export const lang = {
    get: (string, parameters?) => {
        switch (string) {
            // Integrations + Fortnox (Z): translated from Swedish
            case 'INTEG_INTRO': return `Activate and manage add-ons for ${parameters[0]}.`;
            case 'INTEG_CONNECTED_TO': return `Connected to ${parameters[0]}`;
            case 'INTEG_CONNECTED_TO_AUTO': return `Connected to ${parameters[0]} · automatic export on`;
            case 'INTEG_STATUS_FAILED': return `Status could not be loaded (${parameters[0]})`;
            case 'FZ_NOTICE_ORG_MISMATCH': return `Wrong company: the Fortnox account belongs to ${parameters[0]} (${parameters[1]}), but the restaurant belongs to ${parameters[2]}. Nothing was saved.`;
            case 'FZ_NOTICE_DENIED': return `The connection was cancelled in Fortnox: ${parameters[0]}`;
            case 'FZ_NOTICE_ERROR': return `The connection failed: ${parameters[0]}`;
            case 'FZ_CONNECTED_META': return `connected ${parameters[0]} by ${parameters[1]}`;
            case 'FZ_SCOPE_NOTE': return `The connection applies to every restaurant that belongs to ${parameters[0]}. The settings below apply only to ${parameters[1]}.`;
            case 'FZ_ORG_MISMATCH_WARN': return `The restaurant's company in PubQ has org. no. ${parameters[0]} but is connected to ${parameters[1]}.`;
            case 'FZ_REAUTH_WARN': return `The Fortnox connection for ${parameters[0]} has expired and must be approved again.`;
            case 'FZ_ALREADY_CONNECTED': return `The company ${parameters[0]} is already connected – the restaurant is now linked.`;
            case 'FZ_SETTINGS_FOR': return `Settings for ${parameters[0]}`;
            case 'FZ_FROM_Z': return `from Z ${parameters[0]}`;
            case 'FZ_EG': return `e.g. ${parameters[0]}`;
            case 'FZ_APPROVED_SO_FAR': return `${parameters[0]} booked so far`;
            case 'FZ_PREVIEW_TITLE': return `Voucher for Z ${parameters[0]}`;
            case 'FZ_SERIES_X': return `series ${parameters[0]}`;
            case 'FZ_PREVIEW_SUMMARY': return `${parameters[0]} receipts · Z report total ${parameters[1]} kr`;
            case 'FZ_DROPPED': return `${parameters[0]} zero row(s) left out`;
            case 'FZ_RESEND_TITLE': return `Send Z ${parameters[0]} again?`;
            case 'FZ_RESEND_ALREADY': return `Z ${parameters[0]} is already booked.`;
            case 'FZ_RESEND_ALREADY_AS': return `Z ${parameters[0]} is already booked as ${parameters[1]}.`;
            case 'FZ_DISCONNECT_ALL': return `This disconnects Fortnox for every restaurant that belongs to ${parameters[0]}.`;
            case 'FZ_TOAST_SENT': return `Z ${parameters[0]} booked`;
            case 'FZ_TOAST_SENT_AS': return `Z ${parameters[0]} booked as ${parameters[1]}`;
            case 'FZ_TOAST_NOT_SENT': return `Z ${parameters[0]} was not sent`;
            case 'FZ_BACKFILL_RESULT': return `Sent past: ${parameters[0]} booked, ${parameters[1]} not`;
            case 'FZ_BACKFILL_STOPPED': return `Stopped at Z ${parameters[0]}: ${parameters[1]}`;
            case 'FZ_ERR_SECTION_TIMEOUT': return `The Fortnox service did not answer within ${parameters[0]} s`;
            case 'FZ_ERR_SIGNIN_TIMEOUT': return `Sign-in did not answer within ${parameters[0]} s`;
            case 'FZ_CUST_REFRESHED': return `Refreshed from Fortnox: ${parameters[0]} field(s) changed.`;
            case 'CARD_ADDED_FOR':
                return `Card created at ${parameters[0]}`;
            case 'REMOVE_NAME':
                return `Remove ${parameters[0]}?`;
            case 'REMOVED_IMAGE':
                return `Removed ${parameters}`;
            case 'PRODUCTS_UPDATED':
                return `${parameters[0]} products updated`;
            case 'UPDATING_PRODUCTS_PROGRESS':
                return `Updating products ${parameters[0]} of ${parameters[1]}`;
            case 'SAVING_MENU':
                return `Saving menu for ${parameters[0]}`;
            case 'REMOVE_MENU':
                return `Remove ${parameters[0]}?`;
            case 'SAVING_GALLERY':
                return `Saving gallery for ${parameters[0]}`;
            case 'REMOVED_IMAGE':
                return `Removed ${parameters[0]}`;
            case 'NUMBER_ARTICLES':
                return `${parameters[0]} articles`;
            case 'UPDATE_ITEM':
                return `Updated ${parameters[0]}`;
            case 'PRODUCT_ADDED':
                return `${parameters[0]} added`;
            case 'PRODUCT_REMOVED':
                return `${parameters[0]} removed`;
            case 'REMOVE_PRODUCT_CATEGORY':
                return `Are you sure you want to remove product category ${parameters[0]}?`;
            case 'REMOVE_BONG_CATEGORY':
                return `Are you sure you want to remove bong category ${parameters[0]}?`;
            case 'SHARE_NEWS_WITH':
                return `Share news with ${parameters[0]}?`;
            case 'NEWS_SHARED':
                return `Shared ${parameters[0]}`;
            case 'TIMELINE_SAVED_FOR':
                return `Saving timeline for ${parameters[0]}`;
            case 'SHARING_OFFER_WITH':
                return `Sharing offer with ${parameters[0]}`;
            case 'OFFER_SHARED':
                return `Spiltted ${parameters[0]}`;
            case 'REMOVE_COUPON':
                return `Remove ${parameters[0]}?`;
            case 'LINKED_PRODUCT':
                return `Linked ${parameters[0]}`;
            case 'COPY_FROM':
                return `Copy from ${parameters[0]}?`;
            case 'REMOVE':
                return `Remove ${parameters[0]}?`;
            case 'REMOVE_CORPORATE_USER_QUESTION':
                return `Are you sure you want to remove ${parameters[0]}?`;
            case 'REMOVING':
                return `Removed ${parameters[0]}`;
            case 'ADDED':
                return `Added ${parameters[0]}`;
            case 'PRODUCT_SAVED':
                return `${parameters[0]} saved`;
            case 'SAVING_PRODUCT':
                return `Saving product for ${parameters[0]}`;
            case 'CONFIRM_REMOVE_ACCOUNTING':
                return `Are you sure about removing ${parameters[0]}?`;
            case 'SAVED':
                return `Saved ${parameters[0]}`;
            case 'RECEIPTS_AMOUNT':
                return `Totalt: ${parameters[0]} kvitton & ${parameters[1]}`; //translate
            case 'PRINTER_ALREADY_EXISTS':
                return `Printer already exists for ${parameters[0]}`;
            case 'ARE_YOU_SURE_YOU_WANT_TO_MARK_THIS_ORDER_AS':
                return `Are you sure you want to mark this order as ${parameters[0]}?`;
            case 'ARE_YOU_SURE_YOU_WANT_TO_REMOVE': return `Are you sure you want to remove "${parameters[0]}" from "${parameters[1]}"?`;
            case 'ARE_YOU_SURE_YOU_WANT_TO_DELETE': return `Are you sure you want to delete "${parameters[0]}"? This action cannot be undone.`;
            case 'MENU_DEACTIVATED_DETAIL': return `Menu "${parameters[0]}" has been deactivated.`;
            case 'MENU_ACTIVATED_DETAIL': return `Menu "${parameters[0]}" is now active.`;
            case 'CAMPAIGN_MENU_ACTIVATED_DETAIL': return `Campaign menu "${parameters[0]}" is now active.`;
            case 'PRODUCT_REMOVED_FROM_CATEGORY': return `Product "${parameters[0]}" removed from category "${parameters[1]}".`;
            case 'PRODUCT_ADDED_TO_CATEGORY': return `Product "${parameters[0]}" added to category "${parameters[1]}".`;
            case 'ORDER_STATUS_UPDATED': return `Order status updated to "${parameters[0]}".`;
            case 'COLUMNS_SELECTED': return `Columns selected: ${parameters[0]}`;
            case 'ITEM_COMPLETED_DETAIL':
                return `${parameters[0]} marked as completed.`;
            case 'FOOD_ITEMS_COMPLETED_DETAIL':
                return `${parameters[0]} food items marked completed: ${parameters[1]}`;
            case 'DRINK_ITEMS_COMPLETED_DETAIL':
                return `${parameters[0]} drink items marked completed: ${parameters[1]}`;
            case 'ITEMS_COMPLETED_DETAIL':
                return [
                    parameters[0][0] ? `Food: ${parameters[1]}` : '',
                    parameters[0][1] ? `Drinks: ${parameters[2]}` : ''
                ].filter(Boolean).join('. ');;
            case 'TIMER_STARTED_DETAIL':
                return `Timer started for ${parameters[0]} minute${parameters[1]}.`;
            case 'CATERING_ADDON_MORE_PRODUCTS':
                return `+${parameters[0]} more`;
            case 'CATERING_ADDON_ERR_MAX_EXCEEDS_OPTIONS':
                return `Max selected cannot exceed ${parameters[0]} options.`;
            case 'CATERING_ADDON_ERR_MIN_EXCEEDS_OPTIONS':
                return `Min selected cannot exceed ${parameters[0]} options.`;
            default:
                return '';
        }
    },
    ALCOHOL_STRINGS: [
        'vin',
        'shot',
        'drink',
        'sprit',
        'cognac',
        'öl',
        'cider',
        'whisk',
        'whiskey',
        'whisky',
        'rom',
        'likör',
        'vodka',
        'limoncello',
        'alkoläsk',
    ],
    AMOUNT_MIN_MOBILE_WALLET: 'Minimum transfer amount',
    AMOUNT_1_MOBILE_WALLET: 'Amount 1',
    AMOUNT_2_MOBILE_WALLET: 'Amount 2',
    AMOUNT_3_MOBILE_WALLET: 'Amount 3',
    AMOUNT_4_MOBILE_WALLET: 'Amount 4',
    AMOUNT_5_MOBILE_WALLET: 'Amount 5',
    AMOUNT_6_MOBILE_WALLET: 'Amount 6',
    AMOUNT_7_MOBILE_WALLET: 'Amount 7',
    AMOUNT_8_MOBILE_WALLET: 'Amount 8',
    AMOUNT_9_MOBILE_WALLET: 'Amount 9',
    AMOUNT_10_MOBILE_WALLET: 'Amount 10',
    STRINGS: [
        'Öl',
        'Vin',
        'Alkoholfritt',
        'Mat',
        'Cider',
        'Drink',
        'Sprit',
        'Dricks',
        'Presentkort',
    ],
    DRINK_LIST: ['dricka', 'dryck'],
    WEEL_LIST: ['Sön', 'Mån', 'Tis', 'Ons', 'Tors', 'Fre', 'Lör'],
    CHOSE_PRINTER: 'Choose printer',
    SAVE_AS_PDF: 'Save as PDF',
    MY_ACCOUNT: 'My account',
    USER_ID: 'UserID',
    REMOVE_ACCOUNTING: 'Accounting removed',
    PROFILE: 'Profile',
    ADD_INFO_TO_PROFILE:
        'Add information to your profile so we can better support you on this journey.',
    PLEASE_ENTER_ADDRESS: 'Please enter your Address',
    FIRST_NAME: 'First name',
    LAST_NAME: 'Last name',
    POSTCODE: 'PostCode',
    CITY: 'City',
    COUNTRY: 'Country',
    NEXT_STEP: 'Next Step',

    ORGANIZATION: 'Organization',
    ENTER_ORG_INFO: 'Enter your organization information.',
    ENTER_COMPANY_NAME: 'Please enter a company name',
    VALIDATE: 'VALIDATE',
    VALIDATING: 'VALIDATING',
    VALIDATED: 'VALIDATED',
    PREVIOUS: 'Previous',

    REVIEW_DETAILS_SUBMIT: 'Review your Details and Submit',
    WIZARD3_TEXT1:
        'Now we are almoste through the registration part, double check your information below.',
    WIZARD3_TEXT2: 'Then you can start exploring the PubQ platform.',
    WIZARD3_TEXT3: 'A new company will be created with the name',

    FREE_REGISTER: 'Free registration to get started',
    STEP: 'Step',

    SIGNUP: 'Sign Up',
    CREATE_ACC_DETAILS: 'Enter your details to create your account',
    FULLNAME: 'Full Name',
    IS_REQUIRED: 'is required',
    CONFIRM_PASSWORD: 'Confirm Password',
    REGISTER: 'Submit',
    LOG_OUT: 'Log out',
    HANDLE_PERSONNELCARD: 'Get staffcard',
    CREATE_NEW_CARD: 'Create new card',
    PERSONNELCARD: 'Staffcard',
    NAME: 'Name',
    TEXT_ON_CARD: 'Text on card',
    AVAILABLE_THROUGH: 'Valid until',
    URL_TO_BACKGROUND: 'URL for background',
    REMOVE: 'Remove',
    SAVE: 'Save',
    SEARCH: 'Search',
    SEARCH_IMAGE: 'Search image...',
    SEARCH_VIDEO: 'Search video...',
    USER_WITH_CARD: 'Users with card',
    ID: 'ID',
    CARD: 'Card',
    JANUARY: 'January',
    FEBRUARY: 'February',
    MARS: 'March',
    APRIL: 'April',
    MAY: 'May',
    JUNE: 'June',
    JULY: 'July',
    AUGUST: 'August',
    SEPTEMBER: 'September',
    OCTOBER: 'October',
    NOVEMBER: 'November',
    DECEMBER: 'December',
    JAN3: 'Jan',
    FEB3: 'Feb',
    MAR3: 'Mar',
    APR3: 'Apr',
    MAY3: 'May',
    JUN3: 'Jun',
    JUL3: 'Jul',
    AUG3: 'Aug',
    SEP3: 'Sep',
    OCT3: 'Oct',
    NOV3: 'Nov',
    DEC3: 'Dec',
    OK: 'OK',
    AUTHORIZED_USERS: 'Authorized users',
    ADD_NEW_USER: 'Add new user',
    NO_AUTHORIZED_USERS: 'No authorized users yet.',
    ENTER_USER_NAME: 'Enter user name',
    ENTER_USER_EMAIL: 'Enter user email',
    CORPORATE_USER_INVITED: 'Authorized user invited.',
    RESEND_INVITATION: 'Resend invitation',
    CORPORATE_USER_INVITATION_RESENT: 'Invitation resent.',
    CORPORATE_USER_INVITATION_RESEND_FAILED: 'Failed to resend invitation.',
    CORPORATE_USER_ALREADY_LINKED: 'This user is already linked to this corporate customer for this location.',
    CORPORATE_USER_REMOVED: 'Authorized user removed.',
    CORPORATE_USER_REMOVE_FAILED: 'Failed to remove authorized user.',
    FAILED_TO_LOAD_AUTHORIZED_USERS: 'Failed to load authorized users.',
    EMAIL_ADDRESS: 'Email address',
    EMAIL_ADDRESS_DESCRIPTION:
        'To which email address should the report be sent?',
    ENTER_NAME: 'Please enter your name.',
    NAME_REQUIRED: 'Name is required.',
    USERNAME: 'USERNAME',
    DATE: 'DATE',
    DATE_FOR_PUSH: 'Date',
    ORDER_NAME: 'ORDER NAME',
    TOTAL_ITEMS: 'TOTAL ITEMS',
    ADDRESS: 'Address',
    ACTIONS: 'ACTIONS',
    PLACE_ORDER: 'Place Order',
    CANCEL: 'Cancel',
    SCHEDULE_VIEW: 'Schedule View',
    SORTED_ON_PRODUCT: 'Sort by product',
    DAY: 'Day',
    TOTAL: 'Total',
    ORDERS_TODAY: 'Orders today',
    ORDERS_THIS_MONTH: 'Orders this mount',
    ACTIVITY: 'Activity',
    COUPONS_IN_APP: 'Coupons used in app',
    PER_PRODUCT: 'Per product',
    USERS_WITH_CODES: 'Users with discount codes',
    RECEIPTNO: 'Reciept no.',
    TIME: 'Time',
    CODE: 'Code',
    ORDERCODE: 'Order code',
    NAVIGATE_HERE: 'Navigate to here or use menu in upper left corner',
    UPLOADING: 'Uploading',
    SELECT_RESTAURANTS: 'Select restaurants',
    UPLOAD: 'Upload…',
    UPLOAD_IMAGE: 'Upload image',
    SHARE_GALLERY: 'Share gallery',
    SHARE_IMAGE: 'Share image',
    GALLERY: 'Gallery',
    GALLERY_IMAGE_LOAD_FAILED: 'The image could not be loaded',
    GALLERY_RETRY: 'Try again',
    GALLERY_SHOW_MORE: 'Show more',
    GALLERY_IMAGE_REMOVED: 'Image removed',
    GALLERY_VIDEO_REMOVED: 'Video removed',
    ARE_YOU_SURE: 'Are you sure?',
    DELETE_IMAGE: 'Delete image',
    ARE_YOU_SURE_GALLERY:
        'Are you sure you want to delete the image from your gallery?',
    UPDATING_IMAGE_QUICK: "Wait… we're updating your picture shortly",
    IMAGE_SHARED: 'Image shared',
    SYNC_PRODUCTS: 'Synchronize products',
    CLEAR_EXISTING_PROUCTS: 'Cleanup existing products?',
    UPDATING_PRODUCTS: 'Updating products',
    SAVING_OPTION_GROUP: 'Saving addon group…',
    OPT_GROUP_SAVE_FAILED: 'Failed to save addon group.',
    PRODUCT_PAGE_VERIFY: 'Go to product page to verify',
    FROM: 'From',
    TO: 'To',
    ORDERVALUE_COUPON: 'Order value with coupon code',
    SUM_RECEPITS_COUPON: 'Sum of reciepts where guest used coupon code',
    CODE_CAPS: 'CODE',
    DISCOUNT_CAPS: 'DISCOUNT',
    NETTO_CAPS: 'NET',
    VAT_CAPS: 'VAT',
    TOTAL_CAPS: 'TOTAL',
    TODAY_CAPS: 'TODAY',
    CLOSE_CAPS: 'CLOSE',
    CREATE_NEW_GROUP: 'Create new',
    PRODUCT_LIST_DESCRIPTION: 'Manage, update, and organize your products',
    RESET_FORTNOX: 'Reset Fortnox-connection',
    RESET_FORTNOX_TEXT:
        'Are you sure that you want to remove Fortnox connection and reset to create a new connection?',
    NO: 'No',
    YES: 'Yes',
    AUTHORIZATIONCODE: 'Authorization code',
    AUTHORIZED: 'AUTHORIZED',
    VOUCHER_SERIES: 'Verification serie',
    ROUNDING_ACCOUNT: 'Account for penny reconciliation',
    ACTIVATE: 'Activate',
    INTEGRATIONS: 'integration',
    PASSWORD: 'Password',
    FORWARD: 'Continue',
    FORGOT_PASSWORD: 'Forgot your password?',
    RESET_EMAIL_HEAD: 'Email for reset',
    RESET_EMAIL_TXT: 'Fill in your email address',
    NEW_MENU: 'New menu',
    CREATE_NEW_MENU: 'Create new menu',
    COPY: 'Copy',
    SURE: 'Are you sure?',
    MENU_SHARED: 'Menu shared',
    SOMETHING_WRONG: 'Something went wrong!',
    THIS_MENU_ACTIVE: 'This menu is active',
    DELETE_MENU: 'Delete menu',
    ACTIVATE_BEFORE_REMOVE: 'You must activate another menu before remove this',
    REMOVE_FOR_ALL: 'Remove for all?',
    REMOVE_EVEN_OTHERS:
        'Do you want to remove post even if existing in other restaurants?',
    REMOVED_FROM_ALL: 'Removed from all restaurants ',
    MONDAY: 'Monday',
    TUESDAY: 'Tuesday',
    WEDNESDAY: 'Wednesday',
    THURSDAY: 'Thursday',
    FRIDAY: 'Friday',
    SATURDAY: 'Saturday',
    SUNDAY: 'Sunday',
    FAILED: 'Failed',
    SAVED: 'Saved!',
    MENUS: 'Menus',
    VISIBLE_IN_APP: 'Visible in app',
    WEEKLY_MENU: 'Weekly menu',
    WEEKLY_MENU_PLANNER: 'Weekly Menu Planner',
    WEEKLY_MENU_PLANNER_DESCRIPTION: 'Build a weekly product schedule from Monday to Sunday.',
    GLOBAL_SETTINGS: 'Pre-order limits',
    WEEKLY_MENU_GLOBAL_SETTINGS_DESCRIPTION: 'Choose how many days in advance guests can order.',
    ORDER_DAYS_IN_ADVANCE: 'Customers can order this many days in advance',
    DAY_SETTINGS: 'Day Settings',
    SEARCH_PRODUCTS: 'Search products',
    SEARCH_PRODUCT_REGISTER: 'Search product register',
    WEEKLY_MENU_PRODUCT: 'Weekly menu product',
    WEEKLY_MENU_PRODUCT_HINT: 'Show this product in the weekly menu product register.',
    WEEKLY_MENU_PRICE_HELP: 'Optional: leave a field empty to use the base price for that serving method.',
    WEEKLY_MENU_AVAILABLE_THIS_DAY: 'Available on this day',
    WEEKLY_MENU_PRODUCT_ENABLED_EVERYWHERE_HINT: 'When off, this product is hidden everywhere it is used, not only on this weekday.',
    CLOSED_FOR_ORDERING: 'Closed for ordering',
    OPEN_FOR_ORDERING: 'Open for ordering',
    ORDER_CUTOFF_TIME: 'Order Cutoff Time',
    AVAILABLE_FROM: 'Available From',
    AVAILABLE_UNTIL: 'Available Until',
    ORDERS_MUST_BE_PLACED_BEFORE_THIS_TIME: 'Orders must be placed before this time.',
    SAVE_SETTINGS: 'Save Settings',
    GLOBAL_SETTINGS_SAVED: 'Global settings saved',
    SETTINGS_SAVED: 'Settings saved',
    SHOW_BUTTON:
        "Show the button Weekly menu on apps startpage. Update the text every week so user can see what's served",
    UPLOAD_PROGRESS: 'Uploading',
    GALLERY_SHARED: 'Shared gallery!',
    USE_IMAGE: 'Use picture',
    USE_VIDEO: 'Use video',
    PREVIEW_VIDEO: 'Preview video',
    DELETE_VIDEO: 'Delete video',
    UPDATING_IMAGE: "Wait… we're updating your picture shortly",
    UPDATING: 'Updating',
    COMPRESSING: 'Compressing',
    HELP: 'Help',
    IN_STOCK: 'On stock',
    OUT_OF_STOCK: 'Out of stock',
    STOCK_BALANCE_ERROR: 'Stock balance must be greater than 0',
    FEW_LEFT_IN_STOCK: 'Few left in stock',
    CATEGORIES: 'Categories',
    MISCELLANEOUS: 'Miscellaneous',
    PRODUCT_IMAGE: 'Product image',
    SELECT_FILE: 'Select file',
    FOOD: 'Food',
    ALL: 'All',
    ALL_ORDERS: 'All orders',
    DRINKS: 'Drinks',
    PRODUCTS: 'Products',
    ADD: 'Add',
    AUTOCOMPLETE: 'Autocomplete',
    SHOW_ON_KDS: 'Show on KDS',
    CATEGORY_ACTIONS: 'Category actions',
    MENUS_TEXT: 'Manage your menus – create or edit',
    KDS_AND_PRINTER: 'KDS & printer',
    COOKINGTIME_MINUTES: 'Cooking time in minutes',
    PRINTED_ON: 'Printed on',
    DELETE_SUBCATEGORY: 'Delete subcategory',
    SET_LOCATIONS: 'Set locations',
    RESET_PASSWORD: 'Reset password',
    DISCARD_ALL_CHANGES: 'Discard all changes',
    DISCARD_ALL_CHANGES_QUESTION:
        'Are you sure you want to cancel and discard all your changes?',
    ENTER_EMAIL_TO_RESET: 'Enter email to reset the password for the user',
    PUBLISH_NEWS_TEXT: 'Publish news in the app and keep your users informed',
    AUTO_ROTATE_NEWS: 'Auto rotate news',
    ORDERS_AND_RECEIPTS: 'Track orders and handle guest receipts',
    DO_YOU_WANT_TO_REMOVE: 'Do you want to remove',
    DELETE_ADDON_QUESTION: 'Are you sure you want to remove addon group',
    NO_FEATURED_PRODUCTS: 'There are no featured products',
    ADDON_GROUPS_TEXT: 'Create addon groups and link them to your products',
    ORDER_PRINTING_TEXT: 'Configure order handling by bong category',
    REMOVE_USER_QUESTION:
        'Do you want to remove this user from the team for this unit?',
    REMOVE_USER: 'Remove User',
    UPDATE: 'Update',
    CONFIRM: 'Confirm',
    ADD_NEW_OFFER: 'Add new offer',
    ADD_NEW_COUPON_CODE: 'Add new code',
    SELECT_LOCATION: 'Select location...',
    PRODUCT_CATEGORIES: 'Product categories',
    BONG_CATEGORIES: 'Bong categories',
    NEW_PRODUCT_CATEGORY: 'New product category',
    REMOVE_CATEGORY: 'Remove category',
    REMOVE_PRODUCT_CATEGORY: 'Are you sure you want to remove category',
    EDIT_PRODUCT_CATEGORY: 'Edit product category',
    MENU_ACTIVATED: 'Menu activated',
    MENU_TIMES_UPDATED: 'Menu times updated',
    MENU_SCHEDULE: 'Menu schedule',
    MENU_SCHEDULE_ACTIVATED: 'Menu schedule activated',
    SERVING_OPTIONS_UPDATED: 'Delivery options updated',
    DELIVERY_TO_FIXED_LOCATIONS: 'Delivery to fixed locations',
    UPDATED_SUCCESSFULLY: 'Updated successfully',
    NEW_BONG_CATEGORY: 'New bong category',
    REMOVE_BONG_CATEGORY: 'Remove bong category?',
    EDIT_BONG_CATEGORY: 'Edit bong category',
    COURSE: 'Course',
    COURSE_NAME_1: 'Starter',
    COURSE_NAME_2: 'Main course',
    COURSE_NAME_3: 'Dessert',
    NO_COURSE: 'No course',
    NO_COURSE_DIRECT: 'No course (sent at once)',
    COURSE_HINT: 'The till puts items in this bong category into the chosen course. No course: sent to the kitchen at once.',
    TIMELINE: 'Timeline',
    NEW_POST: 'New post',
    SHARE: 'Share',
    CHOOSE_IMAGE: 'Choose image',
    ADD_IMAGE: 'Add image',
    CHANGE_IMAGE: 'Change image',
    TITLE: 'Title',
    TEXT: 'Text',
    OFFER: 'Offer',
    PRODUCT: 'Product',
    URL: 'URL',
    STATIC: 'Static',
    APP_TAB: 'Tab i the app that product is under',
    OFFER_INFO: 'Info about offer',
    WARNING: 'Warning',
    CONFIRMATION: 'Confirmation',
    NONE: 'None',
    REMOVE_SPECIFIC_PRICE: 'Remove specific price',
    NO_LOWER_PRICE: 'The takeaway or eat-in price cannot be 0. Please set a higher price or remove the field.',
    ALREADY_EDITING:
        'You are already editing another post. Are you sure that you want to discard data?',
    ABORT_Q: 'Cancel?',
    CONFIRM_CHANGES:
        'Are you sure that you want to cancel? Changes will be lost.',
    REMOVE_ON_SEVERAL_UNITS:
        'Do you want to delete the product on more of your units?',
    PRODUCT_DELETED_ON_MENUS: 'Product deleted on menus',
    PRODUCT_DELETED: 'Product deleted',
    PRODUCT_REMOVED: 'Product removed',
    MENU_UPDATED: 'Menu updated!',
    DELETE_PRODUCT: 'Delete product',
    ARE_YOU_SURE_DELETE_PRODUCT:
        'Are you sure you want to delete this product?',
    ARE_YOU_SURE_DELETE_SELECTED_PRODUCTS:
        'Are you sure you want to delete the selected products?',
    FILL_ALL_FIELDS: 'You must fill out all fields besides title and text',
    SAVE_NEWS: 'Saving news',
    MAIN_TEXT: 'Main text',
    NEW_TITLE: 'New title',
    REMOVE_POST: 'Remove post?',
    REMOVE_POST_CONFIRM: 'Are you sure that you want to remove post?',
    REMOVE_FOR_OTHERS:
        'Do you want to remove post even if existing in other restaurants?',
    TIMELINE_SHARED: 'Shared timeline!',
    TYPE: 'Type',
    SERVING_METHOD: 'Serving method',
    APPLIES_FOR: 'Valid for',
    PRODUCT_TYPES: 'Product types',
    DISCOUNT_PERCENTAGE: 'Percentage discount',
    AUTOMATIC_ACTIVATION: 'Automatically applied in app for user',
    AUTOMATIC_ACTIVATION_HINT: 'When enabled, this offer is activated for the user without any action required.',
    CREATING_OFFER: 'Create offer',
    OFFER_CREATED: 'Offer created!',
    UPDATING_OFFER: 'Updating offer',
    OFFER_UPDATED: 'Updated offer',
    REMOVING: 'Removing',
    OFFER_REMOVED: 'Removed offer',
    NEW_BUTTON: 'New button ',
    CREATE_NEW_BUTTON: 'Create new button',
    CONNECT_BUTTON: 'Connect the button to?',
    CHOOSE_BG_IMAGE: 'Choose background picture',
    BUTTON_LAYER: 'Button stock',
    FREE_TEXT: 'Free text',
    ACTIVATE_IN_POS: 'ACTIVATE IN CASH REGISTER',
    ALLERGY_INFO_SAVED: 'Info about allergens saved and visible in app',
    MINIMUM_BONUS_SAVED: 'Minimum bonus saved',
    MINIMUM_FEE: 'Minimum fee',
    ADD_FEE: 'Add fee',
    MINIMUM_FEE_OPTIONAL: 'Minimum fee (optional)',
    PAYMENT_OPTIONS_SAVED: 'Alternativ payment saved',
    SERVING_OPTIONS_SAVED: 'Serving options saved',
    DELIVERY_SET_LOCATIONS: 'Set locations',
    NOTIFICATION_SAVED: 'Notice saved',
    INSTAGRAM_SAVED: ' Instagram saved',
    FACEBOOK_SAVED: ' Facebook saved',
    MENU_STYLE_SAVED: 'Menu layout saved',
    FOOD_SETTINGS_SAVED: 'Food settings saved',
    DRINK_SETTINGS_SAVED: 'Drinks setting saved',
    DISCOUNT_SETTINGS_SAVED: 'Discount settings saved',
    COUPON_NAME: 'Name of coupon',
    COUPON_CODE: 'Coupon code',
    ADD_DISCOUNT_CODE: 'Add coupon code',
    PERCENTAGE_IN_DISOUNT: 'Discount by percent',
    TAKEAWAY: 'Takeaway',
    TABLE_SERVING: 'Table service',
    ACTION: 'Action',
    ARTICLE: 'Article',
    ARTICLE_TEXT: 'Article text',
    SEARCH_USERGROUP: 'Search group',
    COLLECT_IN_BAR: 'Pickup at bar',
    DELIVERY: 'Delivery',
    MESSAGE_WHEN_TAB_CLOSED: 'Message to customer when this tab is closed',
    SENDING_PUSH: 'Sending push notification',
    SHOW_YAMMER: 'Show Yammer icon on start page',
    SHOW_TIKTOK: 'Show TikTok icon on start page',
    PUSH_SENT: 'Push notification sent!',
    GENERAL: 'Generally',
    CURRENCY: 'Currency',
    INVOICE: 'Invoice',
    ALLOW_USER_TO_ADD_ORGANIZATION_IN_APP:
        'Allow users to join organization in app',
    GENERAL_SETTINGS: 'General settings',
    ADD_PRICE: 'Add price',
    SUBCATEGORY: 'Subcategory',
    GENERATE_REPORT: 'Generate report',
    PUSH_NOTIFICATIONS: 'Push notification',
    SHORTCUTS: 'Shortcuts',
    MANAGE_GENERAL_SETTINGS: 'Manage the unit’s general settings',
    APP_SETTINGS: 'App settings',
    OFFERS: 'Offers',
    STAMP_CARDS: 'Stamp cards',
    ADD_NEW_STAMP_CARD: 'Create new',
    STAMPS_REQUIRED: 'Stamps required',
    REWARD: 'Reward',
    NO_STAMP_CARDS: 'No stamp cards. Add one to get started.',
    CREATE_STAMP_CARD: 'Create stamp card',
    EDIT_STAMP_CARD: 'Edit stamp card',
    IMPORT: 'Import',
    IMPORT_STAMP_CARD: 'Import stamp card',
    IMPORT_STAMP_CARD_DESCRIPTION: 'Import stamp cards from other units in your loyalty group, allowing guests to collect and redeem stamps across all connected units.',
    NO_STAMP_CARDS_TO_IMPORT: 'No stamp cards available to import from your loyalty group.',
    STAMP_CARD_IMPORTED: 'Stamp card imported successfully',
    FAILED_TO_IMPORT: 'Failed to import stamp card',
    STAMP_CARD_NAME: 'Stamp card name',
    STAMP_CARD_DESCRIPTION: 'Description',
    STAMP_CARD_DESCRIPTION_PLACEHOLDER: 'E.g. Buy 10 lunches and get your 11th for free.',
    HOW_IT_WORKS: 'How it works',
    HOW_IT_WORKS_PLACEHOLDER: 'Optional rules or instructions shown in the app',
    STAMPS_REQUIRED_FOR_FULL_CARD: 'Stamps required for full card',
    REWARD_TYPE: 'Reward type',
    FULL_DISCOUNT: '100% off',
    HALF_DISCOUNT: '50% off',
    SALES_CHANNELS: 'Sales channels',
    CHANNEL_APP: 'App',
    CHANNEL_KIOSK: 'Kiosk',
    CHANNEL_POS: 'POS',
    CHANNEL_WEB: 'Web',
    CUSTOMER_VISIBILITY: 'Customer visibility',
    ALL_CUSTOMERS: 'All customers',
    LOGGED_IN_USERS_ONLY: 'Logged-in users only',
    DELETE_STAMP_CARD: 'Delete stamp card',
    DELETE_STAMP_CARD_CONFIRM:
        'Delete this stamp card?\n\nAll stamps, user progress, and logs for this card will be permanently removed for everyone.\n\nIf you want to keep history and only stop the card from being used, deactivate it (set the card inactive) instead of deleting.',
    STAMP_CARD_DELIVERY_METHODS: 'Delivery methods',
    STAMP_CARD_DELIVERY_METHODS_HINT: 'All methods are allowed by default; uncheck to restrict which delivery methods can earn and use stamps.',
    STAMP_CARD_DM_EAT_IN: 'Eat in',
    STAMP_CARD_DM_TAKEAWAY: 'Take away',
    STAMP_CARD_DM_DELIVER_TO_WORKPLACE: 'Deliver to workplace',
    STAMP_CARD_DM_DELIVERY: 'Delivery',
    STAMP_CARD_DM_TABLE_SERVING: 'Table serving',
    REWARD_ELIGIBLE: 'Reward',
    STAMP_CARD_SEPARATE_REWARD_ITEMS: 'Specify separate reward items',
    STAMP_CARD_SEPARATE_REWARD_ITEMS_HINT: 'Enable this if the reward should apply to other products than the ones that earn stamps.',
    SC_USERS_CARD_RECORDS: 'Card Records',
    SC_USERS_READY_TO_REDEEM: 'Ready to Redeem',
    SC_USERS_AVG_STAMPS: 'Avg Stamps per Card',
    SC_USERS_SEARCH_PLACEHOLDER: 'Search by user name, user ID or card...',
    SC_USERS_NO_RECORDS: 'No user records found.',
    SC_DEACTIVATED_BY_ADMIN: 'Deactivated by admin',
    SC_DEACTIVATED: 'Deactivated',
    SC_CARD_ACTIVE: 'Card Active',
    SC_CARD_INACTIVE: 'Card Inactive',
    SC_USER_DEACTIVATED: 'User Deactivated',
    SC_USER_ACTIVE: 'User Active',
    SC_DEACTIVATED_BANNER: 'This card is deactivated for this user — stamps are preserved but redemption is blocked until reactivated.',
    SC_STAMP_PROGRESS: 'Stamp Progress',
    SC_LAST_STAMP: 'Last stamp',
    SC_LAST_REDEEMED: 'Last redeemed',
    SC_LAST_USED_DATE: 'Date of last activity',
    SC_CARD_NAME: 'Card Name',
    SC_CARD_ID: 'Card ID',
    SC_ADD_STAMP: 'Add Stamp',
    SC_REMOVE_STAMP: 'Remove Stamp',
    SC_NO_STAMPS_TO_REMOVE: 'No stamps to remove',
    SC_MAX_STAMPS_REACHED: 'Maximum stamps reached – mark as redeemed',
    SC_NOT_READY_TO_REDEEM: 'Card is not ready to redeem yet',
    SC_MARK_REDEEMED: 'Mark Redeemed',
    SC_DEACTIVATE: 'Deactivate',
    SC_REACTIVATE: 'Reactivate',
    SC_LOADING_HISTORY: 'Loading history…',
    SC_NO_HISTORY: 'No activity recorded yet.',
    SC_LOG_STAMP_ADDED: 'Stamp Collected',
    SC_LOG_REDEEMED: 'Redeemed',
    SC_LOG_ADMIN_STAMP_ADDED: 'Admin: Stamp Added',
    SC_LOG_ADMIN_STAMP_REMOVED: 'Admin: Stamp Removed',
    SC_LOG_ADMIN_REDEEMED: 'Admin: Marked as Redeemed',
    SC_LOG_ADMIN_DEACTIVATED: 'Admin: Card Deactivated',
    SC_LOG_ADMIN_REACTIVATED: 'Admin: Card Reactivated',
    SC_STAMP: 'stamp',
    SC_STAMPS: 'stamps',
    SC_REFRESH: 'Refresh',
    SC_USER_COL: 'User',
    SC_STAMP_CARD_COL: 'Stamp Card',
    SC_STAMPS_COL: 'Stamps',
    SC_PROGRESS_COL: 'Progress',
    SC_NOT_READY: 'Not Ready',
    SC_ALL_CARDS: 'All Cards',
    SC_STAMP_CARD_DETAILS: 'Stamp Card Details',
    SC_FAILED_LOAD_PROGRESS: 'Failed to load user progress',
    ADD_ROUTE: 'Add route',
    LOADING_ROUTES: 'Loading routes...',
    EXPIRATION: 'Expiration',
    OFFER_TITLE: 'Offer title',
    RESTAURANT_ID: 'Restaurant ID',
    SERVING_OPTIONS: 'Serving options',
    PAYMENT_OPTIONS: 'Payment options',
    MANUALLY_TOGGLE_TEXT:
        'Switch sales on or off manually in the app, web orders, and express checkout',
    USE_SAVE_BUTTON:
        'Changes on this page affects mobileapp and the Save button must be used to submit changes',
    OPEN_FOR_SALE: 'Open for sales',
    MESSAGE_WHEN_CLOSED: 'Notification to customer when tab is closed',
    FOOD_TAB: 'Food sales',
    DRINK_TAB: 'Drinks sales',
    NOTIFICATION_IN_APP: 'Notification banner in app',
    NOTIFICATION_EXPLANATION:
        'The banner with your message will appear on the start page of the app',
    SHOW_NOTIFICATION: 'Show notification',
    NOTIFICATION_TEXT: 'Text for notification',
    ALLERGY_INFO: 'Allergen info',
    ALLERGEN_INFO_DESCRIPTION: 'Publish your allergen information in the app',
    PHONE_NUMBER: 'Phone number',
    OPENING: 'Open at',
    OPENING_HOURS: 'Opening hours',
    CLOSING: 'Closing at',
    TAKEAWAY_EAT_HERE: 'Takeaway & eat here',
    SHOW_FACEBOOK: 'Show Facebook icon on startpage',
    INSTAGRAM: 'Instagram',
    SHOW_INSTAGRAM: 'Show Instagram icon on startpage',
    WHICH_ACTIVE: 'Which are to be activated in the app?',
    ACTIVATED: 'Activated',
    DEACTIVATED: 'Deactivated',
    SUBCATEGORY_DELETED: 'Subcategory deleted',
    MENU_NAME_UPDATED: 'Menu name updated',
    SUBCATEGORY_UPDATED: 'Subcategory updated.',
    SWISH: 'Swish',
    SWISH_NUMBER: 'Swish number',
    VIPPS: 'Vipps',
    TAB: 'Table ticket',
    TABLENUMBER_FROM: 'From table number',
    TABLENUMBER_TO: 'To table number',
    AREA_1: 'Area 1',
    AREA_2: 'Area 2',
    AREA_3: 'Area 3',
    AREA_4: 'Area 4',
    DELIVERY_RADIUS: 'Delivery radius in meters',
    DELIVERY_RADIUS_COST: 'Price for delivery',
    SERVING_OPTIONS_MENU: 'Select delivery options for menu',
    SERVING_OPTIONS_MENU_EXPLANATION:
        'When this menu is live in the app these delivery options will be available',
    FOOD_OPEN: 'Food open',
    FOOD_CLOSED: 'Food closed',
    DRINK_OPEN: 'Drink open',
    DRINK_CLOSED: 'Drink closed',
    BONUSSYSTEM: 'Bonus system',
    LEAST_AMOUNT_BONUS:
        'Least number of points to be able to purchase with points',
    ACTIVE_OR_DEACTIVE_BONUS_SYSTEM: 'Activate or deactivate bonus system',
    ACTIVE_OR_DEACTIVE_MAX_BONUS_POINTS:
        'Activate or deactivate maximum bonus points',
    MAXIMUM_AMOUNT_BONUS:
        'Maximum number of points that can be purchased with points',
    OPEN_CLOSE_AUTOMATICALLY: 'Open/close app automatically',
    OPEN_CLOSE_SETTINGS: 'Open/close app for ordering',
    AUTO_OPENING_HOURS_TITLE: 'Automatic opening hours',
    AUTO_OPENING_HOURS_DESCRIPTION:
        'Check this box to have your sales channels open and close automatically according to the opening hours and deviations below. If unchecked, the opening hours are only shown as information.',
    AUTO_OPENING_HOURS_ON:
        'Active – sales channels open and close automatically according to the hours below.',
    AUTO_OPENING_HOURS_OFF:
        'Not active – opening hours are only shown as information in the sales channels and do not control when you open or close.',
    AUTO_OPENING_HOURS_TAG_ON: 'Controls open/close',
    AUTO_OPENING_HOURS_TAG_OFF: 'Information only',
    BANNER_IN_APP: 'Banner in app',
    SOCIAL_MEDIA: 'Social media',
    ALLERGEN_INFORMATION: 'Allergen information',
    GLOBAL_OFFERS: 'Global offers',
    APPLIES_TO_ALL: 'Valid for all in app',
    SELECTED: 'Selected',
    DESELECT: 'Deselect',
    CONFIRM_BULK: 'Confirm',
    ONETIME: 'Single / Disposible????',
    SET_SCHEDULE: 'Set schedule',
    USER_GROUPS: 'User groups',
    ADD_NEW_GROUP: 'Add new group',
    SEARCH_USER_EMAIL_PHONE: 'Search for user by email or phone number',
    ADD_NEW: 'Add new',
    BONUS_SYSTEM: 'Bonus system',
    GROUP_NAME: 'Group name',
    DISCOUNT_CODES: 'Discount codes ',
    ADD_SUBCATEGORY: 'Add subcategory',
    CREATE_MENU_SCHEDULE:
        'Create a time schedule for the menu to automatically go live',
    DISCOUNTPERCENT: 'Discount percentage',
    APPLY_AUTOMATICALLY: 'Apply this code automatically to customers in app',
    APPLY_CODE_AUTOMATICALLY: 'Apply code automatically',
    SINGLE_OFFER: 'One-time offer',
    MULTIPLE_OFFER: 'Multi-use offer',
    SEND_PUSH: 'Push notification',
    SEND_PUSH_TEXT:
        'Push notification immediately goes out to all customers that accepted notifications on this restaurant',
    SEND: 'Send',
    ADD_NEW_USERGROUP: 'New user group',
    ADD_NEW_USERGROUP_LABEL: 'Add new user group name',
    FRANCHISE_ID: 'Franchise ID',
    USER_GROUP_ID: 'User group ID',
    ARE_YOU_SURE_DELETE_OFFER: 'Are you sure you want to delete this offer?',
    DELETE_OFFER: 'Delete offer',
    DELETE: 'Delete',
    PRODUCT_LIST: 'Product list',
    ALTERNATIVES: 'Alternative',
    HEADER_EX: 'Heading (eg. Degree of frying)',
    OPTION_TYPE: 'Type of add-on',
    SEARCH_EMAIL_ORDER_CODE: 'Search by Email or User ID',
    GUEST_INFORMATION: 'Guest information',
    SIGNED_IN: 'Signed in',
    CHECKBOX_OPTION: 'Optional addon',
    NAME_ADDON: 'Addon name',
    MULTIPLE: 'More options',
    NEW_DELIVERY_LOCATION: 'New delivery location',
    DELIVERY_LOCATIONS: 'Delivery locations',
    NO_LOCATIONS_ADDED: 'No locations added yet',
    SELECT_CODE: 'Select code',
    CONFIRM_ADJUSTMENTS: 'Confirm',
    PRICE: 'Price',
    OPTIONS: 'Add-on',
    OPTIONS_NEWS: 'Options',
    COPY_FROM: 'Copy from',
    USING_STEP_BY_STEP: 'Using step-by-step flow',
    HEADER: 'Heading',
    SUBHEADER: 'Subheading',
    LINK_WITH: 'Linked with',
    EDIT_EXCEPTION: 'Change exceptions',
    EDIT_LOCATIONS: 'Edit locations',
    REASON: 'Reason',
    REASON_DETAILS: 'Details of reason',
    ACCOUNTING: 'Accounting',
    SEARCH_PRODUCT: 'Search product',
    DELIVERY_TYPES: 'Delivery types',
    REMOVE_EXCEPTION_CONFIRM: 'Do you want to remove exception?',
    REMOVE_EXCEPTION: 'Remove exception',
    SAVE_WITHOUT_ACCOUNTING:
        'You cannot save product without accounting infomation and product type ',
    REMOVE_PRODUCT_RESTURANTS:
        'Do you want to remove product from more restaurants',
    PRODUCT_SHARED: 'Shared the product!',
    PRODUCT_SAVED: 'Product saved',
    PRODUCT_INFORMATION: 'Product information',
    ADDON_LIST: 'Addon list',
    BASIC_INFO: 'Basic information',
    EDIT_CATEGORY: 'Edit category',
    NO_CRITERIA_ADDED: 'No criteria added for offer',
    ACTIVE: 'Active',
    SEARCH_USER: 'Search user',
    CUSTOMER_INFORMATION: 'Customer information',
    ALLOW_USER_TO_TRANSFER_MONEY_TO_WALLET_IN_APP:
        'Allow users to transfer money',
    ALLOW_USER_TO_TRANSFER_ANY_AMOUNT_TO_MOBILE_WALLET:
        'Allow users to transfer any amount',
    PRODUCT_ACTIVE: 'Product active',
    PRICE_KR: 'Price',
    WEIGHT_BASED_PRODUCT: 'Weight-based product',
    WEIGHT_BASED_HINT: 'Guests select the weight in the app. The price is calculated as weight in grams / 100 × price per 100 g.',
    WEIGHT_BASED_APP_ONLY: 'This product is only available in the app. It cannot be shown in expresskiosk or weborder.',
    PRICE_PER_100G: 'Price per 100 g',
    MIN_WEIGHT_G: 'Minimum weight (g)',
    MAX_WEIGHT_G: 'Maximum weight (g)',
    WEIGHT_STEP_G: 'Weight step (g)',
    PER_100_G: '/ 100 g',
    WEIGHT_CONFIG_INVALID: 'Invalid weight configuration. Min must be at least the step, max must be greater than min, and (max − min) must be divisible by the step.',
    WEIGHT_BASED_INCOMPATIBLE: 'Weight-based pricing cannot be combined with Build-a-Burger or combined products.',
    BONUS_CONVERT:
        'Percentage that converts into bonus points when purchasing this product',
    BONUS_CONVERT_WALLET:
        'Percentage that converts into bonuspoints when refilling mobile wallet',
    NOT_ALLOWED_TO_BY_WITH_BONUS: 'Not allowed to be purchased with bonus',
    DESCRIPTION: 'Description',
    BONUS_POINTS: 'Bonus points',
    TOP_UP: 'Top up',
    PAYMENT: 'Payment',
    BALANCE_ADJUSTED: 'Balance adjusted',
    AMOUNT_EXCEEDS_BALANCE: ' Amount exceeds balance',
    ERROR_FETCHING_TRANSACTIONS: 'Unable to find transactions. Please try again later.',
    SALDO: 'Balance',
    INVALID_DATE_RANGE: "Start date must be before end date.",
    TRANSACTIONS: 'Transactions',
    DESCRIPTION_SHORT: 'Short description',
    DESCRIPTION_LONG: 'Long description',
    CATEGORY_BONG_INFO: 'Category settings',
    LOYALTY: 'Loyalty',
    NAME_ON_BONG: 'Name on ticket (optional)',
    PRODUCT_TYPE: 'Product type',
    PRODUCT_NAME: 'Product name',
    PRODUCT_CATEGORY: 'Product category',
    PRICE_KR_STUDENT: 'Student price',
    PRICE_KR_STUDENT_DEDUCTION: 'Student price deduction',
    BONG_CATEGORY: 'Bong category',
    ACCOUNTING_VAT: 'Accounting and VAT',
    EXCEPTION: 'Exception',
    CONTAINS_ALCOHOL: 'Contains alcohol ',
    AGE_LIMIT: 'Age limit 18+',
    PURCHASE: 'Purchase',
    COST: 'Cost',
    MARGIN: 'Margin',

    TAGS: 'Tags',
    NEW_TAG: 'New tag',
    MOBILE_WALLET: 'Mobile wallet',
    EXTERNAL_ID: 'External ID',
    STOCK_BALANCE: 'Stock balance',
    COUNT: 'Quantity',
    ACOUNTINGS: 'Accountings',
    VAT_RATE: 'VAT rate',
    VAT_RATES: 'VAT rates',
    ACCOUNTING_ACCOUNT: 'Account',
    NO_ACCOUNT: 'No account',
    ACCOUNTING_CREATED: 'Accounting created',
    PAYMENT_TYPES: 'Payment method',
    ACTIVATED_PAYMENT_TYPES: 'Activated payment method',
    ADITIONAL_PAYMENT_TYPES: 'More payment methods',
    NO_PAYMENT_TYPES:
        'has no payment methods activated. Tap More payment methods to activate one',
    ADDED: 'Added',
    PAYMENT_FEES:
        'Some payment methods are associated with fees. Here you may choose accounts for these ',
    VAT: 'VAT',
    HOME: 'Home',
    HOME_DELIVERY: 'Home delivery',
    RESTAURANT: 'Restaurant',
    RESTAURANT_INFORMATION: 'Restaurant information',
    COMPANY_INFORMATION: 'Company information',
    MENU: 'Menu',
    REDEMPTION_AGREEMENT: 'Redemption Agreement',
    MANAGE: 'Manage',
    REPORTS: 'Reports',
    PREPARING_REPORT: 'Preparing report...',
    REPORT_STATUS_QUEUED: 'Queued...',
    REPORT_STATUS_RUNNING: 'Generating report...',
    REPORT_STATUS_DONE: 'Done, fetching the file...',
    REPORT_RUNS_IN_BACKGROUND: 'You can close this dialog - the report keeps running.',
    SCHEDULED_REPORTS: 'Scheduled reports',
    SCHEDULED_REPORTS_DESCRIPTION: 'Reports generated automatically and emailed as CSV attachments.',
    SCHEDULED_REPORTS_NO_ACCESS: 'You do not have access to scheduled reports. Ask a PubQ administrator to add you.',
    SCHEDULED_REPORTS_EMPTY: 'No scheduled reports yet.',
    SCHEDULED_REPORT_ADD: 'New scheduled report',
    SCHEDULED_REPORT_EDIT: 'Edit scheduled report',
    SCHEDULED_REPORT_SECTION_REPORT: 'Report',
    SCHEDULED_REPORT_SECTION_SETTINGS: 'Settings',
    SCHEDULED_REPORT_NAME_PLACEHOLDER: 'e.g. Invoicing basis, twice a month',
    SCHEDULED_REPORT_TYPE: 'Report',
    SCHEDULED_REPORT_TYPE_PLACEHOLDER: 'Choose a report',
    SCHEDULED_REPORT_SCHEDULE: 'Schedule',
    SCHEDULED_REPORT_UNITS: 'Units',
    SCHEDULED_REPORT_UNITS_HINT: 'All selected units must belong to the same franchise.',
    SCHEDULED_REPORT_FRANCHISE: 'Franchise',
    SCHEDULED_REPORT_FRANCHISE_MIXED: 'The selected units belong to different franchises.',
    SCHEDULED_REPORT_FRANCHISE_MISSING: 'Could not find the franchise for the selected units.',
    SCHEDULED_REPORT_RESOLVING_FRANCHISE: 'Looking up the franchise...',
    SCHEDULED_REPORT_RECIPIENTS: 'Recipients',
    SCHEDULED_REPORT_RECIPIENTS_HINT: 'Press Enter or comma after each address. Each recipient gets their own email.',
    SCHEDULED_REPORT_INVALID_EMAIL: 'Not a valid email address',
    SCHEDULED_REPORT_TRIGGERS: 'When to send',
    SCHEDULED_REPORT_TRIGGERS_HINT: 'Each report is sent just after midnight (00:30 Swedish time) following a matching day, covering the chosen period through the end of that day.',
    SCHEDULED_REPORT_ADD_TRIGGER: 'Add report day',
    SCHEDULED_REPORT_PRESET_HALF_MONTH: 'Twice a month (15th and last day)',
    SCHEDULED_REPORT_SEND_ON: 'Report day',
    SCHEDULED_REPORT_SENT_ON: 'sent',
    SCHEDULED_REPORT_COVERING: 'Covering',
    SCHEDULED_REPORT_DAY: 'Day',
    SCHEDULED_REPORT_WEEKDAY: 'Weekday',
    SCHEDULED_REPORT_DAY_OF_MONTH: 'Day of the month',
    SCHEDULED_REPORT_LAST_DAY_OF_MONTH: 'Last day of the month',
    SCHEDULED_REPORT_DAY_OF_WEEK: 'Day of the week',
    SCHEDULED_REPORT_DAILY: 'Every day',
    SCHEDULED_REPORT_EVERY: 'Every',
    SCHEDULED_REPORT_RANGE_FIRST_HALF: '1st to 15th of the month',
    SCHEDULED_REPORT_RANGE_SECOND_HALF: '16th to last day of the month',
    SCHEDULED_REPORT_RANGE_PREVIOUS_MONTH: 'Previous month',
    SCHEDULED_REPORT_RANGE_MONTH_TO_DATE: 'Month to date',
    SCHEDULED_REPORT_RANGE_LAST_7_DAYS: 'Last 7 days',
    SCHEDULED_REPORT_RANGE_CUSTOM: 'Custom (days relative to the report day)',
    SCHEDULED_REPORT_RANGE_CUSTOM_SHORT: 'Days',
    SCHEDULED_REPORT_FROM_DAY: 'From day',
    SCHEDULED_REPORT_TO_DAY: 'To day',
    SCHEDULED_REPORT_TIME_ZONE: 'Time zone',
    SCHEDULED_REPORT_ENABLED: 'Enabled',
    SCHEDULED_REPORT_LAST_RUN: 'Last run',
    SCHEDULED_REPORT_NEXT_RUN: 'Next run',
    SCHEDULED_REPORT_NEXT_RUNS: 'Next',
    SCHEDULED_REPORT_NEVER_RUN: 'Not run yet',
    SCHEDULED_REPORT_STATUS_QUEUED: 'Queued',
    SCHEDULED_REPORT_STATUS_RUNNING: 'Running',
    SCHEDULED_REPORT_STATUS_SENT: 'Sent',
    SCHEDULED_REPORT_STATUS_PARTIAL: 'Partly sent',
    SCHEDULED_REPORT_STATUS_FAILED: 'Failed',
    SCHEDULED_REPORT_STATUS_CANCELLED: 'Cancelled',
    SCHEDULED_REPORT_STATUS_ENQUEUE_FAILED: 'Could not queue',
    SCHEDULED_REPORT_STATUS_INVALID: 'Invalid schedule',
    SCHEDULED_REPORT_SAVED: 'Scheduled report saved',
    SCHEDULED_REPORT_DELETED: 'Scheduled report deleted',
    SCHEDULED_REPORT_DELETE_TITLE: 'Delete scheduled report',
    SCHEDULED_REPORT_DELETE_CONFIRM: 'Delete this scheduled report? No more emails will be sent for it.',
    SCHEDULED_REPORT_SAVE_FAILED: 'Could not save the scheduled report.',
    SCHEDULED_REPORT_DELETE_FAILED: 'Could not delete the scheduled report.',
    SCHEDULED_REPORT_TYPES_FAILED: 'Could not load the report types.',
    SCHEDULED_REPORT_TOGGLE_FAILED: 'Could not change the schedule.',
    SCHEDULED_REPORT_FIX_ERRORS: 'Fix the following before saving:',
    SCHEDULED_REPORT_ERR_REPORT_TYPE: 'Choose a report',
    SCHEDULED_REPORT_ERR_UNITS: 'Choose at least one unit',
    SCHEDULED_REPORT_ERR_PARAM: 'Fill in',
    SCHEDULED_REPORT_ERR_RECIPIENTS: 'Add between 1 and 20 recipients',
    SCHEDULED_REPORT_ERR_TRIGGERS: 'Add between 1 and 10 report days',
    SCHEDULED_REPORT_ERR_CUSTOM_RANGE: 'A custom period must start on or before its end, within 400 days',
    SCHEDULED_REPORT_ERR_DAY: 'Choose a valid day',
    DOWNLOAD_USER_GROUP_REPORT: 'Download report',
    SELECT_DATE: 'Select date',
    WORKING_LATE_MEALS_REPORT: 'Download working late meals report',
    EMPLOYEE_TAG_MEAL_REPORT: 'Download employee tag meal report',
    WALLET_BALANCES_REPORT: 'Download wallet balances report',

    USR_GRP_ORDERS_RPT_TITLE: 'User Group Orders',
    USR_GRP_ORDERS_RPT_DESC: 'Detailed report of orders placed by different user groups.',

    WRK_LATE_MEALS_RPT_TITLE: 'Working Late Meals',
    WRK_LATE_MEALS_RPT_DESC: 'Overview of meals ordered outside regular working hours.',

    EMPLY_TAG_MEAL_RPT_TITLE: 'Employee Meal Tags',
    EMPLY_TAG_MEAL_RPT_DESC: 'Report on employee meal consumption based on tags.',

    WALLET_BAL_RPT_TITLE: 'Wallet Balances',
    WALLET_BAL_RPT_DESC: 'Current balances of user digital wallets.',
    ADMIN: 'Administration',
    NEWS: 'News flow',
    APP: 'App',
    POS: 'TILL',
    ADDON_GROUP_NAME: 'Addon group name',
    VISIBLE_IF_MENU_ACTIVE: 'Visible if menu is active',
    PICK_ONE_OPTION: 'SELECT ONE',
    SINGLE_OPTION: 'OPTIONAL',
    ADD_ADDON: 'Add new addon',
    STAFF_CARD: 'Staff card',
    MISC: 'Misc.',
    PAYMENT_METHOD: 'Payment method',
    PAYMENT_SOURCE: 'Payment source',
    ACCOUNTINGS: 'Accountings',
    SETTINGS: 'Settings',
    X_REPORT_STARTED: 'Started on',
    RESTURANT_INFO: 'Restaurant information',
    USERS: 'Users',
    SEE_ALL: 'See all…',
    STATISTICS: 'Statistics',
    DARK_MODE: 'Dark layout',
    SELECT_UNIT: 'Choose unit',
    SELECT_PRODUCTS: 'Select products',
    OFFER_CONFIGURATION: 'Offer configuration',
    OFFER_DETAILS: 'Offer details',
    OPENING_H_SAVED: 'Opening hours saved',
    OPENING_H: 'Opening hours',
    CLOSED: 'Closed',
    OPENS: 'Opening',
    CLOSES: 'Closing',
    YAMMER_SAVED: 'Yammer saved',
    TIKTOK_SAVED: 'TikTok saved',
    DEVIATIONS: 'Deviations',
    NEW_DEVIATION: 'New deviation',
    DEVIATION_EXAMPLE: 'Eg. Christmas',
    DEVIATION_INCOMPLETE: 'Occasion, start date and end date are required',
    DEVIATION_START_DATE_IN_PAST: 'Start date cannot be before today',
    DEVIATION_END_DATE_IN_PAST: 'End date cannot be before today',
    OVERLAPPING_DEVIATION_DATE_RANGE: 'This date range overlaps another deviation',
    OCCASION: 'Occasion',
    DEVIATION_DATE: 'Date',
    AMOUNT: 'Amount',
    EDITOR: 'Editor',
    SELECT_LOGO: 'Choose logo…',
    ORG_NO: 'Company number',
    ADRESS: 'Address',
    ZIP_CODE: 'Zip code',
    SEARCH_KEYWORD: 'Search keyword',
    CLEAR: 'Clear',
    POST_ADR: 'City',
    PHONE: 'Phone',
    BONUS_TOOLTIP: 'Bonus points can be redeemed on this product',
    CREATE_PRODUCT: 'Create product',
    EXPORT: 'Export',
    INVITE_USER: 'Invite user',
    EMAIL: 'Email',
    ABOUT_US: 'About us',
    ADD_USER: 'Add users',
    ADD_DOMAIN_AUTO:
        'Users with these email domains will automatically join this user group when creating an account',
    JUST_PUBQSE: 'Eg. just pubq.se, not @pubq.se',
    DOMAIN_EXAMPLE: '(eg. only pubq.se, not @pubq.se)',
    SELECT_BONG_CATEGORY: 'Select bong category',
    SELECT_TAGS_CATEGORY: 'Select tags',
    SELECT_ELLIPSES: 'Select...',
    SELECT_PRODUCT_CATEGORY: 'Select product category',
    SELECT_TYPE: 'Select type',
    SELECT_TAGS: 'Select tags',
    OVERVIEW: 'Overview',
    NEW_ORDER: 'New Order',
    PERSONAL_BANK_DETAILS: 'Personal and Bank Details',
    CART_ITEMS: 'Cart Items',
    INACTIVE: 'Inactive',
    LATEST_ORDERS: 'Latest Orders',
    LOAD: 'Load',
    LOGO_AND_IMAGES: 'Logotypes and Images',
    MESSAGE: 'Message',
    FONTS: 'Fonts',
    DANGER: 'Danger',
    SUCCESS: 'Success',
    SECONDARY: 'Secondary',
    BASE: 'Base',
    FIXED_LOCATIONS: 'Fixed locations',
    EAT_IN: 'Eat in',
    TABLE_SERVICE: 'Table service',
    PRIMARY: 'Primary',
    COLORS: 'Colors',
    ENVIRONMENT_IMAGES: 'Click here to change logo, environment images',
    HIDE_ADVANCE_SETTINGS: 'Hide advance settings',
    SHOW_ADVANCE_SETTINGS: 'Show advance settings',
    NEW_THEME: 'New Theme',
    THEME_MAIN_TEXT: 'Change fonts and colors for your storefront',
    SELECTED_PRODUCTS: 'Selected products',
    BACK: 'Back',
    THEMING: 'Theming',
    SAVED_CARDS: 'Saved cards',
    CHOOSE: 'Select...',
    ADD_OPTION: 'Add option',
    ADD_PRODUCTS_TO_GROUP: 'Add products',
    COPY_MENU: 'Copy menu',
    COPY_MENU_CONFIRMATION: 'Are you sure you want to copy menu',
    LINK_ADDON_TO_PRODUCT: 'Link addon to product',
    LINK_TO_PRODUCT_OR_WEBSITE: 'Link to product or website',
    LINK_TO_PRODUCT: 'Link to product',
    TYPE_OF_OFFER: 'Type of offer',
    START_WITH_HTTPS: 'must begin with https://',
    WHERE_IS_PRODUCT: 'Where is the product?',
    OFFER_INFO_PLACEHODLER: 'Info about offer...',
    OPTION_DESCRIPTION: 'Description of offer',
    SELECT: 'Select',
    DISCOUNT_PERCENTAGE_PLACEHOLDER: 'Discount in percent',
    WRITE: 'Write...',
    SEARCH_PRODUCT_OR_TAG: 'Search product or tag',
    STEP_PLACEHOLDER: 'Step for step-by-step product',
    ABOUT_US_PLACEHOLDER: 'About us',
    DOMAIN_EX: 'Domain i.e. pubq.se',
    TIME_CONTROL_MENU: 'Set a schedule for menu',
    SET: 'Set',
    LANGUAGE: 'Language',
    SCHEDULE: 'Schema',
    ANONYMOUS_ACCOUNT: 'Anonymous account',
    INFORMATION: 'Information',
    ACTIVATION_TIME: 'Activation time',
    ACTIVATE_MENU: 'Activate menu',
    STATUS: 'Status',
    PUBLISHED: 'Published',
    UNPUBLISHED: 'Unpublished',
    WEEK: 'Week',
    SELECT_Z_REPORT: 'Select Z-reports',
    FROM_TO: 'From - to',
    PRODUCT_NEED_EXT_ID:
        'You need to fill in an external ID before you can save the product',
    EAT_IN_PRICE_WARNING:
        'Your eat-in price can not be lower than the regular price',
    ACCOUNTING_WARNING:
        'You must put accounting information on the product before it can be saved',
    PRODUCT_TYPE_WARNING:
        'You must select a product type before it can be saved',
    PRODUCT_CATEGORY_WARNING:
        'You must select a product category before it can be saved',
    PRODUCT_BONG_CATEGORY_WARNING:
        'You must select a bong category before it can be saved',
    SEND_END_TO_FORTNOX: 'Send End Of Day to Fortnox?',
    IMPORT_SUCCESSFUL: 'Import succesful',
    IMPORT_FAILED: 'Import failed',
    WHICH_EMAIL: 'Which mail address to send to?',
    SUMD_Z_REPORTS: 'Summed Z-reports',
    Z_REPORT: 'Z-reports',
    MAIL: 'Mail',
    PREVIOUS_MONTH: 'Previous month',
    COMPILATION: 'Compilation',
    JOURNALNR: 'Journal no.',
    CREATED: 'Created',
    RECEIPTNO_FROM_TO: 'Receipt from - to',
    CATEGORY_CREATED: 'Category created',
    SUM: 'Sum',
    INTEGRATIONS_HEADER: 'Integrations',
    BUY_REBUY: 'Buy and rebuy',
    WRONG_HIT: 'Wrong hit',
    CANCELD: 'Cancelled',
    PROFORMA: 'Proforma',
    CANCELED: 'Canceled',
    MOMS: 'VAT',
    PURCHASE_REFUNDS: 'Purchase and refunds',
    SKIPPED_RECEIPT: 'Skipped',
    CREATING_ENDOFDAY: 'Creating End-OF-Day',
    NOT_ENOUGH: "You haven't had sufficient turnover",
    END_OF_DAY_100: 'End-Of-Day needed to contain more than 100.',
    Z_ENDOFDAY: 'End-Of-Day',
    PREL_X_REPORT: 'Preliminary X-report',
    PAID: 'Paid',
    SUM_PAYMENTS: 'Sum of payments',
    CHANGE_IN: 'Change IN',
    CHANGE_OUT: 'Change OUT',
    ACCOUNTING_REPORTS: 'Accounting reports',
    STARTED: 'Started',
    SETTLED: 'Settled',
    FINISHED: 'Finished on',
    ACCOUNTS: 'Accounts',
    ROWS: 'Rows',
    SALES: 'Sales',
    NEWS_CAROUSEL: 'News carousel',
    TIMESLOTS: 'Timeslots',
    TEAM: 'Team',
    POS_TITLE: 'POS',
    POS_BUTTONS: 'POS buttons',
    POS_V2_BUTTONS: 'POS v2 menus',
    POS_V2_MENUS: 'POS v2 menus',
    POS_V2_MENUS_TITLE: 'POS menus',
    POS_V2_MENUS_SUBTITLE: 'Create and manage POS menus. Only one menu is active at a time on your registers.',
    POS_V2_CREATE_MENU: 'Create menu',
    POS_V2_SEARCH_MENUS: 'Search menus...',
    POS_V2_NO_MATCHING_MENUS: 'No menus found matching your search.',
    POS_V2_NEW_MENU_NAME: 'Menu name',
    POS_V2_MENU_NAME_PLACEHOLDER: 'e.g. Lunch, Dinner, Bar',
    POS_V2_ACTIVE_MENU: 'Active',
    POS_V2_INACTIVE_MENU: 'Inactive',
    POS_V2_SET_ACTIVE: 'Set as active',
    POS_V2_MENU_ACTIVE_SUCCESS: 'Menu activated successfully.',
    POS_V2_DUPLICATE_MENU: 'Duplicate menu',
    POS_V2_DELETE_MENU: 'Delete menu',
    POS_V2_DELETE_MENU_CONFIRM: 'Are you sure you want to delete menu "{name}"?',
    POS_V2_CANNOT_DELETE_ACTIVE_MENU: 'The active menu cannot be deleted. Activate another menu first.',
    POS_V2_NO_MENUS_TITLE: 'No POS menus yet',
    POS_V2_NO_MENUS_HINT: 'Create your first menu to start configuring layers and buttons for your registers.',
    POS_V2_BACK_TO_MENUS: 'Back to menus',
    POS_V2_EDIT_LAYERS: 'Edit layers',
    POS_V2_LAYERS_COUNT: '{count} layers',
    POS_V2_RENAME_MENU: 'Rename menu',
    POS_V2_LAYERS: 'Layers',
    POS_V2_LAYOUT_SAVED: 'Layout saved.',
    POS_V2_LAYOUT_SAVE_FAILED: 'Failed to save layout. Please try again.',
    POS_V2_UNSAVED_CHANGES_TITLE: 'Unsaved changes',
    POS_V2_UNSAVED_CHANGES_CONFIRM: 'You have unsaved changes in this menu. Do you want to discard them and return to menus?',
    POS_V2_DISCARD_AND_LEAVE: 'Discard and leave',
    POS_V2_KEEP_EDITING: 'Keep editing',
    POS_V2_CREATE_FAV_LAYER: 'Create favorites layer',
    POS_V2_FAV_LAYER: 'Favorites',
    POS_V2_TOGGLE_FAVORITE: 'Toggle favorite',
    POS_V2_NO_LAYERS_TITLE: 'No layers yet',
    POS_V2_NO_LAYERS_HINT: 'Create your first layer to organize categories and POS buttons.',
    POS_V2_ADD_LAYER: 'Add layer',
    POS_V2_ADD_CATEGORY: 'Add category',
    POS_V2_MENU_CATEGORIES: 'Menu categories',
    POS_V2_ALL_CATEGORIES_ADDED: 'All menu categories have been added to this layer.',
    POS_V2_SEARCH_CATEGORIES: 'Search categories...',
    POS_V2_SELECT_ALL_CATEGORIES: 'Select all',
    POS_V2_DESELECT_ALL_CATEGORIES: 'Deselect all',
    POS_V2_CUSTOM_CATEGORY_NAME: 'Category name',
    POS_V2_CUSTOM_CATEGORY_PLACEHOLDER: 'Enter category name...',
    POS_V2_CUSTOM_CATEGORY_DESC: 'Create a custom category to manually add items or custom shortcuts.',
    POS_V2_CREATE_CUSTOM_INSTEAD: 'Create a custom category instead',
    POS_V2_NO_MATCHING_CATEGORIES: 'No categories found matching "{query}"',
    POS_V2_ADD_MENU_CATEGORY: 'Add existing',
    POS_V2_ADD_CUSTOM_CATEGORY: 'Add custom category',
    POS_V2_RENAME_CUSTOM_CATEGORY: 'Rename custom category',
    POS_V2_DRAG_CATEGORY: 'Drag to reorder category',
    POS_V2_CUSTOM_CATEGORY: 'Custom',
    POS_V2_MENU_CATEGORY: 'Menu Category',
    POS_V2_NO_PRODUCTS: 'No products',
    POS_V2_CUSTOM_CATEGORY_HINT: 'Add buttons manually for this custom category.',
    POS_V2_DELETE_LAYER: 'Delete layer',
    POS_V2_DELETE_LAYER_CONFIRM: 'Are you sure you want to delete the layer "{name}"?',
    POS_V2_DELETE_CATEGORY_CONFIRM: 'Are you sure you want to delete the category "{name}"?',
    POS_V2_DELETE_BUTTON: 'Delete button',
    POS_V2_DELETE_BUTTON_CONFIRM: 'Are you sure you want to delete the button "{name}"?',
    POS_V2_BUTTON: 'Button',
    POS_V2_PAGE_SUBTITLE: 'Configure layers, categories, and POS buttons.',
    POS_V2_SAVE_LAYOUT: 'Save layout',
    POS_V2_ADD_BUTTON: 'Add button',
    POS_V2_MANAGE_CATEGORY_PRODUCTS: 'Manage products',
    POS_V2_ADD_PRODUCTS: 'Add products',
    POS_V2_ADD_SELECTED: 'Add selected',
    POS_V2_SPECIAL_BUTTONS: 'Special buttons',
    POS_V2_IN_CATEGORY: 'In category',
    POS_V2_PRODUCT_CATALOG: 'Product catalog',
    POS_V2_CUSTOM_LABEL: 'Custom POS label',
    POS_V2_CUSTOM_LABEL_PLACEHOLDER: 'Custom button label...',
    POS_V2_ADD_FREE_TEXT_BTN: 'Add free text button',
    POS_V2_ADD_STOCK_BTN: 'Add sub-layer button',
    POS_V2_NO_PRODUCTS_IN_CATEGORY: 'No buttons in this category yet. Switch to Product Catalog to add products.',
    POS_V2_NO_PRODUCTS_FOUND: 'No products found',
    POS_V2_SELECT_ALL: 'Select all',
    POS_V2_HIDE_ADDED: 'Hide already added',
    POS_V2_FREE_TEXT_PREFILL_HINT: 'Text that will be added to the item upon pressing the button',
    POS_V2_LAYER_VISIBLE_IN_POS: 'Visible in POS',
    POS_V2_LAYER_HIDDEN: 'Hidden in POS',
    POS_V2_DRAG_LAYER: 'Drag to reorder layer',
    POS_V2_LAYER_DISABLED_HINT: 'This layer is hidden from the POS v2 register until enabled.',
    POS_V2_GENERATE_HINT: 'Adds buttons for menu products with selected category. Replaces existing buttons in this tab.',
    POS_V2_GENERATE_CONFIRM:
        'Generate buttons from menu products with selected category? Existing buttons in this tab will be replaced.',
    POS_V2_GRID_EMPTY: 'No buttons yet. Add one or generate from your menu.',
    POS_V2_NO_CATEGORIES_IN_LAYER: 'No categories in this layer.',
    POS_V2_NO_BUTTONS_IN_CATEGORY: 'No buttons in this category.',
    POS_V2_ALL_READONLY: 'View only. Select a category to add or edit buttons.',
    POS_V2_BUTTON_COLOR: 'Color',
    POS_V2_STOCK_EMPTY: 'Add buttons to this stock layer using the + tile.',
    POS_V2_CUSTOM_NAME_TOGGLE: 'Custom button label',
    POS_V2_CUSTOM_NAME_HINT: 'Override the displayed name on the POS button tile',
    POS_V2_CUSTOM_NAME_LABEL: 'Custom name',
    POS_V2_SYNCED_WITH_REGISTER: 'Syncs automatically with Product Register',
    GENERATE_POS_BUTTONS: 'Generate buttons',
    POS_BUTTON_LINK_TYPE: 'What should this button link to?',
    PREFILLED_TEXT: 'Prefilled text',
    POS_USERS: 'POS users',
    POS_V2_USERS: 'POS v2 users',
    // -- Staff (personalliggare) --
    STAFF_MENU: 'Staff',
    STAFF_EMPLOYEES: 'Employees',
    STAFF_DEVICES: 'Punch clocks',
    STAFF_LEDGER: 'Staff ledger',
    STAFF_ACCESS_LOG: 'Access log',
    STAFF_EMPLOYEES_SUBTITLE: 'People who punch in and out in the electronic staff ledger',
    STAFF_DEVICES_SUBTITLE: 'Punch clocks and personal phones enrolled for these premises',
    STAFF_LEDGER_SUBTITLE: 'Presence, shifts and export for inspections',
    STAFF_NOT_CONFIGURED: 'The staff ledger is not configured in this environment.',
    // Schemaläggning (staff scheduling)
    STAFF_SCHEDULE_TITLE: 'Schedule',
    STAFF_SCHEDULE_INTRO: 'Plan shifts for the week, see planned against actually worked hours, and publish when it is ready.',
    STAFF_SCHEDULE_THIS_WEEK: 'This week',
    STAFF_SCHEDULE_COPY_PREVIOUS: 'Copy previous week',
    STAFF_SCHEDULE_REPEAT: 'Repeat',
    STAFF_SCHEDULE_REPEAT_FROM: 'Repeating the shift from',
    STAFF_SCHEDULE_REPEAT_UNTIL: 'Until and including',
    STAFF_SCHEDULE_REPEAT_EVERY: 'How often',
    STAFF_SCHEDULE_REPEAT_DAYS: 'Weekdays',
    STAFF_SCHEDULE_REPEAT_DAYS_HINT: 'Leave empty for the shift\'s own weekday.',
    STAFF_SCHEDULE_REPEAT_DO: 'Create the shifts',
    STAFF_SCHEDULE_REPEAT_NOTE: 'The shifts are created as drafts and stand alone — editing one changes only that one. To change the pattern, delete them and repeat again.',
    STAFF_SCHEDULE_REPEAT_CREATED: '{count} shift(s) created.',
    STAFF_SCHEDULE_REPEAT_SKIPPED: '{count} date(s) skipped (the shift was already there).',
    STAFF_SCHEDULE_REPEAT_CAPPED: 'The limit was reached — repeat again for the rest.',
    STAFF_SCHEDULE_EVERY_WEEK: 'Every week',
    STAFF_SCHEDULE_EVERY_2ND_WEEK: 'Every other week',
    STAFF_SCHEDULE_EVERY_3RD_WEEK: 'Every third week',
    STAFF_SCHEDULE_EVERY_4TH_WEEK: 'Every fourth week',
    STAFF_SCHEDULE_VIEW_MONTH: 'Month',
    STAFF_SCHEDULE_THIS_MONTH: 'This month',
    STAFF_SCHEDULE_WEEK_SHORT: 'wk',
    STAFF_SCHEDULE_OPEN_SHORT: 'open',
    STAFF_SCHEDULE_VIEW_WEEK: 'Week',
    STAFF_SCHEDULE_VIEW_DAY: 'Day',
    STAFF_SCHEDULE_BY_EMPLOYEE: 'By employee',
    STAFF_SCHEDULE_BY_ROLE: 'By role',
    STAFF_SCHEDULE_NO_ROLES_USED: 'No shifts this week.',
    STAFF_SCHEDULE_PRINT: 'Print',
    STAFF_SCHEDULE_PRINTED_AT: 'Printed',
    STAFF_SCHEDULE_EXPORT_CSV: 'Export CSV',
    STAFF_SCHEDULE_DATE: 'Date',
    STAFF_SCHEDULE_WEEKDAY: 'Weekday',
    STAFF_SETTINGS_TITLE: 'Roles and templates',
    STAFF_SETTINGS_INTRO: 'Which roles this unit staffs, and which shift shapes it uses. Rarely changed.',
    STAFF_SETTINGS_BACK: 'Back to the schedule',
    STAFF_ROLE_SECTION: 'Roles',
    STAFF_ROLE_ADD: 'New role',
    STAFF_ROLE_EDIT: 'Edit role',
    STAFF_ROLE_NAME: 'Role',
    STAFF_ROLE_COLOUR: 'Colour in the calendar',
    STAFF_ROLE_ORDER: 'Order',
    STAFF_ROLE_NONE: 'No roles defined. The calendar then uses whatever roles are already on shifts and employees.',
    STAFF_ROLE_RETIRED: 'Retired',
    STAFF_ROLE_RETIRE: 'Retire — it can no longer be picked for new shifts',
    STAFF_ROLE_REINSTATE: 'Make active again',
    STAFF_ROLE_NAME_REQUIRED: 'Enter a role name.',
    STAFF_ROLE_USAGE: 'Shifts with this role',
    STAFF_ROLE_RENAME_WARNING: 'Renaming changes this list only. Existing shifts keep the old name and will show as uncatalogued.',
    STAFF_ROLE_DRIFT_TITLE: 'Roles in use that are not in the list',
    STAFF_ROLE_DRIFT_HINT: 'They come from shifts and employees. Add them to give them a colour and an order — or clean up the ones that should not exist.',
    STAFF_ROLE_ADD_THIS: 'Add this role',
    STAFF_ROLE_SEED: 'Add them all',
    STAFF_ROLE_SEEDED: '{count} role(s) added.',
    STAFF_TEMPLATE_SECTION: 'Shift templates',
    STAFF_TEMPLATE_HINT: 'A template is a shortcut, not a rule: editing one changes no shifts that already exist.',
    STAFF_TEMPLATE_ADD: 'New template',
    STAFF_TEMPLATE_EDIT: 'Edit template',
    STAFF_TEMPLATE_NAME: 'Name',
    STAFF_TEMPLATE_TIME: 'Time',
    STAFF_TEMPLATE_PAID: 'Paid',
    STAFF_TEMPLATE_NONE: 'No templates yet.',
    STAFF_TEMPLATE_NAME_REQUIRED: 'Enter a name for the template.',
    STAFF_TEMPLATE_NO_LINK: 'The template fills in a new shift. It is not linked to the shift afterwards.',
    STAFF_SCHEDULE_COPY_FROM: 'Copy from week…',
    STAFF_SCHEDULE_COPY_SOURCE: 'Copy from',
    STAFF_SCHEDULE_COPY_MODE: 'How',
    STAFF_SCHEDULE_COPY_REPLACE: 'Replace the week',
    STAFF_SCHEDULE_COPY_ADD: 'Add the shifts',
    STAFF_SCHEDULE_COPY_REPLACE_HINT: 'Shifts in this week are removed first. Published shifts are replaced too.',
    STAFF_SCHEDULE_COPY_ADD_HINT: 'The shifts are added on top of what is already here. May create duplicates.',
    STAFF_SCHEDULE_COPY_TARGET: 'Copying to',
    STAFF_SCHEDULE_COPY_DO: 'Copy',
    STAFF_SCHEDULE_COPY_RESULT: '{created} shift(s) copied from {from}.',
    STAFF_SCHEDULE_PUBLISH: 'Publish',
    STAFF_SCHEDULE_REPUBLISH: 'Publish changes',
    STAFF_SCHEDULE_PUBLISHED: 'Published',
    STAFF_SCHEDULE_CHANGED: 'Changed since publish',
    STAFF_SCHEDULE_DRAFT: 'Draft',
    STAFF_SCHEDULE_WHO: 'Who',
    STAFF_SCHEDULE_PLANNED: 'Planned',
    STAFF_SCHEDULE_ACTUAL: 'Worked',
    STAFF_SCHEDULE_DIFF: 'Diff',
    STAFF_SCHEDULE_COST: 'Cost',
    STAFF_SCHEDULE_TOTAL: 'Total',
    STAFF_SCHEDULE_OPEN_SHIFTS: 'Open shifts',
    STAFF_SCHEDULE_OPEN_SHIFT: 'Open shift (nobody)',
    STAFF_SCHEDULE_NO_ROLE: 'No role',
    STAFF_SCHEDULE_ROLE: 'Role',
    STAFF_SCHEDULE_START: 'Start',
    STAFF_SCHEDULE_END: 'End',
    STAFF_SCHEDULE_BREAK: 'Break (min)',
    STAFF_SCHEDULE_NOTE: 'Note',
    STAFF_SCHEDULE_ADD: 'Add a shift',
    STAFF_SCHEDULE_NEW_SHIFT: 'New shift',
    STAFF_SCHEDULE_EDIT_SHIFT: 'Edit shift',
    STAFF_SCHEDULE_DELETE: 'Remove',
    STAFF_SCHEDULE_BAD_TIME: 'Enter times as HH:MM, for example 16:00.',
    STAFF_SCHEDULE_TIME_HINT: 'An end time before the start means the shift runs past midnight.',
    STAFF_SCHEDULE_NO_EMPLOYEES: 'No employees at this unit yet. Add them under Employees first.',
    STAFF_SCHEDULE_NO_WORKPLACE: 'The staff module is not set up for this unit yet.',
    STAFF_SCHEDULE_WARNINGS: '{count} working-time warning(s)',
    STAFF_SCHEDULE_WARNINGS_HINT: 'advisory only, the schedule still saves. Collective agreements may be stricter than the law.',
    STAFF_SCHEDULE_FOOTER: '{shifts} shift(s) this week, {open} open.',
    STAFF_SCHEDULE_NO_WEATHER: 'No weather: set the unit’s coordinates to show the forecast.',
    STAFF_SCHEDULE_WEATHER_SOURCE: 'Weather from SMHI.',
    STAFF_INACTIVE: 'inactive',
    STAFF_ABSENCE_PENDING: 'Absence requests awaiting a decision',
    STAFF_ABSENCE_APPROVE: 'Approve',
    STAFF_ABSENCE_DECLINE: 'Decline',
    STAFF_SMS_OPT_OUT: 'No schedule SMS',
    STAFF_SMS_OPT_OUT_HINT: 'When on, this employee gets no text when a schedule or an open shift is published.',
    STAFF_PHONE_HINT: 'Swedish mobile, or with a country code: +358…. Used for Mina sidor sign-in and schedule SMS.',
    STAFF_UNIT_ALERT_PHONE: 'Phone for absence requests',
    STAFF_UNIT_ALERT_PHONE_HINT: 'A text goes to this number when an employee requests time off. Leave empty for none — requests still appear under Schedule.',
    STAFF_ERROR: 'Something went wrong',
    STAFF_SAVED: 'Saved',
    STAFF_RETRY: 'Try again',
    STAFF_CANCEL: 'Cancel',
    STAFF_SAVE: 'Save',
    STAFF_DONE: 'Done',
    STAFF_SEARCH: 'Search',
    STAFF_REQUIRED: 'Required',
    STAFF_SETUP_TITLE: 'Get started with the staff ledger',
    STAFF_SETUP_HINT: 'Enter the premises details. Company name and organisation number are recorded on every ledger event.',
    STAFF_SETUP_REQUIRED: 'The staff ledger is not set up for these premises yet. Start under Employees.',
    STAFF_DISPLAY_NAME: 'Premises name',
    STAFF_COMPANY_NAME: 'Company name',
    STAFF_ORG_NO: 'Organisation number',
    STAFF_ADDRESS: 'Address',
    STAFF_SETUP_SAVE: 'Get started',
    STAFF_ADD_EMPLOYEE: 'Add employee',
    STAFF_EDIT_EMPLOYEE: 'Edit employee',
    STAFF_FORM_HINT: 'Used in the staff ledger. Past events keep the details that applied at the time.',
    STAFF_SECTION_PERSON: 'Person',
    STAFF_SECTION_EMPLOYMENT: 'Employment',
    STAFF_SECTION_CONTACT: 'Contact',
    STAFF_FIRST_NAME: 'First name',
    STAFF_LAST_NAME: 'Last name',
    STAFF_NATIONAL_ID: 'Personal identity number (personnummer or samordningsnummer)',
    STAFF_NATIONAL_ID_HINT: 'Stored protected and only ever shown masked. Cannot be changed later.',
    STAFF_ROLES: 'Roles',
    STAFF_ROLES_HINT: 'Comma-separated, e.g. chef, waiter',
    STAFF_EMPLOYMENT_FORM: 'Employment type',
    STAFF_START_DATE: 'Start date',
    STAFF_EMAIL: 'Email',
    STAFF_PHONE: 'Phone',
    STAFF_PIN: 'PIN (4 digits)',
    STAFF_PIN_HINT: 'Used to punch in and out. Unique within the restaurant. Can be left empty and set later.',
    STAFF_PIN_INVALID: '4 digits, not one repeated digit',
    STAFF_SET_PIN: 'Set new PIN',
    STAFF_SET_PIN_HINT: 'The old PIN stops working immediately online, and on punch clocks at their next sync.',
    STAFF_PIN_SET_FOR: 'New PIN set for {name}',
    STAFF_NO_PIN: 'No PIN',
    STAFF_DEACTIVATE: 'End employment',
    STAFF_DEACTIVATE_HINT: 'The person can no longer punch. Their history in the staff ledger is kept.',
    STAFF_END_DATE: 'End date',
    STAFF_SHOW_INACTIVE: 'Show ended',
    STAFF_EMPLOYEE: 'Employee',
    STAFF_IDENTITY: 'Identity',
    STAFF_STATUS: 'Status',
    STAFF_STATUS_ACTIVE: 'Active',
    STAFF_STATUS_INACTIVE: 'Ended',
    STAFF_NO_EMPLOYEES: 'No employees yet',
    STAFF_NO_EMPLOYEES_HINT: 'Add the people who will punch at these premises.',
    STAFF_ENROL_DEVICE: 'Enroll device',
    STAFF_SCOPE: 'Type',
    STAFF_SCOPE_WORKPLACE: 'Shared punch clock',
    STAFF_SCOPE_EMPLOYEE: 'Personal phone',
    STAFF_SCOPE_EMPLOYEE_HINT: 'A personal phone can only punch for one person and only stores that person\'s PIN.',
    STAFF_DEVICE_NAME: 'Device name',
    STAFF_CODE_VALID_MINUTES: 'Code valid for',
    STAFF_CREATE_CODE: 'Create code',
    STAFF_NEW_CODE: 'New code',
    STAFF_CODE_HINT: 'Scan the QR code with the device, open the link, or type the code. It can be used once.',
    STAFF_CODE_EXPIRES: 'Expires in {time}',
    STAFF_CODE_EXPIRED: 'The code has expired. Create a new one.',
    STAFF_COPY_LINK: 'Copy link',
    STAFF_LINK_COPIED: 'Link copied',
    STAFF_OPEN_LINK: 'Open',
    STAFF_DEVICE: 'Device',
    STAFF_ENROLLED: 'Enrolled',
    STAFF_LAST_SEEN: 'Last seen',
    STAFF_NEVER: 'Never',
    STAFF_JUST_NOW: 'Just now',
    STAFF_MINUTES_AGO: '{n} min ago',
    STAFF_REVOKE: 'Revoke',
    STAFF_REVOKED: 'Revoked',
    STAFF_REVOKE_HINT: 'The device stops working on its next request. Punches it has not synced stay on the device until it is enrolled again.',
    STAFF_REASON: 'Reason',
    STAFF_NO_DEVICES: 'No devices enrolled',
    STAFF_NO_DEVICES_HINT: 'Enroll the punch clock at the staff entrance with a one-time code.',
    STAFF_PRESENT_NOW: 'On site now',
    STAFF_NOBODY_PRESENT: 'Nobody is on site.',
    STAFF_SINCE: 'Since',
    STAFF_PERIOD: 'Period',
    STAFF_SHIFTS: 'Shifts',
    STAFF_EVENTS: 'Events',
    STAFF_START: 'Start',
    STAFF_END: 'End',
    STAFF_DURATION: 'Duration',
    STAFF_NOTES: 'Notes',
    STAFF_NO_SHIFTS: 'No shifts in this period.',
    STAFF_ANOMALY_OPEN: 'Not clocked out',
    STAFF_ANOMALY_DUPLICATE_IN: 'Double clock-in',
    STAFF_ANOMALY_ORPHAN_OUT: 'Clock-out without clock-in',
    STAFF_OFFLINE_CAPTURED: 'Captured offline',
    STAFF_INTEGRITY_OK: 'Chain verified',
    STAFF_INTEGRITY_BROKEN: 'Chain is broken',
    STAFF_EXPORT: 'Export',
    STAFF_EXPORT_JSON: 'JSON',
    STAFF_EXPORT_SHIFTS_CSV: 'Shifts (CSV)',
    STAFF_EXPORT_EVENTS_CSV: 'Audit trail (CSV)',
    STAFF_EXPORT_WITH_IDS: 'Export with national IDs',
    STAFF_EXPORT_WITH_IDS_HINT: 'National IDs are only released with a stated reason. The reason and the number of IDs revealed are logged.',
    STAFF_EXPORT_FORMAT: 'Format',
    STAFF_EXPORT_REASON_PLACEHOLDER: 'e.g. Tax Agency inspection',
    STAFF_EXPORT_DONE: 'Export downloaded',
    STAFF_TIME: 'Time',
    STAFF_TYPE: 'Type',
    STAFF_IDENTIFICATION: 'Identification',
    STAFF_RECORDED_BY: 'Recorded by',
    STAFF_SUPERSEDED: 'Superseded',
    STAFF_TYPE_PUNCH_IN: 'Clock-in',
    STAFF_TYPE_PUNCH_OUT: 'Clock-out',
    STAFF_TYPE_PUNCH_CORRECTION: 'Correction',
    STAFF_TYPE_PUNCH_VOID: 'Void',
    STAFF_VERIFIED_SERVER: 'PIN (checked by the server)',
    STAFF_VERIFIED_DEVICE: 'PIN (checked offline on the device)',
    STAFF_VERIFIED_NONE: 'Not verified',
    STAFF_BY_MANAGER: 'Manager',
    STAFF_CORRECT: 'Correct',
    STAFF_VOID: 'Void',
    STAFF_CORRECT_HINT: 'The correction is added as a new event. The original stays and remains visible in the audit trail.',
    STAFF_VOID_HINT: 'The void is added as a new event and removes the punch from the shifts. The original stays in the audit trail.',
    STAFF_CORRECTED_TYPE: 'Should be',
    STAFF_CORRECTED_TIME: 'Correct time',
    STAFF_ACCESS_LOG_SUBTITLE: 'Who did what: exports and national IDs revealed, PINs, devices and employee changes',
    STAFF_ACTION: 'Action',
    STAFF_ACTOR: 'Performed by',
    STAFF_TARGET: 'Target',
    STAFF_IDS_REVEALED: 'National IDs',
    STAFF_NO_LOG: 'No entries in this period.',
    STAFF_ACTION_LEDGER_EXPORT: 'Staff ledger export',
    STAFF_ACTION_LEDGER_READ: 'Staff ledger read',
    STAFF_ADD_TILL_INTRO_NO_STAFF: 'Create a new till with a name. Then enter its device ID on the POS to start using it.',
    STAFF_TILL_NAME_REQUIRED: 'Enter a name for the till.',
    STAFF_TILL_CREATE_FAILED: 'Could not create the till. Try again.',
    STAFF_TILL_NEW_CODE_TITLE: 'New one-time code for the till',
    STAFF_TILL_NEW_CODE_INTRO: 'Create a one-time code that connects staff PIN sign-in to this till.',
    STAFF_TILL_DEVICE_ID: 'Device ID of the till',
    STAFF_TILL_STEP_SETUP_ID: 'Enter the device ID in "Set up this register" (in Finnish "Ota tämä kassa käyttöön") and press Register.',
    STAFF_ADD_TILL: 'Add till',
    STAFF_ADD_TILL_INTRO: 'Create a new till with a name. You get a one-time code for exactly that till: entering it on the POS takes the till over and connects staff PIN sign-in in the same step.',
    STAFF_TILL_NAME: 'Till name',
    STAFF_TILL_NAME_PLACEHOLDER: 'e.g. Till 2',
    STAFF_TILL_NAME_HINT: 'The name is set only here — the POS takes it from here.',
    STAFF_TILL_CREATE_CODE: 'Create code',
    STAFF_TILL_CODE_LABEL: 'One-time code for the till',
    STAFF_TILL_STEP_OPEN: 'Open the POS on the new device and sign in to the unit.',
    STAFF_TILL_STEP_SETUP: 'Enter the one-time code in "Set up this register" (in Finnish "Ota tämä kassa käyttöön") and press Register.',
    STAFF_TILL_STEP_DONE: 'Done. The till appears under POS → Devices, and staff sign in with their PIN.',
    STAFF_TILL_CODE_UNAVAILABLE: 'The staff module is not turned on for this unit, or you do not have access to it. Without it, a new till is registered on the till itself with just a name.',
    STAFF_KIND_TILL: 'Till',
    STAFF_KIND_KIOSK: 'Punch clock',
    STAFF_ACTION_EMPLOYEE_POS_ACCESS: 'Till access changed',
    STAFF_POS_ACCESS: 'Till access',
    STAFF_POS_ENABLED: 'May use the till',
    STAFF_POS_ENABLED_HINT: 'They sign in at the till with the same 4-digit PIN they use at the time clock. Their name goes on the receipt and into the journal.',
    STAFF_POS_PERMISSIONS: 'Till permissions',
    STAFF_POS_MAX_DISCOUNT: 'Maximum discount',
    STAFF_POS_PERM_REFUND: 'May issue refunds',
    STAFF_POS_PERM_REMOVE_FROM_TAB: 'May remove items from a tab',
    STAFF_POS_PERM_SPLIT_TAB: 'May split a tab',
    STAFF_POS_PERM_VIEW_SETTINGS: 'May open the till settings',
    STAFF_POS_PERM_VIEW_JOURNAL: 'May read the register journal',
    STAFF_POS_PERM_VIEW_JOURNAL_HINT: 'The POS shows its own journal entries (the journalminne). The whole journal is read in admin.',
    STAFF_POS_PERM_MOVE_BOOKING: 'May move bookings',
    STAFF_POS_PERM_EDIT_BOOKING_TIME: 'May change booking times',
    STAFF_POS_PERM_EDIT_TABLE_MAP: 'May edit the table map',
    STAFF_POS_NEEDS_PIN: 'Set a PIN first — without one they cannot sign in at the till.',
    STAFF_POS_HANDLE: 'Till id',
    STAFF_POS_HANDLE_HINT: 'The number printed on receipts and recorded in the journal. It never changes.',
    STAFF_PUNCH_ONLY: 'Punch clock only',
    STAFF_POS_GRANTED: '{name} can now use the till (till id #{id}).',
    STAFF_POS_WITHDRAWN: '{name} no longer has till access.',
    STAFF_REQUIRE_PUNCH_TO_SELL: 'Require clocking in before using the till',
    STAFF_REQUIRE_PUNCH_TO_SELL_HINT: 'With this on, nobody can sign in at the till unless they are clocked into the staff ledger.',
    STAFF_ACTION_LEDGER_MANUAL_PUNCH: 'Manual punch entered',
    STAFF_ACTION_LEDGER_CORRECT: 'Punch corrected',
    STAFF_ACTION_LEDGER_VOID: 'Punch voided',
    STAFF_ACTIONS: 'Actions',
    STAFF_MANUAL_ENTRY: 'Manual',
    STAFF_CLOSE_SHIFT: 'Close shift',
    STAFF_ADD_PUNCH: 'Add punch',
    STAFF_MANUAL_HINT: 'Add a punch the time clock never recorded. It is marked as manual in the staff ledger, with your reason, your name and the time you entered it.',
    STAFF_MANUAL_TIME: 'When the shift actually started or ended',
    STAFF_MANUAL_AFTER: 'Must be after {time}.',
    STAFF_MANUAL_BEFORE: 'Must be before {time}.',
    STAFF_MANUAL_REASON_HINT: 'E.g. Forgot to clock out, confirmed against the rota',
    STAFF_WHICH_PUNCH: 'Applies to',
    STAFF_ACTION_IDENTITY_RESOLVE: 'National ID resolved',
    STAFF_ACTION_PIN_CREDENTIALS_ISSUE: 'PIN credentials sent to device',
    STAFF_ACTION_WORKPLACE_UPSERT: 'Premises saved',
    STAFF_ACTION_EMPLOYEE_CREATE: 'Employee created',
    STAFF_ACTION_EMPLOYEE_UPDATE: 'Employee updated',
    STAFF_ACTION_EMPLOYEE_PIN: 'PIN set',
    STAFF_ACTION_EMPLOYEE_DEACTIVATE: 'Employment ended',
    STAFF_ACTION_DEVICE_ENROLMENT_CODE: 'Enrollment code created',
    STAFF_ACTION_DEVICE_ENROL: 'Device enrolled',
    STAFF_ACTION_DEVICE_REVOKE: 'Device revoked',
    STAFF_ACTION_PAYROLL_RATE_SET: 'Pay rate added',
    STAFF_ACTION_PAYROLL_RATE_READ: 'Pay rates viewed',
    STAFF_ACTION_PAYROLL_REPORT: 'Labour cost report viewed',
    STAFF_PAYROLL: 'Pay rates',
    STAFF_PAYROLL_SUBTITLE: 'Hourly or monthly pay per employee, effective from a date',
    STAFF_PAYROLL_SENSITIVE: 'Pay data is sensitive. Every view and change is recorded in the access log.',
    STAFF_LABOUR_COST: 'Labour cost',
    STAFF_LABOUR_COST_SUBTITLE: 'Labour cost compared with sales, by day and by employee',
    STAFF_CURRENT_RATE: 'Current pay',
    STAFF_UPCOMING_RATE: 'Upcoming',
    STAFF_NO_RATE: 'No pay rate',
    STAFF_NEW_RATE: 'New pay rate',
    STAFF_NEW_RATE_HINT: 'A new pay rate is added from a date. Earlier rates are never changed, so labour cost already calculated stays as it was.',
    STAFF_RATE_HISTORY: 'Pay history',
    STAFF_RATE: 'Pay',
    STAFF_RATE_TYPE: 'Pay type',
    STAFF_RATE_HOURLY: 'Hourly',
    STAFF_RATE_MONTHLY: 'Monthly',
    STAFF_VALID_FROM: 'Effective from',
    STAFF_OVERHEAD: 'Employer fees / on-costs (%)',
    STAFF_OVERHEAD_HINT: 'Added on top of pay in labour cost, e.g. 31.42% Swedish employer social fees.',
    STAFF_PER_HOUR: 'SEK/h',
    STAFF_PER_MONTH: 'SEK/month',
    STAFF_SET_BY: 'Set by',
    STAFF_NO_HISTORY: 'No pay rate recorded yet.',
    STAFF_SALES_NET: 'Sales excl. VAT',
    STAFF_SALES_GROSS: 'incl. VAT',
    STAFF_LABOUR_PCT: 'Labour cost %',
    STAFF_HOURS: 'Hours',
    STAFF_COSTED_HOURS: 'with a pay rate',
    STAFF_BY_DAY: 'By day',
    STAFF_BY_EMPLOYEE: 'By employee',
    STAFF_DATE: 'Date',
    STAFF_RATE_MISSING: 'Pay rate missing',
    STAFF_WARNING_NO_RATE: '{n} employee(s) worked without a pay rate — those hours are not costed.',
    STAFF_WARNING_OPEN_SHIFTS: '{n} shift(s) are not clocked out and are not costed.',
    STAFF_SALES_UNAVAILABLE: 'No sales for this period — labour cost is shown anyway.',
    STAFF_SALES_SOURCE: 'Sales from POS receipts',
    STAFF_ASSUMPTIONS: 'How it is calculated',
    STAFF_GO_TO_PAYROLL: 'Set pay rates',
    POS_V2_DEVICES: 'POS v2 devices',
    POS_JOURNAL_TITLE: 'Register journal',
    POS_JOURNAL_INTRO: 'The unit journalminne: every till in one series, newest first.',
    POS_JOURNAL_REGISTER: 'Register',
    POS_JOURNAL_SCOPE_UNIT: 'all tills',
    POS_JOURNAL_SCOPE_DEVICE: 'one till',
    POS_JOURNAL_DEVICE: 'Till',
    POS_JOURNAL_ALL_DEVICES: 'All tills',
    POS_JOURNAL_NO_DEVICE: 'Server',
    POS_JOURNAL_SEQ: 'Seq',
    POS_JOURNAL_TIME: 'Time',
    POS_JOURNAL_TYPE: 'Type',
    POS_JOURNAL_RECEIPT: 'Receipt',
    POS_JOURNAL_AMOUNT: 'Amount',
    POS_JOURNAL_CASHIER: 'Cashier',
    POS_JOURNAL_OLDER: 'Show older',
    POS_JOURNAL_PERIOD: 'Period',
    POS_JOURNAL_EMPTY_RANGE: 'No journal entries in the selected period.',
    POS_JOURNAL_RANGE_CAPPED: 'The journal is read newest first, so older periods load in steps. Use Show older to keep going back.',
    POS_JOURNAL_COUNT_LOADED: 'shown of entries loaded',
    POS_JOURNAL_RELOAD: 'Reload',
    POS_JOURNAL_LOADING: 'Loading the journal…',
    POS_JOURNAL_EMPTY: 'No journal entries for this unit yet.',
    POS_JOURNAL_LOAD_FAILED: 'Could not load the journal.',
    POS_JOURNAL_NO_PERMISSION: 'You do not have permission to read the journal.',
    POS_JOURNAL_UNAVAILABLE: 'The journal is not available in this environment yet.',
    POS_JOURNAL_TYPE_SALE: 'Sale',
    POS_JOURNAL_TYPE_RETURN: 'Return',
    POS_JOURNAL_TYPE_COPY: 'Receipt copy',
    POS_JOURNAL_TYPE_CORRECTION: 'Correction',
    POS_JOURNAL_TYPE_PROFORMA: 'Pro forma',
    POS_JOURNAL_TYPE_INTERRUPTED: 'Interrupted',
    POS_JOURNAL_TYPE_X_REPORT: 'X report',
    POS_JOURNAL_TYPE_Z_REPORT: 'Z report',
    POS_JOURNAL_TYPE_LOGIN: 'Sign-in',
    POS_JOURNAL_TYPE_LOGOUT: 'Sign-out',
    POS_JOURNAL_TYPE_MODE_CHANGE: 'Mode change',
    POS_JOURNAL_TYPE_CLOCK_CHANGE: 'Clock change',
    POS_JOURNAL_TYPE_PRICE_CHANGE: 'Price change',
    FR_TITLE_X: 'X report (running day)',
    FR_TITLE_Z: 'Z report',
    FR_SUBTITLE: 'The content follows the Swedish Tax Agency regulation SKVFS 2014:9, 7 kap. 2 § (X) and 3 § (Z). The reference on each row shows which requirement it satisfies.',
    FR_PDF_SUBTITLE: 'Daily report per SKVFS 2014:9 chapter 7. The right-hand column gives the item in the regulation.',
    FR_PDF_PAGE: 'Page',
    FR_FILE_PREFIX: 'daily-report',
    FR_FOOTNOTE_PLAIN: 'Amounts in SEK. Times in Swedish time (Europe/Stockholm).',
    FR_FOOTNOTE: 'Amounts in SEK. Times in Swedish time (Europe/Stockholm). A dash means the figure cannot be taken from the source — not that it is zero.',
    FR_NO_REPORT: 'No report to show for the selected period.',
    FR_NO_ROWS: 'No rows.',
    FR_TOTAL: 'Total',
    FR_AMOUNT: 'Amount',
    FR_QTY: 'Qty',
    FR_ACCOUNT: 'Account',
    FR_BALANCE: 'Difference',

    FR_EXPORT_PDF: 'PDF',
    FR_EXPORT_CSV: 'CSV',
    FR_PRINT: 'Print',

    FR_SECTION_IDENTITY: 'Seller and register',
    FR_SECTION_PERIOD: 'Period and time',
    FR_SECTION_TOTALS: 'Sales and totals',
    FR_SECTION_VAT: 'VAT per rate',
    FR_SECTION_PAYMENTS: 'Sales per payment method',
    FR_SECTION_GROUPS: 'Sales per product group',
    FR_SECTION_COUNTERS: 'Counters',
    FR_SECTION_REDUCTIONS: 'Returns, discounts and unfinished sales',
    FR_SECTION_ACCOUNTINGS: 'Bookkeeping accounts',
    FR_SECTION_GAPS: 'Figures the source cannot supply',

    FR_COMPANY: 'Company name',
    FR_ORGNO: 'Organisation number',
    FR_VATNO: 'VAT number',
    FR_SALESLOCATION: 'Sales location',
    FR_ADDRESS: 'Address',
    FR_KASSABETECKNING: 'Register designation',

    FR_ZNO: 'Z report serial number',
    FR_PRINTED_AT: 'Report taken',
    FR_PERIOD_FROM: 'Period starts',
    FR_PERIOD_TO: 'Period ends',

    FR_SALES_NET: 'Sales, net (excl. VAT)',
    FR_SALES_VAT: 'VAT',
    FR_SALES_TOTAL: 'Sales, gross (incl. VAT)',
    FR_ROUNDING: 'Rounding',
    FR_CASH_FLOAT: 'Cash float',
    FR_CASH_TAKEN: 'Cash taken',
    FR_CASH_EXPECTED: 'Expected in drawer',
    FR_CASH_COUNTED: 'Counted (latest)',
    FR_CASH_DIFFERENCE: 'Cash difference',
    FR_NOTE_CASH_FROM_TILL: 'Cash kept in the drawer (after change) during the day, from the till.',
    FR_NOTE_CASH_EXPECTED: 'Cash float + cash taken.',
    FR_NOTE_CASH_COUNTED: "The day's latest count of the drawer, made at the till.",
    FR_NOTE_CASH_DIFFERENCE: 'Counted minus what the drawer should have held at the count.',
    FR_GRAND_SALES: 'Grand total sales',
    FR_GRAND_RETURNS: 'Grand total returns',
    FR_GRAND_NET: 'Grand total net',

    FR_VAT_RATE: 'Rate',
    FR_VAT_NET: 'Net',
    FR_VAT_VAT: 'VAT',
    FR_VAT_GROSS: 'Gross',
    FR_PAYMENT_MEANS: 'Payment method',
    FR_GROUP: 'Product group',
    FR_GROUP_NONE: 'No product group',

    FR_GOODS_QTY: 'Goods sold',
    FR_SERVICES_QTY: 'Services sold',
    FR_RECEIPT_COUNT: 'Receipts',
    FR_RECEIPT_RANGE: 'Receipt numbers from–to',
    FR_DRAWER_OPENINGS: 'Cash drawer openings',
    FR_RECEIPT_COPIES: 'Receipt copies, count',
    FR_TRAINING_COUNT: 'Training-mode registrations',

    FR_RETURNS: 'Returns, amount',
    FR_DISCOUNTS: 'Discounts, amount',
    FR_DISCOUNT_COUNT: 'Discounts, count',
    FR_OTHER_REDUCTIONS: 'Other price reductions',
    FR_INTERRUPTED: 'Unfinished sales, count',
    FR_CORRECTIONS: 'Corrected receipts, count',
    FR_PROFORMA: 'Pro forma receipts, count',

    FR_GAPS_TITLE: 'These items required by SKVFS 2014:9 ch. 7 cannot be read from the source:',
    FR_STATE_OK: 'Taken from the source',
    FR_STATE_DERIVED: 'Computed here, not reported directly',
    FR_STATE_UNRELIABLE: 'The source returns a known-wrong value',
    FR_STATE_MISSING: 'Not supplied by the source',
    FR_STATE_NOT_APPLICABLE: 'The register has no such function',

    FR_NOTE_GRAND_ZERO: 'The receipt API always returns zero for the grand totals (inherited from the old VB implementation). The accumulated totals exist in the journalminne but are not exposed here.',
    FR_NOTE_NO_KASSABETECKNING: 'The register designation is not part of the settlement response. It is in the journalminne report header.',
    FR_NOTE_NO_ZNO: 'No serial number is set — an X report does not consume one.',
    FR_NOTE_ROUNDING: 'Read back from the bookkeeping row for the rounding account. Rounding is not an SKVFS requirement for a daily report, but it is needed for reconciliation.',
    FR_NOTE_NO_CASH_FLOAT: 'The cash float is recorded per day in the unit settings but is not supplied by the settlement and is not read here.',
    FR_NOTE_NO_DRAWER: 'The register reports no cash drawer events, so there is no counter to show.',
    FR_NOTE_COPIES_IN_JOURNAL: 'Receipt copies are counted in the journalminne, not in the settlement.',
    FR_NOTE_NO_TRAINING: 'The register has no training mode, so the requirement does not apply.',
    FR_NOTE_RETURNS_FOLDED: 'A return is stored as a receipt with negative amounts and is folded into the sales figures. The journalminne does separate returns.',
    FR_NOTE_NO_OTHER_REDUCTIONS: 'Price reductions other than discounts are not reported separately by the source.',
    FR_NOTE_GROUP_ID: 'The source gives the product group ID, not its name, and the aggregated rows carry no quantities — goods and services sold are reported under Counters instead.',

    FR_CSV_FIELD: 'Field',
    FR_CSV_VALUE: 'Value',
    FR_CSV_SKVFS: 'SKVFS',
    FR_CSV_STATE: 'Status',
    FR_CSV_NOTE: 'Note',

    FR_NOTE_COPIES_AMOUNT_X: 'Neither the settlement nor the journal\'s running totals carry the copies\' amount; only the Z report does.',
    FR_NOTE_INTERRUPTED_AMOUNT_SETTLEMENT: 'The settlement counts unfinished receipts but does not sum their amount.',
    TIP_TAB: 'Tips',
    TIP_TITLE: 'Tips',
    TIP_UNIT: 'Unit',
    TIP_PERIOD: 'Period',
    TIP_GENERATED: 'Generated',
    TIP_TOTAL: 'Tips total',
    TIP_RECEIPT_COUNT: 'Receipts with tips',
    TIP_LINE_COUNT: 'Tip lines',
    TIP_DAYS_WITH_TIPS: 'Days with tips',
    TIP_AVERAGE: 'Average per receipt',
    TIP_RECEIPTS_WORD: 'receipts',
    TIP_SECTION_SUMMARY: 'Summary',
    TIP_SECTION_RECEIPTS: 'Tips per receipt',
    TIP_SECTION_CHECK: 'Reconciliation',
    TIP_PER_DAY: 'Tips per day',
    TIP_PER_SETTLEMENT: 'Tips per settlement (Z)',
    TIP_PER_MEANS: 'Tips per payment method',
    TIP_RECEIPTS: 'Receipt list',
    TIP_COL_DATE: 'Date',
    TIP_COL_TIME: 'Time',
    TIP_COL_RECEIPT_NO: 'Receipt no.',
    TIP_COL_SETTLEMENT: 'Settlement',
    TIP_COL_RECEIPT_RANGE: 'Receipt no. from–to',
    TIP_COL_MEANS: 'Payment method',
    TIP_COL_TIP: 'Tip',
    TIP_COL_RECEIPTS: 'Receipts',
    TIP_COL_RECEIPT_TOTAL: 'Receipt total',
    TIP_OPEN_DAY: 'Open day',
    TIP_EXPORT_RECEIPTS_CSV: 'CSV per receipt (payroll)',
    TIP_EXPORT_SUMMARY_CSV: 'CSV summary',
    TIP_FILE_PREFIX: 'tips',
    TIP_FILE_RECEIPTS: 'per-receipt',
    TIP_FILE_SUMMARY: 'summary',
    TIP_DEFINITION: 'Tips are receipt lines named "Extra" at 0 % VAT, from legacy and new registers alike. A payroll figure, not part of the register\'s daily reports.',
    TIP_NOTE_DAY: 'The receipt\'s own day in Swedish time, not the business day.',
    TIP_NOTE_MEANS: '"Inget", "Okänt" and "Flera betalsätt" are tips that cannot be tied to a single payment method.',
    TIP_NOTE_SETTLEMENT: '"Open day" is receipts not yet in a settlement.',
    TIP_CHECK_OK: 'Matches',
    TIP_CHECK_BAD: 'Does not match',
    TIP_CHECK_OK_SUMMARY: 'Per day, per settlement, per payment method and per receipt all add up to the period\'s total.',
    TIP_CHECK_BAD_SUMMARY: 'The breakdowns do not add up to the period\'s total:',
    TIP_NONE: 'No tips registered in the period.',
    TIP_ERROR: 'The tip report could not be loaded.',
    TIP_TRUNCATED: 'The receipt list is cut to the latest 5,000 receipts. Totals and breakdowns cover the whole period; pick a shorter period for the full list.',
    TIP_PRINT_TOO_MANY: 'Too many receipts to print. Use the PDF or CSV for the full list.',
    TIP_FOOTNOTE: 'Amounts in SEK. Times in Swedish time (Europe/Stockholm).',

    FR_TITLE_COMPILATION: 'Compilation of settlements',
    FR_DIALOG_SETTLEMENT: 'Settlement no.',
    FR_EMAIL_SIE: 'E-mail accounting (SIE)',
    FR_SOURCE_JOURNAL: 'Source: the Z report in the register\'s journal, as sealed at the day\'s close. Accounting rows from the same day\'s settlement.',
    FR_SOURCE_SETTLEMENT: 'Source: the settlement (SQL). Items it does not contain are listed as missing below.',
    FR_SOURCE_SETTLEMENT_JOURNAL: 'Source: receipts not yet settled. Grand totals, receipt copies and register ID from the journal.',
    FR_LIST_SOURCE_JOURNAL: 'Z reports from the journal, one per business day. Click a row for the report.',
    FR_LIST_SOURCE_SETTLEMENT: 'Settlements. This unit has no Z reports in the journal.',
    FR_BUSINESS_DATE: 'Business day',
    FR_DAY_CLOSED_AT: 'Day closed',
    FR_FIRST_SALE: 'First registration',
    FR_LAST_SALE: 'Last registration',
    FR_CONTROL_UNIT: 'Control unit (serial no.)',
    FR_CASHIER: 'Cashier',
    FR_SALES_GROSS: 'Total sales (before returns)',
    FR_RETURNS_AMOUNT_TOTALS: 'Less: returns',
    FR_SALES_AFTER_RETURNS: 'Sales after returns (incl. VAT)',
    FR_GROUPS: 'Sales per main group',
    FR_RECEIPT_COPIES_AMOUNT: 'Receipt copies, amount',
    FR_RETURNS_COUNT: 'Returns, count',
    FR_INTERRUPTED_AMOUNT: 'Unfinished sales, amount',
    FR_SECTION_EVENTS: 'Ongoing use',
    FR_EVENT_LOGIN: 'Sign-ins',
    FR_EVENT_LOGOUT: 'Sign-outs',
    FR_EVENT_PRICE_CHANGE: 'Price changes',
    FR_EVENT_MODE_CHANGE: 'Mode changes',
    FR_EVENT_CLOCK_CHANGE: 'Clock changes',
    FR_VAT_CHECK_OK: 'The VAT breakdown adds up to sales after returns ({expected} {cur}).',
    FR_VAT_CHECK_BAD: 'The VAT breakdown does NOT add up to sales after returns: per-rate total {actual}, sales {expected}, difference {diff} {cur}. The source needs checking.',
    FR_SETTLEMENT: 'settlement no.',
    FR_ACCOUNTINGS_FROM: 'Accounting rows from',
    FR_ACCOUNTINGS_FROM_NOTE: 'The settlement is made at the till and need not follow the Z report\'s business day; compare the periods.',
    FR_ACCOUNTINGS_NONE: 'No till settlement starts within this business day, so there are no accounting rows to show. The Z report is complete regardless.',
    FR_NOTE_FROM_JOURNAL: 'From the journal.',
    FR_NOTE_GRAND_FROM_JOURNAL: 'From the journal\'s running total, as it stands now. Never reset.',
    FR_NOTE_GRAND_NET: 'Grand total sales minus grand total returns (ch. 2 § 5).',
    FR_NOTE_COPIES_SINCE_JOURNAL_Z: 'From the journal: copies since the last Z report, which may start at a different point than the settlement.',
    FR_NOTE_CONTROL_UNIT: 'No control unit is connected yet. The serial is required on the receipt (ch. 7 § 1 l), not on the report.',
    FR_NOTE_CASHIER_SETTLEMENT: 'The report is produced in the admin, not by a cashier.',
    FR_NOTE_CASHIER_Z: 'The Z report is produced automatically by the server when the day closes.',
    FR_NOTE_NO_KASSABETECKNING_JOURNAL: 'The report header has no register ID.',
    FR_NOTE_CLOSE_TIME: 'Per the unit\'s configured close time.',
    FR_NOTE_GROUPS_NOT_IN_JOURNAL: 'Journal lines carry no product group, so sales cannot be split per main group.',
    FR_NOTE_CASH_FLOAT_CLIENT: 'Registered at the till at the start of the day.',
    FR_NOTE_CASH_FLOAT_NOT_REGISTERED: 'No cash float was registered at the till that day.',
    FR_NOTE_RECEIPTS_SUM: 'Sales plus return receipts, which the journal counts separately.',
    FR_NOTE_OTHER_REDUCTIONS_JOURNAL: 'The journal counts corrected receipts but does not report other sales-reducing registrations or their amount.',
    FR_NOTE_INTERRUPTED_AMOUNT: 'The journal counts unfinished sales but does not keep their amount.',
    FR_NOTE_EVENTS: 'Not required on the report, but these events must be in the journal (SKVFS 2014:9 ch. 4). The count here is what an inspector checks the journal against.',
    FR_NOTE_COMPILATION: 'A compilation of several settlements has no sequence number of its own and is not a Z report.',

    PRINT_TO_POS_PRINTER: 'Print on till printer',
    POS_LOG_MEMORY_TITLE: 'POS activity log',
    POS_LOG_MEMORY_INTRO: 'What the tills did: tabs, items, bookings, kitchen sends and payments, newest first.',
    POS_LOG_MEMORY_PERIOD: 'Period',
    POS_LOG_MEMORY_TILL: 'Till',
    POS_LOG_MEMORY_ALL_TILLS: 'All tills',
    POS_LOG_MEMORY_UNKNOWN_TILL: 'Unknown till',
    POS_LOG_MEMORY_CASHIER: 'Cashier',
    POS_LOG_MEMORY_ALL_CASHIERS: 'All cashiers',
    POS_LOG_MEMORY_NO_CASHIER: 'No cashier',
    POS_LOG_MEMORY_RELOAD: 'Reload',
    POS_LOG_MEMORY_TIME: 'Time',
    POS_LOG_MEMORY_TYPE: 'Event',
    POS_LOG_MEMORY_ORDER: 'Order',
    POS_LOG_MEMORY_DETAIL: 'Detail',
    POS_LOG_MEMORY_LOADING: 'Loading the activity log…',
    POS_LOG_MEMORY_EMPTY: 'No POS activity logged for this unit in the selected period.',
    POS_LOG_MEMORY_EMPTY_FILTER: 'No events match the selected till and cashier.',
    POS_LOG_MEMORY_CAPPED: 'Only the newest events in the period were read. Narrow the period to see the rest.',
    POS_LOG_MEMORY_COUNT_LOADED: 'shown of events loaded',
    POS_LOG_MEMORY_LOAD_FAILED: 'Could not load the activity log.',
    POS_LOG_MEMORY_NO_PERMISSION: 'You do not have permission to read the activity log.',
    POS_LOG_MEMORY_TYPE_CUSTOMER_TAB: 'Tab',
    POS_LOG_MEMORY_TYPE_TRANSACTION_FAILED: 'Payment failed',
    POS_LOG_MEMORY_TYPE_CREATE_RECEIPT: 'Receipt created',
    POS_LOG_MEMORY_TYPE_CORRECT_RECEIPT: 'Receipt corrected',
    POS_LOG_MEMORY_TYPE_REFUND_RECEIPT: 'Refund',
    POS_LOG_MEMORY_TYPE_MOVE_BOOKING: 'Booking moved',
    POS_LOG_MEMORY_TYPE_COPY_BOOKING: 'Booking copied',
    POS_LOG_MEMORY_TYPE_UPDATE_BOOKING: 'Booking changed',
    POS_LOG_MEMORY_TYPE_UPDATE_TAB: 'Tab changed',
    POS_LOG_MEMORY_TYPE_ADD_ITEM: 'Item added',
    POS_LOG_MEMORY_TYPE_REMOVE_ITEM: 'Item removed',
    POS_LOG_MEMORY_TYPE_UPDATE_ITEM: 'Item changed',
    POS_LOG_MEMORY_TYPE_TO_KITCHEN: 'Kitchen send',
    POS_DEVICES_SUBTITLE: 'Registers that have set themselves up for this unit. Saved changes apply on the register straight away.',
    POS_DEVICES_TABLE_TITLE: 'Devices',
    POS_DEVICES_EMPTY: 'No POS devices registered for this unit',
    POS_DEVICES_EMPTY_HINT: 'Open POSv2 on the register. It asks for a device name the first time it starts.',
    POS_DEVICES_NAME: 'Device name',
    POS_DEVICES_ID: 'Device ID',
    POS_DEVICES_LAST_SEEN: 'Last seen',
    POS_DEVICES_NEVER_SEEN: 'Never',
    POS_DEVICES_EDIT: 'Edit device',
    POS_DEVICES_FORM_HINT: 'Saved settings are sent to the register immediately.',
    POS_DEVICES_SECTION_IDENTITY: 'Identity',
    POS_DEVICES_SECTION_HARDWARE: 'Hardware',
    POS_DEVICES_UNIT_HINT: 'Changing the route moves this register to another unit.',
    POS_DEVICES_NAME_REQUIRED: 'Enter a device name',
    POS_DEVICES_ROUTE_REQUIRED: 'Enter a route',
    POS_DEVICES_SAVED: 'Device settings saved',
    POS_DEVICES_NEW_STAFF_CODE: 'New staff sign-in code',
    POS_DEVICES_REMOVE: 'Remove till',
    POS_DEVICES_REMOVE_CONFIRM: 'The till is removed from the unit and staff sign-in on it is revoked. A POS using it is asked to choose another till.',
    POS_DEVICES_REMOVED: 'Till removed.',
    POS_DEVICES_REMOVE_FAILED: 'Could not remove the till.',
    POS_DEVICES_ADD_TILL: 'Add till',
    POS_DEVICES_ADD_WITHOUT_STAFF: 'New till: open the POS on the new device and give it a name, and it appears here. With the staff module turned on, add the till here instead with a one-time code, so staff can sign in with their PIN.',
    POS_DEVICES_STAFF_SIGNIN: 'Staff sign-in',
    POS_DEVICES_STAFF_CONNECTED: 'Connected',
    POS_DEVICES_STAFF_REVOKED_TAG: 'Revoked',
    POS_DEVICES_STAFF_REVOKE: 'Revoke staff sign-in',
    POS_DEVICES_STAFF_REVOKE_HINT: 'Staff can no longer sign in on this till until it is registered again with a new code. The till keeps its settings (printer, terminal, language).',
    POS_DEVICES_STAFF_REVOKE_REASON: 'Reason',
    POS_DEVICES_STAFF_REVOKED: 'Staff sign-in revoked for this till.',
    POS_DEVICES_STAFF_REVOKE_FAILED: 'Could not revoke staff sign-in.',
    POS_DEVICES_SAVE_ERROR: 'Could not save device settings',
    POS_DEVICES_LOAD_ERROR: 'Could not load POS devices',
    POS_DEVICES_SURFBOARD: 'Surfboard',
    POS_DEVICES_SECTION_SURFBOARD: 'Surfboard',
    POS_DEVICES_SURFBOARD_MODE: 'Payment mode',
    POS_DEVICES_SURFBOARD_APPSWITCH: 'App switch (CheckoutX)',
    POS_DEVICES_SURFBOARD_TERMINAL_MODE: 'External terminal',
    POS_DEVICES_SURFBOARD_MODE_HINT: 'Not set: the Surfboard payment option the cashier picks decides.',
    POS_DEVICES_SURFBOARD_TERMINAL: 'Surfboard terminal',
    POS_DEVICES_SURFBOARD_TERMINAL_HINT: 'Used in external terminal mode. App switch pays with CheckoutX registered on the register itself.',
    POS_DEVICES_SURFBOARD_NOT_CONFIGURED: 'Surfboard is not set up for this unit',
    POS_DEVICES_SURFBOARD_TERMINAL_NONE: 'None (pick a terminal at each payment)',
    USERS_SUBTITLE: 'Manage POS V2 users, permissions, and register sign-in',
    USERS_ADD: 'Create user',
    USERS_EDIT: 'Edit user',
    USERS_USE_LOGIN: 'Use sign-in in POS',
    USERS_USE_LOGIN_HINT: 'Requires PIN when signing in',
    USERS_TIMEOUT_MINUTES: 'Timeout (minutes)',
    USERS_LOGOUT_TYPE: 'Sign-out type',
    USERS_AUTO_LOGOUT: 'Auto sign-out after inactivity',
    USERS_MANUAL_LOGOUT: 'Sign out manually',
    USERS_SETTINGS_SAVED: 'Sign-in settings saved',
    USERS_SETTINGS_SAVE_ERROR: 'Could not save sign-in settings',
    USERS_FIRST_NAME: 'First name',
    USERS_LAST_NAME: 'Last name',
    USERS_EMPLOYEE_ID: 'Employee ID',
    USERS_PIN: 'PIN code',
    USERS_REFUND: 'Can process refunds',
    USERS_REMOVE_FROM_TAB: 'Can remove items from tab',
    USERS_MAX_DISCOUNT: 'Max discount %',
    USERS_EMPTY: 'No users yet',
    USERS_EMPTY_HINT: 'Create your first POS V2 user',
    USERS_FORM_HINT: 'Enter user details and permissions',
    USERS_FIRST_NAME_REQUIRED: 'First name is required',
    USERS_LAST_NAME_REQUIRED: 'Last name is required',
    USERS_EMPLOYEE_ID_REQUIRED: 'Employee ID is required',
    USERS_EMAIL_REQUIRED: 'Email is required',
    USERS_PIN_REQUIRED: 'PIN is required',
    USERS_PIN_INVALID: 'PIN must be 4–8 digits',
    USERS_EMAIL_INVALID: 'Invalid email address',
    USERS_CREATED: 'User created',
    USERS_UPDATED: 'User updated',
    USERS_DELETED: 'User deleted',
    USERS_LOAD_ERROR: 'Could not load users',
    USERS_SAVE_ERROR: 'Could not save user',
    USERS_DELETE_ERROR: 'Could not delete user',
    USERS_DELETE_HEADER: 'Delete user',
    USERS_DELETE_CONFIRM: 'Are you sure you want to delete this user?',
    USERS_TABLE_TITLE: 'Users',
    USERS_SECTION_PERSONAL: 'Personal details',
    USERS_SECTION_ACCESS: 'Access',
    USERS_SECTION_PERMISSIONS: 'Permissions',
    USERS_TOGGLE_PIN: 'Show or hide PIN',
    USERS_ACTIVE_HINT: 'Inactive users cannot sign in at the POS',
    // Sidebar labels for the POS section (the screens keep their own titles)
    NAV_POS_BUTTON_LAYER: 'POS button layer',
    NAV_POS_DEVICES: 'Devices',
    NAV_POS_ACTIVITY_LOG: 'Activity log',
    POS_SETTINGS: 'Settings',
    POS_SETTINGS_SUBTITLE: 'Configure POS settings for this unit.',
    POS_QUICK_RAIL: 'Quick rail',
    POS_QUICK_RAIL_SUBTITLE: 'Configure the Open Product button shown next to the cart in POS V2.',
    POS_QUICK_RAIL_OPEN_PRODUCTS_ENABLED: 'Enable Open Product button',
    POS_QUICK_RAIL_OPEN_PRODUCTS_ENABLED_HINT: 'Show the Open Product button on the Quick Rail in POS.',
    POS_QUICK_RAIL_OPEN_PRODUCTS: 'Open Products',
    POS_QUICK_RAIL_OPEN_PRODUCTS_HINT: 'Select products from the product register that staff can price manually.',
    POS_QUICK_RAIL_OPEN_PRODUCTS_EMPTY: 'No Open Products selected yet. Add products above.',
    POS_QUICK_RAIL_ADD_PRODUCTS: 'Add products',
    POS_QUICK_RAIL_DELETE_CONFIRM: 'Are you sure you want to remove "{name}"?',
    POS_QUICK_RAIL_SAVED: 'Quick rail settings saved.',
    POS_QUICK_RAIL_SAVE_ERROR: 'Failed to save Quick rail settings. Please try again.',
    POS_QUICK_RAIL_LOAD_ERROR: 'Failed to load Quick rail settings. Please try again.',
    POS_QUICK_MESSAGES: 'Quick messages',
    POS_QUICK_MESSAGES_SUBTITLE: 'Manage quick messages shown in the POS register.',
    POS_QUICK_MESSAGES_PLACEHOLDER: 'Enter a quick message',
    POS_QUICK_MESSAGES_EMPTY: 'No quick messages yet. Add one above.',
    POS_QUICK_MESSAGES_SAVED: 'Quick messages saved.',
    POS_QUICK_MESSAGES_SAVE_ERROR: 'Failed to save quick messages. Please try again.',
    POS_QUICK_MESSAGES_LOAD_ERROR: 'Failed to load quick messages. Please try again.',
    POS_QUICK_MESSAGES_DELETE_CONFIRM: 'Are you sure you want to delete "{message}"?',
    POS_ORDER_MESSAGES: 'Order comment messages',
    POS_ORDER_MESSAGES_SUBTITLE: 'Premade messages staff can pick in the POS order comment, for the whole order.',
    POS_ORDER_MESSAGES_PLACEHOLDER: 'Enter an order comment message',
    POS_ORDER_MESSAGES_EMPTY: 'No order comment messages yet. Add one above.',
    POS_ORDER_MESSAGES_SAVED: 'Order comment messages saved.',
    POS_ORDER_MESSAGES_SAVE_ERROR: 'Failed to save order comment messages. Please try again.',
    POS_ORDER_MESSAGES_LOAD_ERROR: 'Failed to load order comment messages. Please try again.',
    POS_SIGN_IN: 'Sign-in',
    POS_DAY_CLOSE: 'Day close',
    POS_Z_CLOSE_TIME: 'Z-report close time',
    POS_Z_CLOSE_TIME_HINT: 'The time (Swedish time) the business day closes and each register gets its Z-report.',
    POS_Z_CLOSE_TIME_DEFAULT: 'Not set - the day closes at 00:00.',
    POS_Z_CLOSE_TIME_INVALID: 'Enter a time as HH:MM, e.g. 05:00.',
    POS_Z_CLOSE_TIME_SAVED: 'Z-report close time saved',
    POS_Z_CLOSE_TIME_SAVE_ERROR: 'Could not save the Z-report close time',
    POS_TIPPING: 'Tipping',
    POS_TIPPING_SUBTITLE: 'Configure tipping for guest self-service payment.',
    POS_TIPPING_ENABLED: 'Enable tipping',
    POS_TIPPING_ENABLED_HINT: 'Show tip options in the self-service payment app.',
    POS_TIPPING_THRESHOLD: 'Minimum amount',
    POS_TIPPING_THRESHOLD_HINT: 'Tip is shown when the amount to pay is at least this value.',
    POS_TIPPING_SAVED: 'Tipping settings saved.',
    POS_TIPPING_SAVE_ERROR: 'Failed to save tipping settings. Please try again.',
    POS_TIPPING_LOAD_ERROR: 'Failed to load tipping settings. Please try again.',
    ORG_SALES: 'Sales',
    TOTALS: 'Totals',
    POS_REPORTS: 'Settlement report',
    PAYMENTS: 'Payments',
    FINANCE: 'Finance',
    APP_BUTTONS: 'App buttons',
    MFA: 'MFA',
    RECEIPTS: 'Receipts',
    ACCOUNTING_ACCOUNTS: 'Accounting accounts',
    TODAY: 'Today',
    YESTERDAY: 'Yesterday',
    LAST_WEEK: 'Last week',
    APP_OPEN: 'App open',
    APP_CLOSED: 'App closed',
    THIS_MONTH: 'This month',
    LAST_MONTH: 'Last month',
    USER: 'User',
    ORDERS: 'Orders',
    OPEN: 'Open',
    END_OF_DAY: 'End of day',
    ADD_DOMAINS: 'Add domains',
    DELETE_USER_GROUP: 'Delete user group',
    USER_GROUP_DELETED: 'User group deleted',
    USER_GROUP_UPDATED: 'User group updated',
    HISTORY: 'History',
    DELETED: 'Deleted',
    EDIT_CATEGORY_ON_PRODUCTS: 'Edit category on products',
    DELETE_GROUP: 'Delete group',
    ERROR: 'Error',
    CATEGORY_DELETED: 'Category deleted',
    TIP_REPORT: 'Tip report',
    DESC_GENERATE_REPORT:
        'The report is generated into a PDF file that will be automatically downloaded.',
    GENERATING_REPORT: 'Generates the report',
    ERROR_TIP_REPORT:
        'Something went wrong in the generation of the tip report! Try again.',
    COMPANY_NAME: 'Company name',
    EMAIL_NOT_VALID: 'The emailadress is not valid',

    //Banking info traslation
    BANKINFO_HEADER: 'Personal and Bank Details',
    BANKINFO_SUB_HEADER: 'Fill out the form',
    BANKINFO_FIRST_NAME: 'First Name',
    BANKINFO_LAST_NAME: 'Last Name',
    BANKINFO_BUSINESS_NAME: 'Business Name',
    BANKINFO_PHONE_NUMBER: 'Phone Number to CEO',
    BANKINFO_EMAIL: 'Email to CEO',
    BANKINFO_TAX_ID: 'Tax ID',
    BANKINFO_LIST_OF_OWNERS: 'List of Owners',
    BANKINFO_UPLOAD_IDENTIFCATION: 'Upload Identification',
    BANKINFO_ADD_OWNER: 'Add Owners',
    BANKINFO_BANK_NAME: 'Bank Name',
    BANKINFO_BANK_ACCOUNT_NUMBER: 'Bank Account Number',
    BANKINFO_BANK_PROOF: 'Upload Bank ScreenShot',
    BANKINFO_SEND_VERIFICTION: 'Send For Verification',
    MIN_LENGTH: 'min length',

    ZERO_NOTIFICATION: 'No new notifications',
    //************************************* Pdf translation ***********************
    PDF_HEADER: 'Pdf View',
    PDF_DOWNLOAD: 'Download Pdf',
    PDF_FORMAT: 'Select Page Size',
    PDF_TEXT: 'Enter Text',
    PDF_TEXT_COLOR: 'Text Color',
    PDF_BACKGROUND_COLOR: 'Background Color',

    GRIN_HEADER: 'Reusable packaging',
    TAG: 'Tag',
    GRIN_PACKAGES: 'Packaging',
    GRIN_NONE: 'None',
    CAN_ORDER: 'Can order',
    SHOW_IN_APP: 'Show in app',
    SHOW_IN_KIOSK: 'Show in expresskiosk',
    SHOW_IN_WEB: 'Show in weborder',
    SHOW_IN_TAKEAWAY: 'Show for takeaway',
    SHOW_IN_EATHERE: 'Show for pickup at disk',
    SHOW_IN_TABLEORDER: 'Show for tableorder',
    SHOW_IN_DRIVEDELIVERY: 'Show for drive delivery',
    SHOW_IN_FIXEDLOCATION: 'Show for fixed location',
    DELIVERY_PRICE: 'Delivery price',
    DELIVERY_TO_LOCATION_PRICE: 'Delivery to location price',
    STANDARD: 'Standard',
    ADVANCED: 'Advanced',
    ADVANCED_SETTINGS: 'Advanced settings',
    ADD_DESCRIPTION_SHORT: 'Add description short...',
    ADD_DESCRIPTION_LONG: 'Add description long...',
    FILTER_NAME_ID: 'Filter by name or ID',
    VAT_ID: 'VAT Id',
    LAST_30_DAYS: 'Last 30 days',
    DAYS: 'Days',
    WEEKS: 'Weeks',
    MONTHS: 'Months',
    THIS_WEEK: 'This week',
    TOTAL_SALES: 'Total Revenue',
    EDIT_GROUP: 'Edit group',
    ADDON_GROUPS: 'Add-on groups',
    TOTAL_SALES_DAY_BY_DAY: 'Sales Day by Day',
    BAR_CHART_SHORT: 'Bar',
    LINE_CHART_SHORT: 'Line',
    SALES_BY_HOUR: 'Revenue by hour',
    Z_REPORTS: 'Z-reports',
    X_REPORT: 'X-report',
    CREATE_CATEGORY: 'Create category',
    SETTLEMENTNO: 'SettlementNo',
    TIMESTAMP: 'Timestamp',
    RECEIPTNOSTART: 'Receipt no start',
    RECEIPTNOSTOP: 'Receipt no stop',
    TOTALAMOUNT: 'Total Amount',
    SALES_INFO: 'Sales',
    NO_DATA_PERIOD: 'No data found',
    FETCH_DATA_ERROR: 'Error while fetching data.',
    LOADING_DATA: 'Loading data. Please wait',
    DATA: 'Data',
    OCLOCK: 'Hour',
    TOTAL_SALES_HOURLY: 'Total sales by hour',
    TOTAL_SALES_BY: 'Total sales by',
    PAYMENT_METHODS: 'Payment methods',
    DATE_LOWER: 'Date',
    DAY_LOWER: 'day',
    WEEK_LOWER: 'week',
    MONTH_LOWER: 'month',
    NET: 'Net',
    MEDIAN_RECEIPT: 'Median receipt',
    HIGHEST_PURCHASE_RECEIPT: 'Highest purchase receipt',
    HIGHEST_DISCOUNT_RECEIPT: 'Highest discount receipt',
    PRODUCTS_SOLD: 'Products sold',
    PRICE_OPTIONS: 'Price options',
    LARGEST_ORDER: 'Largest order',
    SOURCES: 'Channels',
    EAT_IN_PRICE: 'Eat in price',
    TAKEAWAY_PRICE: 'Takeaway price',
    QR_FOR_SCANNING: 'QR code for scanning',
    BONUS_BUY: 'Bonus buyable',
    BONUS: 'Bonus %',
    LOAD_ALL_USERS: 'Show all users',
    SHOW_USERS: 'Show users',
    INVITED_USERS: 'Invited users',
    USER_NOT_FOUND: 'No user found',
    CONFIRM_USERGROUP: 'Confirm',
    LINK_EXISTING_OFFER: 'Link existing offer',
    CREATE_OFFER: 'Create offer',
    EDIT_OFFER: 'Edit offer',

    EDIT: 'Edit',
    LINK: 'Link',
    GUESTS: 'Guests',
    ORDER_PRINTING: 'Order rules',
    EDIT_USER_GROUP: 'Edit user group',
    EDIT_USER: 'Edit user',
    EDIT_INVOICE: 'Edit invoice',
    ADD_TO_ALL_USERS: 'Add to all users',
    INVOICE_DETAILS: 'Invoice details',
    UNIT_SETTINGS: 'Unit settings',
    INVALID_EMAIL_OR_PASSWORD: 'Invalid email or password',
    INVALID_EMAIL: 'Invalid email',
    ENTER_VALID_EMAIL: 'Please enter a valid email address.',
    TEAM_MEMBERS: 'Team members',
    PRODUCT_DETAILS: 'Product details',
    ADDONS: 'Add-ons',
    ADD_UNIQUE_ADDONS: 'Add unique add-on',

    //Addons Translation
    ADDONS_HEADER: 'Addons',
    NO_ADDONS: 'This product does not yet have any addons',
    APP_INFORMATION: 'App information',
    NAME_IN_APP: 'Name in app',
    DESCRIPTION_IN_APP: 'Description in app',
    LOGO_IN_APP: 'Logo in app',
    NAME_OF_APP: 'Published in app',
    OPEN_AND_CLOSE_APP: 'Open / close the app for ordering',
    RESTRICT_ITEM: 'Restrict this item to one purchase a day',
    DELETE_PRODUCTS: 'Delete Products',
    DISCARD: 'Discard',

    //Weborder Translation
    WEB_ORDER_HEADER: 'Weborder',
    COLOR_HEADER: 'Colors',
    PRIMARY_COLOR_HEADER: 'Primary colors',
    SECONDARY_COLOR_HEADER: 'Secondary colors',
    SUCCESS_COLOR_HEADER: 'Success colors',
    DANGER_COLOR_HEADER: 'Danger colors',
    RESTAURANT_INFO: 'Restaurant info',
    OPEN_HEADER: 'Open',
    CLOSED_HEADER: 'Closed',
    CANCEL_HEADER: 'Cancel changes',
    PUBLISH_HEADER: 'Publish',
    WEBORDER_SETTINGS: 'Weborder',
    FAVICON: 'Favicon (browser tab and search result icon)',
    FAVICON_CHANGE: 'Change favicon',
    FAVICON_REMOVE: 'Remove favicon',
    FAVICON_NOTE: 'Square PNG, at least 48x48 px (192x192 or larger recommended). Use a simple mark such as the restaurant symbol, not the wide logo. Shown in browser tabs and next to the restaurant in Google search results.',
    FAVICON_TOO_SMALL: 'The image is {width}x{height} px. A favicon must be at least {min}x{min} px.',
    FAVICON_NOT_SQUARE: 'This image is {width}x{height} px and not square, so it will look squashed as a favicon. A square version of the logo mark works best. Use it anyway?',
    FAVICON_LOAD_FAILED: 'Could not load the selected image.',

    //ADVANCED SETTINGS FOR APP INFO
    CUSTOM_ORDER_TICKET_MESSAGE: 'Custom order ticket message',
    CUSTOM_ORDER_SHOW_TICKET_MESSAGE:
        'This text will replace the ordinary information on the order ticket for all delivery options',
    QR_VALIDATION_MESSAGE: 'QR code on order ticket',
    CLOSE_ORDER_TICKET_CONFIRMATION_MESSAGE: 'Close order ticket confirmation',
    SHOW_COMMENT_ON_ORDER_MESSAGE: 'Show comment field on order',
    SHOW_COMMENT_ON_PRODUCT_MESSAGE: 'Show comment field on product',
    ADVANCE_SETTINGS_SAVED: 'Advanced settings saved',
    MENU_STYLE_TEXT: 'Menu style',

    //PUSH NOTIFICATIONS HISTORY
    SEND_AGAIN: 'Send again',
    //MENU NAVIGATION
    MENU_NAV_HOME: 'Home',
    MENU_NAV_APP: 'App',
    MENU_NAV_COMMUNICATION: 'Communication',
    MENU_NAV_OPENCLOSE: 'Open & close',
    FINANCE_EXPORTS_API: 'Finance export setup',
    TCPOS_CREDENTIALS: 'Tcpos credentials',
    TOKEN: 'Token',
    UNIT_ID: 'Unit id',
    CATEGORY_TEXT_DESCRIPTION:
        'These subcategories and products will be visible in this app when the menu is active.',
    SUBCATEGORYGROUPS_HEADER: 'Sub categories',
    SUBCATEGORYGROUPS_TEXT_DESCRIPTION:
        'Tie existing subcategory groups to the menu or create a new one.',
    ADD_SUBCATEGORYGROUP: 'Create',
    ADD_TO_MENUS: 'Add to Menus',
    MINIMUM_VALUE_REQUIRED: 'Minimum value required',
    MAXIMUM_VALUE_REQUIRED: 'Maximum value required',
    MINIMUM_CANNOT_BE_GREATER_THAN_MAXIMUM:
        'Minimum cannot be greater than maximum',
    MAXIMUM_CANNOT_BE_LESS_THAN_MINIMUM: 'Maximum cannot be less than minimum',
    BONUS_POINTS_UPDATED: 'Bonus points updated',
    EDIT_PRODUCT: 'Edit Product',
    EDIT_SELECTED_PRODUCTS: 'Edit selected products',
    RENAME: 'Rename',
    MINIMUM_BONUS_REQUIRED: 'Minimum bonus required',
    //GUEST INFORMATION
    SHOW_MORE: 'Show more',
    ADJUST_AMOUNT: 'Adjust amount',
    CARD_DETAILS: 'Card Details',
    APPLY_FILTER: 'Apply filter',
    TOTAL_SAVED_CARDS: 'Total Saved Cards',
    FILTER_RESULT: 'Filter result',
    START_DATE: 'Start date',
    END_DATE: 'End date',
    ADJUST: 'Adjust',
    RECEIPT_DETAILS: 'Receipt Details',
    ORDER_TEXT: 'Order',
    INVOICE_TEXT: 'Invoice',
    INVOICE_DATE: 'Invoice Date',
    RECEIPT_NO: 'Receipt No',
    PHONE_NO: 'Phone No',
    QTY: 'Qty',
    RATE: 'Rate',
    LINE_TOTAL: 'Line Total',
    CODE_TEXT: 'Code',
    CONNECT_SOCIAL_MEDIA: 'Link to your social media profiles in the app',
    ALLERGEN_INFORMATION_DESCRIPTION:
        'Enter your unit’s contact details to display in the app where guests can turn with allergy questions',
    MANAGE_ADVANCED_SETTINGS: 'Manage the unit’s more advanced settings',
    KUNIT_TEXT: 'K.unit',
    SUBTOTAL: 'Subtotal',
    DELIVERY_FEE: 'Delivery Fee',
    COUPON_CODE_INPUT_FIELD: 'Enable coupon code field',
    CLOSE_ORDER_TICKET_CONFIRMATION_DESCRIPTION:
        'Ask the guest for extra confirmation before redeeming the order ticket',
    MENU_STYLE_DESCRIPTION: 'Choose layout for unit’s app menu',
    SHOW_COMMENT_ON_ORDER_DESCRIPTION: 'Allow comment on the entire order',
    SHOW_COMMENT_ON_PRODUCT_DESCRIPTION: 'Allow comment at product level',
    COUPON_CODE_DESCRIPTION:
        'Show the coupon code field in the app so guests can apply coupon codes',
    DISCOUNT: 'Discount',
    SEARCH_NAME_OR_TAG: 'Search by name or tag',
    GROSS: 'Gross',
    CARD_IN_APP: 'Card in app',
    TOTAL_SAVED_RECEIPTS: 'Total Saved Receipts',
    TOTAL_SAVED_BONUS_POINTS: 'Total Saved Points',
    TOTAL_SAVED_WALLETS: 'Total wallet transactions',
    TRANSACTIONS_NOT_FOUND: 'Transactions not found',
    AMOUNT_TO_ADJUST: 'Amount to adjust',
    POINTS: 'Points',
    ADJUST_WALLET: 'Adjust balance',
    ADJUST_BONUS: 'Adjust Bonus',
    ADJUST_BONUS_ERROR: 'Unable to adjust bonus. Please try again later.',
    ADJUST_WALLET_ERROR: 'Unable to adjust balance. Please try again later.',
    FEATURED_PRODUCT: 'Featured product',
    FEATURED_PRODUCT_DESC:
        'This product will be featured on the units start page in the app and can only be purchased using the "Eat in" serving method. Would you like to proceed?',

    FIELDS_MISSING_ERROR: 'Please fill all required fields.',

    //UNIT-LIST PAGE
    SHOW_ALL: 'Show all',
    UNIT_SWITCHER_SEARCH_UNITS: 'Search units by name or ID',
    UNIT_SWITCHER_SELECT: 'to select',
    UNIT_SWITCHER_OPEN: 'to open',
    UNIT_SWITCHER_CLOSE: 'to close',
    UNIT_SWITCHER_NO_RESULTS: 'No units found',
    CHOOSE_UNIT: 'Select unit',
    UNIT_NAME: 'Unit name',
    COMPANY: 'Company',
    TOTAL_DISCOUNT: 'Total discount',

    //MISSING-PARAMETERS-PAGE
    MISSING_TEXT:
        'Some products in the product register are missing a bong or product category. This may cause them to not function as expected in the app. Please review and update to ensure smooth operation.',
    NOT_SELECTED: 'Not selected',
    EDIT_ALL: 'Bulk edit',
    PERCENT: 'Increase or Decrease price by percentage',

    //USERGROUP Page

    SEARCH_BY_EMAIL: 'Search by email',
    ADD_USER_TO_USERGROUP: 'Add new member',
    SEARCH_MEMBER: 'Search member',
    ADD_MEMBER: 'Add member',
    NO_USER_WITH_EMAIL: 'Could not find any user with that email address',

    SELF_SERVICE_KIOSK: 'Self-service kiosk',
    DEFAULT_LANGUAGE: 'Default language',
    START_SCREEN_IMAGE: 'Start screen image',
    ADDED_TO_MENU: 'Added to menu',
    NOT_ADDED_TO_ANY_MENU: 'Not added to any menu',
    APP_MENUS: 'App menus',
    NOT_IN_ANY_APP_MENU: 'Not in any app menu',
    NOT_IN_ANY_POS_MENU: 'Not in any POS menu',
    BANNER_IN_KIOSK: 'Banner in kiosk',
    SHOW_MEMBERSHIP_REGISTRATION_KIOSK: 'Membership registration',
    SHOW_MEMBERSHIP_REGISTRATION_KIOSK_DESCRIPTION: 'Show membership registration button on kiosk',
    SHOW_MEMBERSHIP_REGISTRATION_KIOSK_HELP: 'When enabled, customers can register their membership (stamp card) via QR scan on the kiosk. Turn off to hide this option.',
    KIOSK_FONTS: 'Fonts',
    KIOSK_FONTS_DESCRIPTION: 'Choose one font for titles and headings, and one for body text. Both are loaded from Google Fonts.',
    FONT_HEADING: 'Titles & headings font',
    FONT_BODY: 'Body text font',
    FONT_PREVIEW: 'Preview',
    FONT_PREVIEW_HEADING: 'Welcome',
    FONT_PREVIEW_BODY: 'The quick brown fox jumps over the lazy dog.',
    FONT_PREVIEW_HEADING_LABEL: 'Heading',
    FONT_PREVIEW_BODY_LABEL: 'Body',
    FONT_USE_SAME_AS_HEADING: 'Use same as heading',
    FONT_FILTER_PLACEHOLDER: 'Search fonts...',
    SELECT_FONT: 'Select a font',
    SLIDER_INTERVAL: 'Slider Interval (seconds)',
    SLIDER_INTERVAL_PLACEHOLDER: 'Enter interval in seconds',
    SLIDER_INTERVAL_DESCRIPTION: 'Time before switching to next image (1-60 seconds)',
    IMAGE_NUMBER: 'Image',
    MOVE_UP: 'Move Up',
    MOVE_DOWN: 'Move Down',
    PREVIEW_IMAGE: 'Preview Image',
    HEADER_IMAGE: 'Header image',
    SELECT_START_SCREEN_IMAGE: 'Select Start Screen Image',
    SELECT_HEADER_IMAGE: 'Select Header Image',
    SELECT_LANGUAGE: 'Select Language',
    SELECT_TEXT_ALIGN: 'Select textAlign',
    SELECT_COLOR: 'Select Color',
    KIOSK_NOT_CONFIGURED: "You can't change the start screen image for the self-service kiosk on this unit",
    KIOSK_DEVICE_CONFIG: 'Kiosk device configuration',
    USE_CUSTOM_START_SCREEN_IMAGES: 'Use custom start screen images for this device',
    KIOSK_NO_DEVICE_REGISTERED: 'No kiosk device registered for this unit. Register the device from the kiosk app first (enter route and unit name).',
    ROUTE: 'Route',
    ROUTE_PLACEHOLDER: 'Enter route name',
    MULTIPLE_ROUTES: 'Multiple routes',
    MULTIPLE_ROUTES_PLACEHOLDER: 'Comma-separated routes',
    NAME_PLACEHOLDER: 'Name',
    MODEL: 'Model',
    MODEL_PLACEHOLDER: 'Model',
    MENU_CODE: 'Menu code',
    CODE_PLACEHOLDER: 'Code',
    SOFTPOS: 'SoftPOS',
    SOFTPOS_CURRENCY: 'SoftPOS currency',
    SOFTPOS_INTEGRATION_ID: 'SoftPOS integration ID',
    SOFTPOS_INTEGRATION_PASSWORD: 'SoftPOS integration password',
    SAVE_DEVICE_CONFIG: 'Save device configuration',
    SELECT_DEVICE: 'Select device',
    PRINTER: 'Printer',
    CARD_TERMINAL: 'Card terminal',
    AVAILABLE_TERMINALS: 'Available terminals',
    NO_TERMINALS_FOUND: 'No terminals found',
    LOADING: 'loading',
    BANNER_TITLE: 'Title',
    BANNER_MESSAGE: 'Message',
    TEXT_ALIGN_TEXT: 'Text align',
    COLOR_THEME_TEXT: 'Color theme',
    ROLE: 'Role',
    ADMINISTRATOR: 'Admin',
    TCPOS_PORT: 'TCPOS port',

    //TEAMS PAGE FOR RESET PASSWORD
    RESETPASSWORD: 'Reset password',

    //NEWS PAGE COLORPICKER
    TITLE_TEXT_COLOR: 'Title and text color',

    //FEATURED_PRODUCT SORT ORDER
    FEATURED_PRODUCTS: 'Featured products',
    EMAIL_REPORT: 'Email report',

    //MORE NEWS ITEM TRANSLATIONS
    HAS_BACKGROUND_TEXT: 'Has background',
    SHOW_BADGE_TEXT: 'Show badge',
    ADD_COLOR: 'Add color...',
    EDIT_ACCOUNT: 'Edit accounting',

    //ADDONS REWORD PRODUCT TRANSLATIONS
    ADD_ADDONS: 'Add addons',
    NO_ADDONS_GROUP: 'No addons group',
    ADD_ADDONS_GROUP_TO_PRODUCT: 'Add addons group to product',
    NO_ADDONS_IN_GROUP: 'There are no addons created yet',
    SELECT_ONE: 'Select One',
    SELECT_MULTIPLE: 'Select Multiple',
    DELETE_ADDON: 'Delete addon',
    EDIT_MENU_NAME: 'Edit menu name',
    PASSWORD_UPDATED: 'Password updated',
    PENDING_REFUNDS: 'Pending refunds',
    DOWNLOAD_AS_PDF: 'Download as PDF',
    ADD_TO_UNITS: 'Add to units',
    APPLY_DEFAULT_ROLE: 'Apply Default role',
    SELECT_MORE_UNITS: 'Select more units',
    SELECT_UNITS: 'Select units',
    CHOOSE_ORGANIZATION_UNITS: 'Choose organization units',
    RECEIPT_NUMBER: 'Receipt',
    RECEIPT_TYPE: 'Type',
    SALES_CHANNEL: 'Sales channel',
    CUSTOMER_NAME: 'Customer',
    ORDER_NUMBER: 'Order',
    TRANSACTIONS_MENU: 'Transactions',
    SEARCH_RECEIPT: 'Search receipt number',
    RECEIPT_PURCHASE: 'Purchase',
    RECEIPT_REFUND: 'Refund',
    EMAIL_RECEIPT: 'Email receipt',
    PURCHASE_AT: 'Purchase at',
    SUMMARY: 'Summary',
    EXTRA: 'Extra',
    REFUND: 'Refund',
    REFUND_SELECTED_ROW: 'Refund selected row',
    REFUND_PAYMENT: 'Refund payment',
    PRODUCTS_TO_REFUND: 'Products to refund',
    SELECT_REASON: 'Select a reason',
    NOTE: 'Note',
    ADD_NOTE_DETAILS: 'Add more details about this refund.',
    REFUND_REASON_DUPLICATE: 'Duplicate',
    REFUND_REASON_FRAUDULENT: 'Fraudulent',
    REFUND_REASON_CUSTOMER_REQUEST: 'Request by customer',
    REFUND_REASON_OTHER: 'Other',
    REFUND_BONUS_POINTS: 'Refund bonus points',
    BONUS_POINTS_REFUND: 'Bonus Points Refund',
    BONUS_SUMMARY: 'Bonus Summary',
    AMOUNT_TO_REFUND: 'Amount to Refund',
    ENTER_BONUS_AMOUNT: 'Enter bonus amount to refund',
    BONUS_REFUND_AMOUNT: 'Bonus amount to be refunded',
    NO_BONUS_REMAINING: 'No bonus points remaining to refund',
    ENTER_BONUS_POINTS_TO_REFUND:
        'Enter the amount of bonus points to refund (if applicable).',
    REASON_MUST_BE_SELECTED: 'Please select a refund reason',
    NOTE_REQUIRED_FOR_OTHER:
        'Note is required when "Other" is selected as reason',
    REFUND_AMOUNT_INVALID: 'Refund amount must be greater than 0',
    REFUND_AMOUNT_EXCEEDS_TOTAL:
        'Refund amount cannot exceed the original receipt amount',
    BONUS_REFUND_EXCEEDS_ORIGINAL:
        'Bonus points refund cannot exceed the original bonus payment amount',
    BONUS_REFUND_EXCEEDS_REMAINING:
        'Bonus points refund cannot exceed the remaining bonus amount',
    ORIGINAL_BONUS: 'Original Bonus',
    ALREADY_REFUNDED: 'Already Refunded',
    REMAINING: 'Remaining',
    //MFA SETTINGS
    TWO_FACTOR_AUTHENTICATION: 'Two-Factor Authentication',
    TWO_FACTOR_AUTHENTICATION_ACTIVE: '2FA Active',
    TWO_FACTOR_AUTHENTICATION_INACTIVE: '2FA Inactive',
    TWO_FACTOR_AUTHENTICATION_SETUP: 'Setup TOTP 2FA',
    TWO_FACTOR_AUTHENTICATION_REMOVE: 'Remove 2FA',
    SECURE_YOUR_ACCOUNT: 'Secure Your Account',
    ENABLE_TWO_FACTOR_AUTHENTICATION:
        'Enable two-factor authentication to add an extra layer of security to your account',
    PROTECT_YOUR_ACCOUNT:
        'Protect your account even if your password is compromised',
    ENHANCED_SECURITY: 'Enhanced Security',
    MULTIPLE_OPTIONS: 'Multiple Options',
    QUICK_SETUP: 'Quick Setup',
    GET_STARTED_IN_JUST_A_FEW_MINUTES_WITH_OUR_GUIDED_SETUP:
        'Get started in just a few minutes with our guided setup',
    CHOOSE_YOUR_SETUP_METHOD: 'Choose Your Setup Method',
    RECOMMENDED: 'Recommended',
    SMS_AUTHENTICATION: 'SMS Authentication',
    AUTHENTICATOR_APP: 'Authenticator App',
    CURRENT_STATUS: 'Current Status',
    ACTIVE_METHODS: 'Active Methods',
    PRIMARY_METHOD: 'Primary Method',
    RECEIVE_VERIFICATION_CODES_VIA_TEXT_MESSAGE:
        'Receive verification codes via text message. Fast and convenient for most users.',
    USE_APPS_LIKE_GOOGLE_AUTHENTICATOR_OR_AUTHY_FOR_ENHANCED_SECURITY:
        'Use apps like Google Authenticator or Authy for enhanced security.',
    WORKS_OFFLINE: 'Works offline',
    INDUSTRY_STANDARD: 'Industry standard',
    SETUP_SMS_2FA: 'Setup SMS 2FA',
    SETUP_TOTP_2FA: 'Setup TOTP 2FA',
    SET_AS_PRIMARY: 'Set as Primary',
    NOTICE: 'Notice',
    SECURITY_NOTICE_DESCRIPTION:
        'You must have at least one 2FA method enabled at all times. If you have only one method active, you cannot disable it until you add another method.',
    SECURITY_NOTICE_DESCRIPTION2:
        'In order to manage or disable an alternate 2FA method, you must first re-authenticate by logging in using that specific method.',
    ADD_CHANGE_PHONE_NUMBER: 'Add/Change Phone Number',
    ENTER_PHONE_NUMBER_WITH_COUNTRY_CODE:
        'Enter your phone number with country code (e.g., +1 for US/Canada, +44 for UK)',
    SENDING_VERIFICATION_CODE: 'Sending verification code...',
    SET_UP_AUTHENTICATOR_APP: 'Set Up Authenticator App',
    SCAN_QR_CODE_WITH_GOOGLE_AUTHENTICATOR_OR_ANOTHER_TOTP_APP:
        'Scan this QR code with Google Authenticator or another TOTP app:',
    MISSING_2FA_TEXT:
        'You are missing a 2FA code. Please enter a code to continue.',
    MANAGE_YOUR_2FA_METHODS: 'Manage your 2FA methods',
    REMOVE_2FA: 'Remove 2FA',
    ENABLED: 'Enabled',
    DISABLED: 'Disabled',
    RECEIVE_VERIFICATION_CODES_VIA_TEXT_MESSAGE_FAST_AND_CONVENIENT_FOR_MOST_USERS:
        'Receive verification codes via text message. Fast and convenient for most users.',
    CHOOSE_FROM_SMS_AUTHENTICATOR_APPS_OR_EMAIL_VERIFICATION:
        'Choose from SMS Authenticator App or Email Verification',
    HIGHEST_SECURITY: 'Highest Security',
    NO_APP_INSTALLATION: 'No app installation',
    WORKS_ON_ANY_PHONE: 'Works on any phone',
    AUTHENTICATION: 'Authentication',
    ENTER_VERIFICATION_CODE: 'Enter Verification Code',
    SENT_6_DIGIT_VERIFICATION_CODE:
        "We've sent a 6-digit verification code to your phone number",
    VERIFICATION_CODE: 'Verification Code',
    DIDNT_RECEIVE_THE_CODE: "Didn't receive the code?",
    HAVING_TROUBLE: 'Having trouble?',
    SWITCH_TO: 'Switch to',
    REMEMBER_THIS_DEVICE_FOR_30_DAYS: 'Remember this device for 30 days',
    VERIFYING_CODE: 'Verifying code...',
    VERIFY: 'Verify',
    ENTER_6_DIGIT_CODE_FROM_AUTHENTICATOR_APP:
        'Enter the 6-digit code from your authenticator app',
    TWO_FACTOR_AUTHENTICATION_MUST_BE_ENABLED_BY:
        'Two-factor authentication (2FA) must be enabled by',
    SETUP_2FA: 'Setup 2FA',
    SETUP_AUTHENTICATOR: 'Setup Authenticator',
    ADD_PHONE: 'Add Phone',
    RECONFIGURE: 'Reconfigure',
    RESEND_CODE: 'Resend code',
    RESENDING: 'Resending',
    MESSAGE_REQUIRED: 'Message is required ',
    TITLE_REQUIRED: 'Title is required',
    MIN_3_CHARS: 'Minimum 3 characters required',
    SELECT_ROLE: 'Select role',
    NO_ADDONS_YET: 'No addons created yet',
    PRINT_ONE_BY_ONE: 'Print items one by one',

    //Printers Translation
    PRINTERS: 'Printers',
    PRINTER_MANAGEMENT: 'Printer Management',
    UPDATE_PRINTER_LIST: 'Update printer list',
    TOTAL_PRINTERS: 'Total printers',
    DEFAULT_PRINTER: 'Default printer',
    NETWORK_STATUS: 'Network status',
    CONNECTED: 'Connected',
    LOADING_PRINTERS: 'Loading printers...',
    AVAILABLE_PRINTERS: 'Available printers',
    DEFAULT: 'Default',
    ONLINE: 'Online',
    SHOW_OPTIONS: 'Show options',
    NO_PRINTERS_FOUND: 'No printers found',
    ADD_FIRST_PRINTER_MESSAGE: 'Add your first printer to get started.',
    ADD_PRINTER: 'Add printer',
    ADD_NEW_PRINTER: 'Add new printer',
    SET_AS_DEFAULT: 'Set as default',
    DEACTIVATE: 'Deactivate',
    PRINTER_ADDED: 'Printer added successfully',
    PRINTER_NAME: 'Printer name',
    ENTER_PRINTER_NAME: 'Enter printer name',
    MAC_ADDRESS: 'MAC address',
    ENTER_MAC_ADDRESS: 'Enter MAC address',
    DELETE_PRINTER: 'Delete printer',
    DELETE_PRINTER_QUESTION: 'Are you sure you want to delete this printer?',
    PRINTER_TEXT: 'Configure and manage receipt printers',

    //Printer Translation
    MEMBER_ADDED: 'Member Added',
    DO_YOU_REALLY_WANT_TO_DELETE_USER_GROUP:
        'Do you really want to delete this user group?',
    AT_LEAST_ONE_SERVING_METHOD_REQUIRED:
        'atleast one serving method is required',
    AT_LEAST_ONE_CRITERIA_REQUIRED: 'atleast one criteria is required',
    DISCOUNT_TYPE: 'Discount Type',
    DESCRIPTION_REQUIRED: 'Description required',
    DISCOUNT_PERCENT_REQUIRED: 'Discount percent required',
    DISCOUNT_AMOUNT_REQUIRED: 'Discount amount required',
    DISCOUNT_AMOUNT: 'Discount amount',
    EMAIL_REQUIRED: 'Email is required',
    USER_ALREADY_INVITED_INVITE_AGAIN:
        'User is already invited. Do you want to invite again?',
    MANUAL_EMPLOYEE_ID: 'Employee ID',
    MANUAL_TAG_ID: 'Tag ID',
    ENTER_MANUAL_TAG_ID: 'Enter tag ID',
    ENTER_MANUAL_EMPLOYEE_ID: 'Enter employee ID',
    ADD_MANUAL_USER: 'Add user',
    MANUAL_ENTRY: 'Manual entry',
    LAST_EDITED: 'Last edited',
    SOMETHING_WENT_WRONG_WHILE_ADDING_DOMAIN:
        'Something went wrong while adding the domain',
    USER_INVITED: 'User invited',
    COULD_NOT_INVITE_USER: 'Could not invite user',
    USER_INVITED_AGAIN: 'User invited again',
    ADD_CRITERIA: 'Add Criteria',
    ALREADY_MEMBER: 'Already a member',
    DOMAIN_ALREADY_ADDED: 'Domain already added',
    INVALID_DOMAIN_FORM: 'Invalid domain format',
    ONE_CATEGORY_MINIMUM: 'You need to have at least one category',
    ALERT: 'Alert',
    CLOSE: 'Close',
    CATEGORIES_DESCRIPTION:
        'Create product and bong categories for your products.',
    CATEGORY: 'Category',
    TABLE: 'Table',
    SERVING_OPTIONS_DESCRIPTION:
        'Select which serving methods should be available in the sales channels',
    ENABLE_SERVING_METHOD: 'Manage serving methods',
    ENABLE_SERVING_METHOD_DESCRIPTION:
        'When a serving method is enabled, guests in your sales channels can select it as an option when placing an order.',
    DELIVERY_OPTIONS: 'Delivery options',
    DELIVERY_OPTIONS_DESCRIPTION:
        'There are two types of delivery options. One allows you to define fixed delivery locations (for example, a specific building or spot), while the other makes it possible to deliver directly to customers’ own addresses.',
    EATIN_DESCRIPTION: 'Allow guests to order for dining in',
    TAKEAWAY_DESCRIPTION: 'Allow guests to order for pickup at the restaurant',
    TABLE_SERVING_DESCRIPTION: 'Allow guests to order directly to the table',
    SEAT_SERVING_DESCRIPTION: 'Allow guests to order directly to the seat',
    WORKPLACE_DELIVERY_DESCRIPTION:
        'Delivery to fixed locations, e.g. buildings or office departments',
    HOME_DELIVERY_DESCRIPTION: 'Delivery to customer addresses',
    UNABLE_TO_SAVE: 'Unable to save changes',
    THIS_MENU_DELETED: 'This menu has been deleted',
    QR_ON_TICKET_TEXT:
        'Add a QR code to the guests order ticket to enable order validation using a scanner',
    PUBLISH_BANNER_TEXT:
        'Publish a message on the units home screen in the app to share information with guests.',
    TYPE_MESSAGE: 'Type a message',
    TEAM_MEMBERS_DESCRIPTION: 'Manage team members roles and user permissions',
    //PRODUCT
    EAN_CODE: 'EAN Code',
    EAN: 'EAN',
    RECEIPT: 'Receipt',
    CONTROL_UNIT: 'Control unit',
    MARK_AS_WRONG_HIT: 'Do you want to mark this receipt as wrong hit?',
    RECEIPT_DOWNLOADED: 'Receipt downloaded',
    RECEIPT_DOWNLOAD_FAIL: 'Failed to download receipt',
    RECEIPT_UPDATED: 'Receipt updated',
    FAILED_TO_EMAIL_RECEIPT: 'Failed to email receipt to ',
    RECEIPT_EMAILED_TO: 'Receipt sent to ',
    PREPARING_EXPORT: 'Preparing export',
    HOW_MANY: 'How many?',
    HOW_MANY_REFUND: 'How many do you want to refund?',
    REFUND_IN_PROGRESS: 'Refund in progress',
    ENTER_PIN: 'Enter pin code',
    DOWNLOAD_QR: 'Download QR code',
    INVITATION_SENT: 'Invitation sent',
    SENT: 'Sent',
    SENT_AT: 'Sent at',
    READERS_LIST: 'Readers List',
    READ: 'Read',
    TOTAL_READS: 'Total reads',
    TOTAL_SEND: 'Total send',
    ANONYMOUS_READERS: 'Anonymous Readers',
    PIN_CODE: 'PIN Code',
    ADD_PIN_CODE: 'Add PIN-code',

    REMOVE_ADDON_OPTIONS_APPROVAL:
        'Do you want to remove this option from the group?',
    DEL_CONFIRMATION: 'Delete confirmation',
    OPT_GROUP_UPDATED: 'The option group has been updated.',
    WARN_ONE_ADDON_OPTION: 'At lease one addon option is compulsory.',
    REMOVE_ADDON_OPTIONS_GROUP_APPROVAL:
        'Are you sure you want to delete this option group?',
    OPT_GROUP_REMOVED: 'Option group has been removed.',
    OPT_GROUP_CREATED: 'The option group has been created.',
    ARE_YOU_SURE_REMOVE_USER_FROM_GROUP:
        'Are you sure you want to remove this user from the group?',
    YES_REMOVE: 'Yes, remove',
    ADDED_TO_GROUP: 'Added to user groups.',
    REMOVED_USER_FROM_GROUP: 'Removed user from group.',
    FAILED_TO_REMOVE_USER_FROM_GROUP: "Failed to remove user from group.",
    FAILED_TO_ADD_USER_TO_GROUP: "Failed to add user to group.",
    EDIT_INFORMATION: "Edit Information",
    PROFILE_UPDATED: "Profile updated successfully.",
    PRODUCT_REGISTER: 'Product Register',
    NO_PRODUCTS_FOUND: 'No products found',
    NAME_AND_TAGS: 'Name & tags',
    IMAGE: 'Image',
    SUBCATEGORIES: 'Subcategories',
    TIME_SCHEDULED: 'Time scheduled',
    EDIT_NAME: 'Edit name',
    PRODUCT_ADDED_TITLE: 'Added',
    PRODUCT_REMOVED_TITLE: 'Removed',
    HANDLE_MENUS: 'Handle menus',
    HANDLE_MENUS_TEXT:
        'Manage your menus and subcategories here – create new ones or edit existing ones',
    MENU_LIST: 'Menu list',
    MENU_LIST_TEXT: 'Create and adjust your menus',
    DELETE_SUBCATEGORY_Q:
        'Deleting the global subcategory will delete it from all the menus it belongs to. Are you sure you want to delete?',
    MANAGE_SUBCATEGORIES: 'Manage subcategories',
    CREATE_DRINK_CATEGORY: 'Create a subcategory for drink',
    CREATE_FOOD_CATEGORY: 'Create a subcategory for food',
    ADD_DRINK_CATEGORY: 'Add subcategory to drink',
    ADD_FOOD_CATEGORY: 'Add subcategory to food',
    CATEGORY_TYPE: 'Category',
    SELECT_SUBCATEGORY: 'Select subcategory',
    CREATE_NEW: 'Create new',
    ADD_EXISTING: 'Add existing',
    EDIT_SUBCATEGORY: 'Edit subcategory',
    VISIBLE_IN_KIOSK: '(visible in kiosk)',
    IMAGE_REQUIRED: 'Image required',
    PRODUCTS_REMOVED: 'Products removed',
    INVITE_USER_ERROR: 'Something went wrong while inviting the user.',
    DELIVERY_OPTIONS_MENU: 'Select serving method for the menu',
    DELIVERY_OPTIONS_MENU_EXPLANATION:
        'When this menu is visible in the app, these serving methods will be enabled.',
    NO_DRINK_CATEGORIES: 'No drink categories have been created yet.',
    NO_FOOD_CATEGORIES: 'No food categories have been created yet.',
    ADD_CATEGORY: 'Add category',
    NO_SUB_NO_PRODS:
        'contains no products. Remove the subcategory or add products.',
    MENU_ACTIVATE_ERROR:
        "Oops! Something went wrong and the menu didn't activate.",
    PIN_CODE_ADDED: 'Menu pin code added successfully',
    FEATURED_LIST_REORDERED: 'Menu Featured products list reordered.',

    //RECEIPT

    WRONG_PIN: 'Wrong pin, try again',
    REFUNDED: 'Refunded',
    REFUNDED_RECEIPT: 'Refunded receipt',
    RECEIPT_ALREADY_REFUNDED: 'Receipt already refunded',
    RECEIPT_ALREADY_PARTIALLY_REFUNDED: 'Receipt already partially refunded',
    USERS_NOT_ALLOWED_TO_REPURCHASE:
        'Users are not allowed to make repurchases',
    RECEIPT_LINE_ALREADY_REFUNDED: 'Receipt line already refunded',
    CONTACT_SUPPORT: 'Contact support with this receipt number',
    USERS_NOT_ALLOWED_TO_MARK_AS_CORRECTION: 'Users are not allowed to mark typos',
    REMAINING_ATTEMPTS: 'Remaining attempts',
    CONFIRM_PIN_SUBMIT: 'Confirm PIN to submit a total refund',
    CONFIRM_PIN_PARTIAL_REFUND: 'Confirm PIN to refund selected products',
    REFUNDS: 'Refunds',
    REASON_FOR_REFUND: 'Reason for refund',
    PROCEED: 'Proceed',
    NO_REFUND_RECEIPT_FOUND: 'No refund receipt found',
    NO_RECEIPT_FOUND: 'No receipt found',
    REPURCHASE: 'Repurchase made on receipt',
    RECEIPT_NOT_FOUND: "Couldn't find receipt with number",
    FAILED_TO_REFUND_RECEIPT: 'Failed to refund receipt',
    COLLECTIVE_DISCOUNT: 'Collective discount',
    SMOOTHING: 'Ear smoothing',
    REASON_MUST_BE_FILLED_IN: 'Reason must be filled in',
    REFUNDED_BY: 'Refunded by',
    ERROR_RECEIPT:
        'Something went wrong while retrieving your receipts. Please try again later.',
    NO_PRODUCT_EXTERNAL_ID:
        'You need to add an External ID to this product before you can add it to a menu. Go to the product list and update your product.',
    NO_EXTERNAL_ID_HEADER: 'External ID is missing',

    //EAN
    INVALID_EAN:
        'EAN must contain only digits and be between 8 and 14 characters long.',
    //EAN

    ASSIGN_TO_STEP: 'Assign to step',
    ENABLE_STEP_BY_STEP_FLOW: "The attached addons will be removed. Do you still want to enable the step by step flow?",
    DISABLE_STEP_BY_STEP_FLOW: "The attached addons will be removed. Do you still want to disable the step by step flow?",
    STEP_HEADER: 'Header',
    STEP_SUB_HEADER: 'Subheader',
    ADD_TITLE: 'Add title...',
    ADD_DESCRIPTION: 'Add description...',
    NO_ADDONS_IN_STEP: 'This product has no addons in this step.',
    DELETE_STEP: 'Delete step',
    LIST_VIEW_TEXT:
        'List view is the default mode and displays add-ons in organized list on the product page.',
    STEP_BY_STEP_VIEW_TEXT:
        'Step-by-step mode presents add-ons in a sequential process on the product page.',
    DISABLE_NAME_PRODUCT: 'Disable "Name your product" step',
    DISABLE_NAME_PRODUCT_TEXT: 'The final naming step will be skipped for this product in all channels.',
    ADD_STEP: 'Add step',
    SERVING_METHODS: 'Serving methods',
    SERVING_METHOD_EAT_IN: 'Eat in',
    SERVING_METHOD_TAKEAWAY: 'Takeaway',
    SERVING_METHOD_TABLE: 'Table serve',
    SERVING_METHOD_HOME_DELIVERY: 'Home delivery',
    SERVING_METHOD_FIXED_LOCATION: 'Fixed location',
    UNASSIGN: 'Unassign',
    REFUND_REASON_LABEL: 'Write the reason for the refund, max 200 characters',

    CATERING: 'Catering',
    CATERING_PRODUCT_LIST: 'Catering product list',
    CATERING_PRODUCT_LIST_DESCRIPTION: "Manage, update, and organize your catering products.",
    CATERING_SETTINGS_TITLE: 'Catering settings',
    CATERING_SETTINGS_SUBTITLE: "Manage the unit's catering settings",
    CATERING_PICKUP_TAB: 'Pickup',
    CATERING_DELIVERY_TAB: 'Delivery',
    CATERING_ADDITIONAL_SETTINGS_TAB: 'Additional settings',
    CATERING_PICKUP_INSTRUCTIONS_TITLE: 'Pickup instructions',
    CATERING_PICKUP_INSTRUCTIONS_DESCRIPTION:
        'These are the instructions for customers to follow when picking up their catering order. They will appear on both the catering webpage and in the confirmation email.',
    CATERING_PICKUP_INSTRUCTIONS_PLACEHOLDER: 'Pick up at main reception',
    CATERING_PICKUP_INSTRUCTIONS_MAX_LENGTH: 'Pickup instructions must be 100 characters or fewer.',
    CATERING_PICKUP_INSTRUCTIONS_SAVED: 'Successfully saved pickup data.',
    CATERING_PICKUP_INSTRUCTIONS_SAVE_ERROR: 'Failed to save pickup data.',
    CATERING_PICKUP_INSTRUCTIONS_LOAD_ERROR: 'Failed to load pickup instructions.',
    CATERING_SETTINGS_TAB_PLACEHOLDER: 'Additional catering settings will appear here soon.',
    PRODUCT_CREATED: "Product created.",
    // Catering Orders
    CATERING_ORDERS_DESCRIPTION: "Manage and track all catering orders from the catering webapp",
    PRINT_EXPORT: "Print/Export",
    DELIVERY_METHOD: "Delivery Method",
    SELECT_DATE_RANGE: "Select date range",
    SELECT_DATE_TIME: "Select date and time",
    SEARCH_ORDERS: "Search orders...",
    CATERING_CUSTOMER_NAME: "Customer Name",
    COMPLETION_DATE: "Completion Date",
    PICKUP: "Pickup",
    COMMENT: "Comment",
    CREATION_DATE: "Creation Date",
    VIEW_DETAILS: "View Details",
    CHOOSE_COLUMNS: "Choose Columns",
    ORDER_INFORMATION: "Order Information",
    ORDER_DATE: "Order Date",
    METHOD: "Method",
    DELIVERY_TIME: "Delivery Time",
    PICKUP_TIME: "Pickup Time",
    FULL_NAME: "Full Name",
    PAYMENT_STATUS: "Payment Status",
    DELIVERY_STATUS: "Delivery Status",
    CATERING_UNPAID: "Unpaid",
    CATERING_PENDING: "Pending",
    CATERING_DELIVERED: "Delivered",
    APPROVE_ORDER: "Approve Order",
    DECLINE_ORDER: "Decline Order",
    MARK_AS_DONE: "Mark as Done",
    MARK_AS_PENDING: "Mark as Pending",
    PRINT_EXPORT_ORDERS: "Print/Export Orders",
    DATE_RANGE_ORDER_CREATION: "Date Range (Based on Order Creation Date)",
    DATE_RANGE_COMPLETION: "Date Range (Based on Completion Date)",
    SELECT_DELIVERY_METHOD: "Select delivery method",
    ONLY_APPROVED_ORDERS: "Only approved orders will be included in the print/export.",
    PRINT: "Print",
    EXPORT_PDF: "Export pdf",
    EXPORT_PRODUCTION_TASKS: "Export Production Tasks",
    PRODUCTION_TASKS_INFO: "This report will include all approved orders scheduled for completion in the selected date range. Products will be grouped by day with quantities summed.",
    DATE_RANGE: "Date Range",
    CONTACT_CUSTOMER: "Contact Customer",
    DOWNLOAD_PDF: "Download PDF",
    APPROVED: "Approved",
    COMPLETED: "Completed",
    DONE: "Done",
    DECLINED: "Declined",
    QUANTITY: "Quantity",
    EACH: "each",
    MOBILE_PAY: "Mobile Pay",
    REGISTERED: "Registered",
    // Catering Main Component
    TAGS_CATEGORIES: 'Tags & Categories',
    // Catering Menu Component
    CATERING_MENUS: "Catering Menus",
    MANAGE_PRIORITIZE_MENUS: "Manage and prioritize your catering menus",
    CREATE_MENU: "Create Menu",
    TOTAL_MENUS: "Total Menus",
    MENU_STATUS: "Menu Status",
    NO_ACTIVE_MENU: "No Active Menu",
    INACTIVE_MENUS: "Inactive Menus",
    VIEW_MANAGE_MENUS: "View and manage all your catering menus",
    DEACTIVATE_MENU: "Deactivate menu",
    EDIT_MENU: "Edit menu",
    NO_MENUS_FOUND: "No menus found",
    CREATE_FIRST_MENU_DESC: "Create your first catering menu to get started. Organize your offerings and make them available to customers.",
    CREATE_FIRST_MENU: "Create First Menu",
    EDIT_MENU_DIALOG: "Edit Menu",
    MENU_NAME: "Menu Name",
    MENU_NAME_PLACEHOLDER: "e.g., Wedding Menu, Corporate Lunch",
    CREATE_CAMPAIGN_MENU: "Create campaign menu?",
    USE_FIXED_DATES: "Use Fixed Delivery/Pickup Dates",
    CAMPAIGN_TYPE: "Campaign Type",
    SELECTED_TYPE: "Selected type",
    ADD_PICKUP_DATE: "Add Pickup Date",
    ADD_DELIVERY_DATE: "Add Delivery Date",
    PICKUP_DATES: "Pickup Dates",
    DELIVERY_DATES: "Delivery Dates",
    PICKUP_TIME_SLOTS: "Pickup Time Slots",
    DELIVERY_TIME_SLOTS: "Delivery Time Slots",
    ADD_TIME_SLOT: "Add Time Slot",
    START_TIME_MUST_BE_LESS_THAN_END_TIME: "Start time must be less than end time",
    START_AND_END_TIME_CANNOT_BE_SAME: "Start and end time cannot be the same",
    TIME_SLOT_OVERLAPS_WITH_ANOTHER: "This time slot overlaps with another time slot",
    ACTIVE_MENUS_VISIBLE: "Active menus are visible to customers",
    UPDATE_MENU: "Update Menu",
    NO_ACTIVE_MENU_WARNING: "No Active Menu: Customers cannot place orders until a menu is activated.",
    // Catering Products Component
    LONG_DESCRIPTION: 'Long Description',
    SERVINGS_PER_PRODUCT: 'Servings per Product',
    MINIMUM_ORDER_QUANTITY: 'Minimum Order Quantity',
    CATERING_DIETARY_TAGS: 'Dietary Tags',
    CATERING_ECO_TAGS: 'Eco Tags',
    FULFILLMENT_OPTIONS: 'Fulfillment Options',
    PICK_UP: 'Pick-up',
    DELIVERY_OPTION: 'Delivery',
    BOTH: 'Both',
    SERVING: 'Serving',
    ECONOMICS: 'Economics',
    MINIMUM_ORDER_LEAD_DAYS: 'Minimum order lead days',
    MAXIMUM_ORDER_QUANTITY: 'Maximum order quantity',
    SELECT_UP_TO_4: 'Select up to 4',
    DETAILS: 'Details',
    // Catering Menu Details
    BACK_TO_MENUS: "Back to menus",
    TOTAL_CATEGORIES: "Total Categories",
    TOTAL_PRODUCTS: "Total Products",
    WITH_PRODUCTS: "With Products",
    NO_CATEGORIES_FOUND: "No categories found",
    CREATE_FIRST_CATEGORY_DESC: "Create your first category to organize products in this menu.",
    CREATE_FIRST_CATEGORY: "Create First Category",
    HERO_IMAGE_TEXT_COLOR_CAMPAIGN: "Hero Image Text Color",
    HERO_IMAGE_TEXT_COLOR_CAMPAIGN_PLACEHOLDER: "e.g., #000000 or #FFFFFF",
    HERO_IMAGE_TEXT_COLOR_REGULAR: "Text color",
    HERO_IMAGE_TEXT_COLOR_REGULAR_PLACEHOLDER: "e.g., #000000 or #FFFFFF",
    // Tags & Categories
    CATEGORIES_MANAGEMENT: 'Categories Management',
    ORGANIZE_PRODUCTS_CATEGORIES:
        'Organize your products with custom categories',
    CATEGORIES_WITH_PRODUCTS: 'Categories with Products',
    DIETARY_TAGS_MANAGEMENT: 'Dietary Tags Management',
    ORGANIZE_DIETARY_TAGS: 'Manage dietary tags for your products',
    ECO_TAGS_MANAGEMENT: 'Eco Tags Management',
    ORGANIZE_ECO_TAGS: 'Manage eco-friendly tags for your products',
    ADD_DIETARY_TAG: 'Add Dietary Tag',
    ADD_ECO_TAG: 'Add Eco Tag',
    TOTAL_DIETARY_TAGS: 'Total Dietary Tags',
    TOTAL_ECO_TAGS: 'Total Eco Tags',
    DIETARY_TAGS_WITH_PRODUCTS: 'Dietary Tags with Products',
    ECO_TAGS_WITH_PRODUCTS: 'Eco Tags with Products',
    // Menu Category Product
    LINKED_PRODUCTS: 'Linked Products',
    AVAILABLE_PRODUCTS: 'Available Products',
    PRODUCTS_LINKED: 'Products linked',
    PRODUCT_LINKED: 'Product linked',
    SEARCH_LINKED_PRODUCTS: 'Search linked products...',
    NO_PRODUCTS_LINKED: 'No products linked',
    TRY_DIFFERENT_SEARCH: 'Try a different search term',
    ADD_PRODUCTS_FROM_AVAILABLE:
        'Add products from the "Available Products" tab',
    NO_DESCRIPTION: 'No description',
    SEARCH_AVAILABLE_PRODUCTS: 'Search available products...',
    NO_AVAILABLE_PRODUCTS: 'No available products',
    ALL_PRODUCTS_ADDED: 'All products have been added to this category',
    ADD_TO_CATEGORY: 'Add to Category',
    ENABLE_STOCK_BALANCE_TRACKING: 'Enable stock balance tracking',
    STOCK_BALANCE_DISABLED: '(Disabled)',
    SERVINGS: 'Servings',
    MIN_ORDER: 'Min Order',
    ON: 'on',
    ORGANIZE_MENU_CATEGORIES: 'Organize your menu items into categories',
    NO_DESCRIPTION_PROVIDED: 'No description provided',
    LAST_MODIFIED_DATE: 'Last Modified Date',
    MANAGE_PRODUCTS: 'Manage products',
    NO_CATEGORIES_YET: 'No categories yet',
    CREATE_FIRST_CATEGORY_TEXT:
        'Create your first category to start organizing menu items. Categories help structure your menu and make it easier for customers to browse.',
    CATEGORY_NAME: 'Category Name',
    CATEGORY_DESCRIPTION: 'Category Description',
    CATEGORY_NAME_PLACEHOLDER: 'e.g., Appetizers, Main Course, Desserts',
    CATEGORY_DESCRIPTION_PLACEHOLDER:
        'Provide a brief description of this category...',
    OPTIONAL_CATEGORY_DETAILS:
        'Optional: Add details to help customers understand this category',
    UPDATE_CATEGORY: 'Update Category',
    DELETE_CATEGORY: 'Delete category',
    CREATE_NEW_CATEGORY: 'Create New Category',
    SEARCH_CATEGORIES: 'Search categories...',
    SEARCH_DIETARY_TAGS: 'Search dietary tags...',
    SEARCH_ECO_TAGS: 'Search eco tags...',
    SORT_BY: 'Sort by',
    TAGS_WITH_PRODUCTS: 'Tags with Products',
    TRY_ADJUSTING_SEARCH:
        'Try adjusting your search criteria or create a new category.',
    NO_DIETARY_TAGS_FOUND: 'No dietary tags found',
    NO_ECO_TAGS_FOUND: 'No eco tags found',
    ORGANIZE_DIETARY_INFO:
        'Organize your products with dietary information tags',
    ORGANIZE_ECO_INFO:
        'Organize your products with eco-friendly information tags',
    CREATE_FIRST_DIETARY_TAG: 'Create First Dietary Tag',
    CREATE_FIRST_ECO_TAG: 'Create First Eco Tag',
    ADD_NEW_CATEGORY: 'Add New Category',
    ENTER_CATEGORY_NAME: 'Enter category name',
    DESCRIPTION_OPTIONAL: 'Description (Optional)',
    ENTER_CATEGORY_DESCRIPTION: 'Enter category description',
    ENTER_DIETARY_TAG_NAME: 'Enter dietary tag name',
    ENTER_DIETARY_TAG_DESCRIPTION: 'Enter dietary tag description',
    DIETARY_TAG_NAME: 'Dietary Tag Name',
    ECO_TAG_NAME: 'Eco Tag Name',
    ENTER_ECO_TAG_NAME: 'Enter eco tag name',
    ENTER_ECO_TAG_DESCRIPTION: 'Enter eco tag description',
    ADD_NEW_DIETARY_TAG: 'Add New Dietary Tag',
    ADD_NEW_ECO_TAG: 'Add New Eco Tag',
    EDIT_DIETARY_TAG: 'Edit Dietary Tag',
    EDIT_ECO_TAG: 'Edit Eco Tag',
    CREATE_DIETARY_TAG: 'Create Dietary Tag',
    UPDATE_DIETARY_TAG: 'Update Dietary Tag',
    CREATE_ECO_TAG: 'Create Eco Tag',
    UPDATE_ECO_TAG: 'Update Eco Tag',
    LINKED: 'linked',
    SELECT_CATEGORY: 'Select Category',
    DATE_CREATED: 'Date created',
    SEARCH_TITLE_OR_TEXT: 'Search...',
    PUSH_NOTIFICATIONS_INTRO:
        'You can create and send a new notification, or resend a previous one from your history',
    ALL_NEWS: 'All news',
    CREATE_NEW_NOTIFICATION: 'Create notification',
    PUSH_NOTIFICATION: 'Push notification',
    NO_PUSH_NOTIFICATIONS_FOUND: 'No push notifications found',
    NO_NEWS_FOUND: 'No news carousels found',
    RECIPIENT: 'Recipient',
    SEND_TO_ALL: 'Send to all',
    SEND_TO_GROUP: 'Send to group',
    SELECT_GROUP: 'This notficication will be sent to',
    REACH_STATMENT: 'Push notification will reach:',
    GROUPS: 'Group(s)',
    NO_GROUPS: 'No groups',
    ALL_USERS: 'All Users',
    SELECT_USER_GROUPS: 'Select User Group',
    PRODUCT_NOT_FOUND: 'Product not found',
    NOT_FOUND: 'Not Found',
    FAILED_TO_DELETE_PRODUCT: 'Failed to delete product',
    FAILED_TO_BULK_UPDATE_PRODUCTS: 'Failed to bulk update products',
    SHARED: 'Shared',
    PRODUCTS_BULK_UPDATED: 'Products bulk updated successfully',
    UPDATED: 'Updated',
    DISCARDED: 'Discarded',
    CHANGES_DISCARDED: 'Changes discarded',
    PRODUCT_UPDATED: 'Product updated successfully',
    FAILED_TO_SAVE_PRODUCT: 'Failed to save product',
    PRODUCTION_TASKS_REPORT_GENERATED_SUCCESSFULLY:
        'Production tasks report generated successfully',
    FAILED_TO_LOAD_ORDERS: 'Failed to load orders',
    FAILED_TO_UPDATE_ORDER_STATUS: 'Failed to update order status',
    INVALID_MENU_IDENTIFIER: 'Invalid menu identifier',
    MENU_NOT_FOUND: 'Menu not found',
    FAILED_TO_LOAD_MENU_DETAILS: 'Failed to load menu details',
    FAILED_TO_LOAD_CATEGORIES: 'Failed to load categories',
    CATEGORY_NAME_REQUIRED: 'Category name is required',
    CATEGORY_CREATED_SUCCESSFULLY: 'Category created successfully',
    FAILED_TO_CREATE_CATEGORY: 'Failed to create category',
    CATEGORY_UPDATED_SUCCESSFULLY: 'Category updated successfully',
    FAILED_TO_UPDATE_CATEGORY: 'Failed to update category',
    CATEGORY_DELETED_SUCCESSFULLY: 'Category deleted successfully',
    FAILED_TO_DELETE_CATEGORY: 'Failed to delete category',
    FAILED_TO_UPDATE_PRODUCT_ORDER: 'Failed to update product order',
    FAILED_TO_LOAD_PRODUCTS: 'Failed to load products',
    FAILED_TO_ADD_PRODUCT_TO_CATEGORY: 'Failed to add product to category',
    FAILED_TO_REMOVE_PRODUCT_FROM_CATEGORY:
        'Failed to remove product from category',
    PRODUCT_ORDER_UPDATED: 'Product order updated',
    FAILED_TO_LOAD_CATERING_MENUS: 'Failed to load catering menus',
    MENU_CREATED_SUCCESSFULLY: 'Menu created successfully',
    FAILED_TO_CREATE_MENU: 'Failed to create menu',
    MENU_UPDATED_SUCCESSFULLY: 'Menu updated successfully',
    FAILED_TO_UPDATE_MENU: 'Failed to update menu',
    MENU_DELETED_SUCCESSFULLY: 'Menu deleted successfully',
    FAILED_TO_DELETE_MENU: 'Failed to delete menu',
    MENU_DEACTIVATED: 'Menu Deactivated',
    FAILED_TO_UPDATE_MENU_STATUS: 'Failed to update menu status',
    NAME_ASC: 'Name (A-Z)',
    NAME_DESC: 'Name (Z-A)',
    DATE_CREATED_NEWEST: 'Date Created (Newest)',
    DATE_CREATED_OLDEST: 'Date Created (Oldest)',
    DELETE_ECO_TAG: 'Delete Eco Tag',
    DELETE_DIETARY_TAG: 'Delete Dietary Tag',
    CONFIRM_STATUS_UPDATE: 'Confirm Status Update',
    REMOVE_PRODUCT: 'Remove Product',
    BASIC_INFORMATION: 'Basic Information',
    CAMPAIGN_SETTINGS: 'Campaign Settings',
    ENABLE_PICKUP_DELIVERY_DATES:
        'Enable to set specific pickup/delivery dates and times',
    REMOVE_DATE: 'Remove date',
    START_DATE_REQUIRED_FOR_CAMPAIGN_MENU:
        'Start date is required for campaign menu',
    END_DATE_AFTER_START_DATE: 'End date must be after start date',
    BOTH_DATES_PASSED_WARNING: "Both start and end dates have passed. Update the dates before activating this menu.",
    PAST_DATE_RANGE_EDIT_WARNING: "Both selected dates are in the past. Update the end date to today or later to edit the start date.",
    PAST_SCHEDULE_DATES_WARNING: "One or more pickup/delivery dates are in the past. Update or remove past dates to save changes.",
    AT_LEAST_ONE_PICKUP_SCHEDULE_REQUIRED:
        'At least one pickup schedule is required',
    AT_LEAST_ONE_DELIVERY_SCHEDULE_REQUIRED:
        'At least one delivery schedule is required',
    AT_LEAST_ONE_PICKUP_OR_DELIVERY_SCHEDULE_REQUIRED:
        'At least one pickup or delivery schedule is required',
    MENU_NAME_REQUIRED: 'Menu name is required',
    ALLERGEN_CATEGORIES: 'Allergen Categories',
    REMOVE_ALLERGEN_CATEGORY: 'Remove allergen category',
    MILK: '🥛 Milk',
    MILK_PROTEIN: '🥛 Milk Protein',
    GLUTEN: '🌾 Gluten',
    NUTS: '🥜 Nuts',
    CRUSTACEANS: '🦞 Crustaceans',
    EGG: '🥚 Egg',
    MOLLUSCS: '🦪 Molluscs',
    FISH: '🐟 Fish',
    PORK: '🥓 Pork',
    PEANUTS: '🥜 Peanuts',
    SESAME_SEEDS: 'Sesame Seeds',
    SULPHUR: 'Sulphur',
    SOYBEANS: '🫘 Soybeans',
    CELERY: '🥬 Celery',
    MUSTARD: 'Mustard',
    LUPIN: 'Lupin',
    GARLIC: '🧄 Garlic',
    MUSHROOM: '🍄‍🟫 Mushroom',
    ALMOND: '🥜 Almond',
    HAZELNUT: '🥜 Hazelnut',
    WALNUT: '🥜 Walnut',
    CASHEW: '🥜 Cashew',
    PECAN: '🥜 Pecan',
    BRAZIL_NUT: '🥜 Brazil Nut',
    PISTACHIO: '🥜 Pistachio',
    MACADAMIA: '🥜 Macadamia',
    CATERING_DELIVERY_AVAILABILITY_DESC: 'Configure which days and time slots customers can select for delivery. Toggle each day on/off and add specific time windows.',
    CATERING_DELIVERY_AVAILABILITY: 'Delivery availability',

    //Signage
    MENUDISPLAY_SETTINGS_TITLE: 'Menudisplay settings',
    MENUDISPLAY_SETTINGS_SUBTITLE: 'Configure your menu display',
    MENUDISPLAY_GENERAL_SETTINGS_TAB: 'General settings',
    MENUDISPLAY_GENERAL_SETTINGS_SUBTITLE: 'Unit-wide menu display options that apply across all screens and slides.',
    MENUDISPLAY_DEFAULT_LANGUAGE_SUBTITLE: 'Default language shown on signage menu displays for this unit.',
    MENUDISPLAY_MENU_DISPLAY_CONFIG_SUBTITLE: 'Configure logo, background, font color, and product image visibility.',
    MENUDISPLAY_PRODUCT_IMAGE: 'Product image',
    MENUDISPLAY_PRODUCT_IMAGE_SUBTITLE: 'Show product image thumbnail',
    MENUDISPLAY_TOGGLE_ON: 'On',
    MENUDISPLAY_TOGGLE_OFF: 'Off',
    MENUDISPLAY_FONT_COLOR: 'Font color',
    MENUDISPLAY_FONT_FAMILY_TITLE: 'Font family',
    MENUDISPLAY_FONT_FAMILY_SUBTITLE: 'Choose a Google Font for menu text on signage.',
    MENUDISPLAY_FONT_PREVIEW_SAMPLE: 'Sample: Aa Bb Cc 0123456789',
    MENUDISPLAY_FONT_COLOR_SUBTITLE: 'Choose font color',
    MENUDISPLAY_FONT_COLOR_HEX_PLACEHOLDER: '#000000',
    MENUDISPLAY_LOGO_SUBTITLE: 'Add or remove a logo',
    MENUDISPLAY_LOGO_TITLE: 'Logo',
    CHANGE_LOGO: 'Change logo',
    MENUDISPLAY_UPLOADED: 'Uploaded',
    MENUDISPLAY_NOT_SET: 'Not set',
    MENUDISPLAY_LOGO_PREVIEW_ALT: 'Logo preview',
    MENUDISPLAY_REPLACE_IMAGE: 'Replace image',
    MENUDISPLAY_CLICK_TO_UPLOAD_LOGO: 'Click to upload',
    MENUDISPLAY_LOGO_UPLOAD_HINT: 'PNG, JPG, SVG · Recommended 400×400px',
    MENUDISPLAY_CUSTOM_MENU_DISPLAY_TITLE: 'Custom menu display',
    MENUDISPLAY_CUSTOM_MENU_DISPLAY_SUBTITLE: 'Create and manage reusable product groups for signage slides.',
    MENUDISPLAY_BACKGROUND_TITLE: 'Background',
    MENUDISPLAY_BACKGROUND_SUBTITLE: 'Back ground needs to be 1080x1920 resolution',
    MENUDISPLAY_BACKGROUND_PREVIEW_ALT: 'Background preview',
    MENUDISPLAY_CLICK_TO_UPLOAD_BACKGROUND: 'Click to upload background',
    MENUDISPLAY_BACKGROUND_UPLOAD_HINT: 'PNG, JPG · Recommended 1920×1080px',
    MENUDISPLAY_CHANGE_IMAGE: 'Change image',
    MENUDISPLAY_REMOVE_LOGO_WARN: 'Removing the logo wil laffect the menu display layout',
    MENUDISPLAY_DELETE: 'Delete',
    MENUDISPLAY_ABORT: 'Cancel',
    MENUDISPLAY_FAILED_UPDATE: 'Failed to update',
    MENUDISPLAY_THEME_SAVED: 'Theme saved',
    MENUDISPLAY_NO_LOGO: 'No logo to remove',
    MENUDISPLAY_REMOVE_LOGO_HEADER: 'Remove logo?',
    MENUDISPLAY_SELECT_FILE: 'Select a file',
    MENUDISPLAY_UNSAVED_CHANGES_HINT: 'You have unsaved changes',
    MENUDISPLAY_LOADING_ARIA_LABEL: 'loading',
    MENUDISPLAY_LOADING_THEME_SETTINGS_TEXT: 'Loading theme settings…',
    SCREEN_SETTINGS_TITLE: 'Screen settings',
    SCREEN_SETTINGS_SUBTITLE: 'Configure your screen',
    SCREEN_ADD_SCREEN: 'Create a screen',
    SCREEN_ADD_FIRST_SCREEN: 'Create your first screen',
    SCREEN_SCREEN_STATUS: 'Screen status',
    SCREEN_EDIT_SCREEN: 'Edit screen',
    SCREEN_SCREEN_NAME: 'Screen name',
    SCREEN_SELECT_COLLECTION: 'Select slide collection',
    SCREEN_REMOVE_SCREEN: 'Delete screen',
    SCREEN_REMOVE_SCREEN_HEADER: 'Delete screen',
    SCREEN_REMOVE_SCREEN_WARN: 'Are you sure you want to delete this screen?',
    SCREEN_SCREENS: 'Screens',
    SCREEN_PUBLISH_ACTIVATED: 'Screen "{name}" is activated.',
    SCREEN_PUBLISH_DEACTIVATED: 'Screen "{name}" is deactivated.',
    SCREEN_STATUS_UPDATE_ERROR: 'Could not save screen status. Please try again.',
    SCREEN_SCHEDULES: 'Schedules',
    SCREEN_SCHEDULE: 'Schedule',
    SCREEN_ADD_SCHEDULE: 'Add schedule',
    SCREEN_SCHEDULES_HINT: 'Assign slide collections to days and time windows. The player shows the collection that matches the current time.',
    SCREEN_SCHEDULE_DAYS: 'Days',
    SCREEN_SCHEDULE_DAYS_PLACEHOLDER: 'Select days',
    SCREEN_SCHEDULE_START: 'Start time',
    SCREEN_SCHEDULE_END: 'End time',
    SCREEN_SCHEDULE_COUNT: '{count} schedules',
    SCREEN_SCHEDULE_REQUIRED: 'Add at least one schedule.',
    SCREEN_SCHEDULE_COLLECTION_REQUIRED: 'Select a slide collection for each schedule.',
    SCREEN_SCHEDULE_DAYS_REQUIRED: 'Select at least one day for each schedule.',
    SCREEN_SCHEDULE_INVALID_TIME: 'End time must be after start time for each schedule.',
    COLLECTION_SETTINGS_TITLE: 'Slide collections',
    COLLECTION_SETTINGS_SUBTITLE: 'Configure your slide collections',
    COLLECTION_COLLECTIONS: 'Collections',
    COLLECTION_ADD_FIRST_COLLECTION: 'Add your first collection',
    COLLECTION_CREATED: 'Collection created:',
    COLLECTION_CREATE_COLLECTION: 'Create collection',
    COLLECTION_EDIT_COLLECTION: 'Edit collection',
    COLLECTION_NAME: 'Collection name',
    SLIDE_COLLECTION: 'Slide collection',
    SLIDE_CREATE_FIRST: 'Create your first slide to get started',
    SLIDE_CREATE_SLIDE: 'Create slide',
    SLIDE_CREATE_SUBTITLE: 'Add a new slide to your signage',
    SLIDE_DELETE_SLIDE: 'Delete slide',
    SLIDE_DELETE_COLLECTION: 'Delete collection',
    SLIDE_DELAY_SECONDS: 'Delay seconds',
    SLIDE_DELAY_HINT: 'How long this slide should be shown',
    SLIDE_DELAY_WARNING: 'Delay must be at least 5 seconds',
    SLIDE_NAME: 'Slide name',
    SLIDE_NAME_WARNING: 'Name is required',
    SLIDE_IMAGE: 'Slide image',
    SLIDE_IMAGE_ALT: 'slide image',
    SLIDE_TYPE_SELECT: 'Select slide type',
    SLIDE_ACTIVE_MENU: 'Active menu',
    SLIDE_IMAGE_TYPE: 'Image',
    SLIDE_VIDEO_TYPE: 'Video',
    SLIDE_VIDEO: 'Slide video',
    SLIDE_VIDEO_FILE: 'Video file',
    SLIDE_VIDEO_ALT: 'slide video',
    SLIDE_FILE_UPLOADED: 'File uploaded',
    SLIDE_VIDEO_FORMATS_HINT: 'Supported formats: MP4. Max size: 50 MB.',
    SLIDE_VIDEO_DURATION_HINT: 'Detected from uploaded video file',
    SLIDE_DELAY_REQUIRED: 'Slide delay is required',
    UPLOAD_VIDEO: 'Upload video',
    VIDEO_GALLERY: 'Video Gallery',
    VIDEO_URL: 'Video URL',
    VIDEO_DURATION: 'Duration (seconds)',
    SLIDE_EDIT_SLIDE: 'Edit slide',
    SLIDE_EDIT_SUBTITLE: 'Update this slide in your signage',
    SLIDE_NAME_MINLENGTH: 'Name needs to be atleast 3 characters',
    SLIDE_DELAY_SECONDS_SUFFIX: 'sec',
    SIGNAGE_MIN_3_CHARACTERS: 'Min 3 characters',
    SLIDE_CREATED: 'Slide successfully created',
    SLIDE_UPDATED: 'Slide successfully updated',
    SLIDE_PUBLISHED: 'Slide published',
    SLIDE_UNPUBLISHED: 'Slide unpublished',
    SLIDE_DELETED: 'Slide deleted',
    REMOVE_SLIDE_HEADER: 'Remove Slide',
    REMOVE_SLIDE_MESSAGE: 'Are you sure you want to remove the slide?',
    REMOVE_SLIDE: 'Remove slide',
    REMOVE_COLLECTION_HEADER: 'Remove Collection',
    REMOVE_COLLECTION_MESSAGE: 'Removing this collection may affect any screens that use it.',
    REMOVE_COLLECTION: 'Remove collection',
    COLLECTION_DELETED: 'Collection deleted',
    COLLECTION_CREATED_SUCCESS: 'Collection created successfully',
    COLLECTION_UPDATED_SUCCESS: 'Collection updated successfully',
    ACTIVE_MENU_SLIDE: 'Active menu slide',
    CUSTOM_MENU_SLIDE: 'Custom menu slide',
    IMAGE_SLIDE: 'Image slide',
    VIDEO_SLIDE: 'Video slide',
    VIDEO_TOO_LARGE: 'Video file size must be 50MB or less',
    VIDEO_TOO_LONG: 'Video duration must be 60 seconds or less',
    VIDEO_INVALID_FORMAT: 'Only MP4 files are supported',
    VIDEO_PROBE_FAILED: 'Unable to read video metadata',
    VIDEO_UPLOAD_FAILED: 'Video upload failed',
    SLIDE_CUSTOM_MENU: 'Custom',
    CUSTOM_MENU_DISPLAYS_TITLE: 'Custom Menu Display',
    CUSTOM_MENU_DISPLAY_CREATE: 'Create Menu Display',
    SELECT_CUSTOM_MENU: 'Choose custom menu-display',
    NO_CUSTOM_MENU_DISPLAYS: 'No custom menu displays found',
    CUSTOM_MENU_DISPLAY: 'Custom Menu Display',
    CUSTOM_ACTION: 'Manage',
    CONFIRM_DELETE_CUSTOM_MENU_MESSAGE: 'Are you sure you want to delete the custom menu display? Some slides may be affected',
    CONFIRM_DELETE_CUSTOM_MENU_HEADER: 'Delete Custom Menu Display',
    CUSTOM_MENU_SUBTITLE: 'Manage your custom signage displays',
    CUSTOM_MENU_TOTAL_DISPLAYS: 'Total Displays',
    CUSTOM_MENU_TOTAL_PRODUCTS: 'Total Products',
    CUSTOM_MENU_THEMED_DISPLAYS: 'Themed Displays',
    CUSTOM_MENU_THEME: 'Theme',
    CUSTOM_MENU_PRODUCT: 'product',
    CUSTOM_MENU_BACKGROUND_IMAGE: 'Background image',
    CUSTOM_MENU_LOGO: 'Logo',
    CUSTOM_MENU_PRODUCT_IMAGES_ON: 'Product images on',
    CUSTOM_MENU_EMPTY_DESCRIPTION: 'Create your first custom display to showcase selected products on your signage screens.',
    CUSTOM_MENU_EDIT_DISPLAY: 'Edit Display',
    CUSTOM_MENU_NEW_DISPLAY: 'New Custom Display',
    CUSTOM_MENU_OF_5_SELECTED: 'of 5 selected',
    CUSTOM_MENU_NO_PRODUCTS_SELECTED: 'No products selected yet.',
    CUSTOM_MENU_SWITCH_AVAILABLE_PRODUCTS: 'Switch to Available Products to add.',
    CUSTOM_MENU_NO_SEARCH_MATCH: 'No products match your search.',
    CUSTOM_MENU_FONT_COLOR: 'Font Color',
    CUSTOM_MENU_SHOW_PRODUCT_IMAGES: 'Show Product Images',
    CUSTOM_MENU_DISPLAY_THUMBNAILS: 'Display thumbnails on signage screen',
    CUSTOM_MENU_SELECT_LOGO: 'Select logo from gallery',
    CUSTOM_MENU_LOGO_SELECTED: 'Logo selected',
    CUSTOM_MENU_SELECT_BACKGROUND: 'Select background from gallery',
    CUSTOM_MENU_BACKGROUND_SELECTED: 'Background selected',
    CUSTOM_MENU_THEME_SAVE_NOTE: 'Theme changes apply live on your signage screens after saving.',
    CUSTOM_MENU_DISPLAY_SAVE_SUCCESS: '"{name}" was saved.',
    CUSTOM_MENU_DISPLAY_SAVE_ERROR: 'Could not save the custom display. Please try again.',
    CATERING_PICKUP_AVAILABILITY_DESC: 'Configure which days and time slots customers can select for pickup. Toggle each day on/off and add specific time windows.',
    CATERING_PICKUP_AVAILABILITY: 'Pickup availability',
    CATERING_SLOTS: 'Time slots',
    CATERING_DISABLED: 'Disabled',
    CATERING_START_TIME: 'Start time',
    CATERING_END_TIME: 'End time',
    CATERING_DELIVERY_TIME: 'Delivery time',
    CATERING_ADD_TIME_SLOT: 'Add time slot',
    CATERING_PRODUCTION_DAYS_HEADER: 'Production Days',
    CATERING_PRODUCTION_DAYS_DESCRIPTION: 'Configure which days of the week count as production days when calculating minimum pickup dates. Days that are not production days will be skipped when counting lead time.',
    CATERING_PRODUCTION_DAYS_LABEL: 'Days that count as production days',
    DAYS_MONDAY: 'Monday',
    DAYS_TUESDAY: 'Tuesday',
    DAYS_WEDNESDAY: 'Wednesday',
    DAYS_THURSDAY: 'Thursday',
    DAYS_FRIDAY: 'Friday',
    DAYS_SATURDAY: 'Saturday',
    DAYS_SUNDAY: 'Sunday',
    CONFIRMATION_REQUIRED: "Confirmation Required",
    DO_YOU_WANT_TO_PROCEED: 'Do you want to proceed?',
    REMOVING_LAST_TIMESLOT: 'Removing the last timeslot will deactivate',
    NO_DAYS_AVAILABLE: 'No days are available for pickup',
    CREATE_CAMPAIGN_MENU_TITLE: 'Create Campaign Menu',
    EVENT_SETTINGS: 'Event Settings',
    CREATE_EVENT_MENU: 'Create Event Menu',
    UPLOAD_HERO_IMAGE: 'Upload Hero Image',
    CAMPAIGN_BUTTON_TEXT: 'Campaign Button Text',
    CAMPAIGN_BUTTON_PLACEHOLDER: 'Enter the text for the campaign button',
    CAMPAIGN_MENU_LIST: 'Campaign Menu List',
    VIEW_CAMPAIGN_MENUS: 'View and manage all your campaign menus',
    STARTS: 'Starts',
    ENDS: 'Ends',
    SAVE_CHANGES: 'Save changes',
    EVENT: 'Event',
    ACTIVATE_EVENT_MENU: 'Activate Event Menu',
    ACTIVATE_EVENT_MENU_WARNING_MESSAGE: 'All Campaign menus will be deactivated when activating an event menu. You must validate this action to proceed.',
    CONTINUE: 'I understand, Continue',
    NO_REGULAR_MENU_WARNING: 'Please activate a regular menu before continuing',
    MENU_ACTIVATION_REQUIRES_CATEGORY_WITH_PRODUCT: 'A menu must have at least one category with at least one product before it can be activated.',
    EVENT_MENU_WARNING: 'Please deactivate the event menu and activate a regular menu first',
    DEACTIVATE_MENU_WARNING_MESSAGE: "Disabling this menu will also disable the currently active campaign menu. Do you want to continue?",
    DELETE_MENU_WARNING_MESSAGE: "Deleting this menu will also disable the currently active campaign menu. Do you want to continue?",
    HERO_IMAGE_TEXT: 'Hero Image text',
    HERO_IMAGE_TEXT_PLACEHOLDER: 'Add a text to write on campaign Hero Image',
    EVENT_MENU_FIXED_DATE_WARNING: 'Event menus should have fixed dates',

    // catering hero image text settings
    CATERING_COMMUNICATION_TAB: 'Communication',
    CATERING_THEME_TAB: 'Theme',
    CATERING_ALERT_BANNER_HEADER: 'Catering Alert Banner',
    CATERING_ALERT_BANNER_DESCRIPTION: 'Add a message to inform guests about current issues or disruptions. When activated, this text will appear as an alert banner in the web app.',
    CATERING_ALERT_BANNER_TEXT_HEADER: 'Alert Banner Text',
    CATERING_ALERT_BANNER_TEXT_COLOR: 'Banner text color',
    CATERING_ALERT_BANNER_TEXT_COLOR_PLACEHOLDER: 'e.g., #000000 or #FFFFFF',
    CATERING_ALERT_BANNER_BACKGROUND_COLOR: 'Banner background color',
    CATERING_ALERT_BANNER_BACKGROUND_COLOR_PLACEHOLDER: 'e.g., #FFF3CD or #FFFFFF',
    CATERING_ALERT_BANNER_TEXT_PLACEHOLDER: 'Enter alert banner message',
    CATERING_ALERT_BANNER_TEXT_MAX_LENGTH: 'Maximum characters reached for alert banner.',
    CATERING_HERO_IMAGE_AND_LOGO_HEADER: 'Hero Image and Logo',
    CATERING_HERO_IMAGE_AND_LOGO_DESCRIPTION: 'Configure hero image and logo.',
    CATERING_BUTTON_COLORS_HEADER: 'Button Colors',
    CATERING_BUTTON_COLORS_DESCRIPTION: 'Customize the primary button color and button text color used in the Catering web app.',
    CATERING_BUTTON_PRIMARY_COLOR: 'Button primary color',
    CATERING_BUTTON_TEXT_COLOR: 'Button text color',
    CATERING_FONTS_HEADER: 'Theme Fonts',
    CATERING_FONTS_DESCRIPTION: 'Configure title and body fonts.',
    CATERING_TITLE_FONT_LABEL: 'Title Font',
    CATERING_BODY_FONT_LABEL: 'Body Font',
    CATERING_THEME_LOGO_HEADER: 'Logo',
    CATERING_THEME_HERO_IMAGE_HEADER: 'Hero Image',
    CATERING_THEME_PREVIEW_HEADER: 'Preview',
    CATERING_THEME_PREVIEW_BTN_SOLID: 'Button',
    CATERING_THEME_PREVIEW_BTN_OUTLINED: 'Outline',
    CATERING_THEME_PREVIEW_BTN_TEXT: 'Text',
    CATERING_THEME_REPLACE: 'Replace',
    CATERING_HERO_IMAGE_HEADER: 'Hero Image Text',
    CATERING_HERO_IMAGE_DESCRIPTION: 'Configure hero image text',
    CATERING_HERO_IMAGE_TITLE_HEADER: 'Title',
    CATERING_HERO_IMAGE_TITLE_PLACEHOLDER: 'Enter hero image title',
    CATERING_HERO_IMAGE_TITLE_MAX_LENGTH: 'Maximum characters reached for hero image title.',
    CATERING_HERO_IMAGE_BODY_HEADER: 'Body',
    CATERING_HERO_IMAGE_BODY_PLACEHOLDER: 'Enter hero image description',
    CATERING_HERO_IMAGE_BODY_MAX_LENGTH: 'Maximum characters reached for hero image description.',
    CATERING_HERO_IMAGE_TEXT_CONFIGURATION_SAVED: 'Hero image text configuration saved successfully.',
    CATERING_HERO_IMAGE_TEXT_CONFIGURATION_SAVE_ERROR: 'Failed to save hero image text configuration. Please try again.',
    CATERING_HERO_IMAGE_TITLE_REQUIRED: 'Hero image title is required.',
    CATERING_HERO_IMAGE_BODY_REQUIRED: 'Hero image description is required.',
    CATERING_ALERT_BANNER_TEXT_REQUIRED: 'Alert banner message is required.',
    CATERING_ALERT_BANNER_SWITCH_MESSAGE: 'You must enter an alert banner message before activating the banner.',
    SETTINGS_UPDATED: "Settings updated successfully.",
    SETTINGS_COULDNT_UPDATE: "Something went wrong. Could not update settings.",
    CATERING_CUTOFF_TIME_UPDATED: "Order cutoff time updated",
    CATERING_CUTOFF_TIME_COULDNT_UPDATE: "Something went wrong. Could not update cutoff time.",
    ORDER_CUTOFF_CONFIGURATION: 'Order Cutoff Configuration',
    ORDER_CUTOFF_DESCRIPTION: 'Set the latest time for orders to count same day as the first production day',
    SELECT_TIME: 'Select time',
    ADJUST_CUTOFF_TIME: 'Adjust cutoff time',
    ALLERGEN_DESCRIPTION: 'Allergen Description',
    ENTER_ALLERGEN_DESCRIPTION: 'Enter allergen description',
    NO_ACTIVE_CAMPAIGN_MENU: 'No active campaign menu',
    CAMPAIGN_MENU_STATUS: 'Campaign Menu Status',
    AUTO_APPROVE_ORDERS_HEADER: 'Auto approve orders',
    AUTO_APPROVE_ORDERS_DESCRIPTION: 'Automatically approve incoming catering orders without manual review.',
    SHOW_MANDATORY_POPUP_FOR_DATE_HEADER: 'Mandatory date selection popup',
    SHOW_MANDATORY_POPUP_FOR_DATE_DESCRIPTION: 'Show a popup on the catering webapp that requires customers to select a date before browsing the menu.',
    NOTIFICATION_EMAILS_HEADER: 'Order notification emails',
    NOTIFICATION_EMAILS_DESCRIPTION: 'Add email addresses to receive notifications for new catering orders. Multiple emails can be added.',
    NOTIFICATION_EMAIL_LANGUAGE: 'Notification email language',
    ADD_EMAIL: 'Add email',
    ENTER_EMAIL_ADDRESS: 'Enter email address',
    ADDED_EMAILS: 'Added emails',
    NO_EMAILS_ADDED: 'No email addresses added',
    INVALID_EMAIL_FORMAT: 'Invalid email format',
    EMAIL_ALREADY_EXISTS: 'Email already exists',
    CATERING_MENU_PREFERENCE_HEADER: 'Product Menu Type',
    CATERING_MENU_PREFERENCE_DESCRIPTION: 'Select which menu type should display a product if it exists in both Regular and Campaign menus. When a product is added to both menu types, it will appear only in the menu type chosen here the settings.',
    IMPORTANT: 'Important',
    MENU_PREFERENCE_NOTE: 'A product can belong to only one menu type. If it appears in both Campaign and Regular menus, it will be shown according to your selected menu preference.',
    CATERING_SELECT_MENU_TYPE: 'Select Menu Type',
    CATERING_MENU_PREFERENCE_NOTE: 'If a product is added to both menu types, it will be displayed only in the preferred menu type.',
    CATERING_CAMPAIGN_MENU: 'Campaign',
    CATERING_REGULAR_MENU: 'Regular',
    COMMENT_FIELD_ON_ORDER: 'Comment field on order',
    COMMENT_FIELD_DESCRIPTION: 'Enable or disable the comment field at checkout.',

    // Catering addon groups
    CATERING_ADDONS_SUBTITLE: 'Manage catering addon groups and their options',
    CATERING_ADDON_CREATE_GROUP: 'Create Addon Group',
    CATERING_ADDON_SEARCH_GROUPS: 'Search addon groups...',
    CATERING_ADDON_AVAILABILITY: 'Availability',
    CATERING_ADDON_OPTIONS_LABEL: 'Options',
    CATERING_ADDON_OPTION_SINGULAR: 'option',
    CATERING_ADDON_OPTION_PLURAL: 'options',
    CATERING_ADDON_PRODUCT_SINGULAR: 'product',
    CATERING_ADDON_PRODUCT_PLURAL: 'products',
    CATERING_ADDON_LOADING: 'Loading…',
    CATERING_ADDON_NO_GROUPS: 'No addon groups found',
    CATERING_ADDON_NO_GROUPS_HINT: 'Create your first addon group to get started',
    CATERING_ADDON_LOAD_ERROR: 'Failed to load addon groups.',
    CATERING_ADDON_SAVED: 'Saved',
    CATERING_ADDON_UPDATED: 'Addon group updated.',
    CATERING_ADDON_CREATED: 'Addon group created.',
    CATERING_ADDON_SAVE_FAILED: 'Save failed',
    CATERING_ADDON_UPDATE_ERROR: 'Could not update addon group. Please try again.',
    CATERING_ADDON_CREATE_ERROR: 'Could not create addon group. Please try again.',
    CATERING_ADDON_DELETE_FAILED: 'Delete failed',
    CATERING_ADDON_DELETE_ERROR: 'Could not delete addon group. Please try again.',
    CATERING_ADDON_TYPE_SINGLE: 'Single',
    CATERING_ADDON_TYPE_MULTIPLE: 'Multiple',
    CATERING_ADDON_EDIT_GROUP: 'Edit Addon Group',
    CATERING_ADDON_NEW_GROUP: 'New Addon Group',
    CATERING_ADDON_EDIT_SUBTITLE: 'Update the details of this addon group',
    CATERING_ADDON_NEW_SUBTITLE: 'Fill in the details to create a new addon group',
    CATERING_ADDON_STEP_ADD_OPTIONS: 'Add Options',
    CATERING_ADDON_NAME_PLACEHOLDER: 'e.g. Choose a sauce',
    CATERING_ADDON_DESCRIPTION_PLACEHOLDER: 'Short description shown to the customer',
    CATERING_ADDON_TYPE_LABEL: 'Addon type',
    CATERING_ADDON_TYPE_SINGLE_DESC: 'Customer picks exactly one option',
    CATERING_ADDON_TYPE_MULTIPLE_DESC: 'Customer picks one or more options',
    CATERING_ADDON_DELIVERY_METHOD_AVAILABILITY: 'Delivery method availability',
    CATERING_ADDON_PICKUP_HINT: 'Show for pickup orders',
    CATERING_ADDON_DELIVERY_HINT: 'Show for delivery orders',
    CATERING_ADDON_ADD_PRODUCT: 'Add product',
    CATERING_ADDON_SEARCH_PRODUCT_PLACEHOLDER: 'Search product…',
    CATERING_ADDON_ADD: 'Add',
    CATERING_ADDON_NOT_FOUND: 'Not found',
    CATERING_ADDON_REMOVE: 'Remove',
    CATERING_ADDON_NO_PRODUCTS_LINKED: 'No products linked to this group yet.',
    CATERING_ADDON_LINKS_APPLIED_ON_SAVE: 'Product links are applied on Save.',
    CATERING_ADDON_SELECTION_RULES: 'Selection rules',
    CATERING_ADDON_PRESELECT: 'Pre-select',
    CATERING_ADDON_PRESELECT_HINT: 'Default option when the customer opens this group.',
    CATERING_ADDON_PRESELECTED_OPTION: 'Pre-selected option',
    CATERING_ADDON_CHOOSE_OPTION: 'Choose an option',
    CATERING_ADDON_MIN_SELECTED: 'Min selected',
    CATERING_ADDON_MIN_SELECTED_HINT: 'Minimum options the customer must choose.',
    CATERING_ADDON_MAX_SELECTED: 'Max selected',
    CATERING_ADDON_NO_LIMIT: 'No limit',
    CATERING_ADDON_MAX_SELECTED_HINT: 'Leave empty for no upper limit.',
    CATERING_ADDON_OPTIONS_REQUIRED: 'Addon options',
    CATERING_ADDON_DRAG_REORDER: 'Drag to reorder',
    CATERING_ADDON_OPTION_NAME: 'Option name',
    CATERING_ADDON_OPTION_NAME_PLACEHOLDER: 'e.g. Garlic aioli',
    CATERING_ADDON_LINK: 'Link',
    CATERING_ADDON_REMOVE_LINK: 'Remove link',
    CATERING_ADDON_DELETE_OPTION: 'Delete option',
    CATERING_ADDON_NO_OPTIONS_YET: 'No options yet. Click "Add option" to start.',
    CATERING_ADDON_PRESELECT_NONE: 'None',
    CATERING_ADDON_PRESELECT_FIRST: 'First option',
    CATERING_ADDON_PRESELECT_SPECIFIC: 'Specific option',
    CATERING_ADDON_ERR_FIRST_OPTION: 'Add at least one option before using "First option".',
    CATERING_ADDON_ERR_CHOOSE_PRESELECT: 'Choose which option to pre-select.',
    CATERING_ADDON_ERR_PRESELECT_INVALID: 'Pre-selected option must be one of the options below.',
    CATERING_ADDON_ERR_MIN_ZERO: 'Min selected must be 0 or greater.',
    CATERING_ADDON_ERR_MAX_ZERO: 'Max selected must be 0 or greater, or left empty.',
    CATERING_ADDON_ERR_MAX_LESS_MIN: 'Max selected cannot be less than min selected.',

    // Catering products editor
    CATERING_PRODUCT_LOADING_ADDONS: 'Loading...',
    CATERING_PRODUCT_NO_ADDON_GROUPS_AVAILABLE: 'No addon groups available',
    CATERING_PRODUCT_HIDE_OPTIONS: 'Hide options',
    CATERING_PRODUCT_NO_OPTIONS_IN_GROUP: 'No options in this group.',
    CATERING_PRODUCT_NO_ADDON_GROUPS_LINKED: 'No add-on groups linked.',
    CATERING_PRODUCT_SET_SELLING_PRICE_HINT: 'Set the selling price for this product',
    CATERING_PRODUCT_SELECT_TAB: 'Select a tab.',
    CATERING_PRODUCT_PREVIEW: 'Product Preview',
    CATERING_PRODUCT_NO_IMAGE: 'No image',
    CATERING_PRODUCT_UNTITLED: 'Untitled Product',
    CATERING_PRODUCT_NO_CATEGORY_SELECTED: 'No category selected',
    CATERING_PRODUCT_NO_SHORT_DESCRIPTION: 'No short description provided.',
    CATERING_PRODUCT_NO_LONG_DESCRIPTION: 'No long description provided.',
    CATERING_PRODUCT_MIN_LEAD_DAYS_LABEL: 'Min Lead Days',
    CATERING_PRODUCT_MODIFIED_AT: 'Modified at:',
    CATERING_PRODUCT_ID_LABEL: 'Product ID:',
    CATERING_PRODUCT_ERR_MIN_EXCEEDS_MAX: 'Minimum order quantity cannot exceed maximum order quantity',
    CATERING_PRODUCT_ERR_STOCK_LT_MAX: 'Stock balance cannot be less than maximum order quantity',
    CATERING_PRODUCT_ERR_STOCK_LT_MIN: 'Stock balance cannot be less than minimum order quantity',
    CATERING_PRODUCT_DAYS_SUFFIX: 'days',

    // Catering orders UI
    CATERING_ORDER_UPDATE_DATE_TIME: 'Update Date & Time',
    CATERING_ORDER_CUSTOMER_EMAIL_UNAVAILABLE: 'Customer email is not available',
    CATERING_ORDER_SELECT_DATE_RANGE: 'Please select a date range',
    CATERING_ORDER_SELECT_VALID_DATE_RANGE: 'Please select a valid date range',
    CATERING_ORDER_NO_APPROVED_ORDERS: 'No approved orders found matching the selected criteria',
    CATERING_ORDER_NO_APPROVED_IN_RANGE: 'No approved orders found in the selected date range',
    CATERING_ORDER_SELECT_DATE_AND_TIME: 'Please select date and time',
    CATERING_ORDER_DATE_CANNOT_BE_PAST: 'Date cannot be in the past',
    CATERING_ORDER_EXPORT_PDF_SUCCESS: 'Orders exported to PDF successfully',
    CATERING_ORDER_EXPORT_LOAD_FAILED: 'Failed to load orders for export',
    CATERING_ORDER_EXPORT_FAILED: 'Failed to export orders',
    CATERING_ORDER_PRINT_LOAD_FAILED: 'Failed to load orders for printing',
    CATERING_ORDER_PRINT_FAILED: 'Failed to print orders',
    CATERING_ORDER_PRODUCTION_LOAD_FAILED: 'Failed to load orders for production tasks',
    CATERING_ORDER_PRODUCTION_EXPORT_FAILED: 'Failed to export production tasks',

    // KDS
    KDS_TITLE: 'KDS',
    KDS_ORDERS_TITLE: 'Kitchen Orders',
    KDS_ORDERS_DESC: 'Monitor eat-in, takeaway, delivery orders as they move kitchen workflow',
    PENDING_TAG: 'Pending',
    INPROGRESS_TAG: 'Inprogress',
    COMPLETED_TAG: 'Completed',
    ORDER_STATUS_PLACEHOLDER: 'No orders selected',
    ORDER_TYPE_PLACEHOLDER: 'All types',
    ORDER_SEARCH_PLACEHOLDER: 'Search...',
    TABLE_COLUMNS_PLACEHOLDER: 'Select columns',
    ORDER_NUMBER_HEADER: 'Order Number',
    ORDER_CREATED_DATETIME_HEADER: 'Created Date/Time',
    STATUS_HEADER: 'Status',
    ORDER: 'Order',
    REQUEST_REFUND_BTN: 'Request refund',
    REJECT_ORDER_BTN: 'Reject order',
    PRINT_BTN: 'Print',
    SET_COMPLETION_TIME: 'Set completion time:',
    MINUTES_ABBR: 'min',
    CUSTOM: 'Custom',
    ORDER_INFORMATION_HEADER: 'Order Information',
    ORDER_DATE_LABEL: 'Order date:',
    ORDER_TIME_LABEL: 'Order Time:',
    ORDER_METHOD_LABEL: 'Method:',
    DELIVERY_METHOD_D: 'Delivery',
    DELIVERY_METHOD_FD: 'Fixed delivery',
    EATIN_METHOD: 'Eat in',
    TABLE_SERVING_METHOD: 'Table serving',
    TAKEAWAY_METHOD: 'Takeaway',
    TAKEAWAY_FOOD: 'Takeaway food',
    TAKEAWAY_DRINKS: 'Takeaway drinks',
    PRINT_ORDERS_DIALOG_HEADER: 'Print Orders',
    FILTER_BY_STATUS_LABEL: 'Filter by status:',
    SELECT_STATUS_PLACEHOLDER: 'Select status',
    SELECT_PRINT_ORDERS_LABEL: 'Select orders to print:',
    SELECTED_ORDERS_LABEL: '{0} orders selected',
    CHOOSE_ORDERS_PLACEHOLDER: 'Choose orders',
    NO_ORDERS_WITH_STATUS: 'No orders found with status',
    CANCEL_BTN: 'Cancel',
    PRINT_SELECTED_BTN: 'Print selected',
    RECEIPT_NUMBER_HEADER: 'Receipt number',
    ORDER_USER_NAME_HEADER: 'Name',
    ORDER_TYPE_HEADER: 'Order type',
    EMAIL_HEADER: 'Email',
    DELIVERY_LOCATION_HEADER: 'Delivery location',
    PHONE_NUMBER_HEADER: 'Phone number',
    PAYMENT_METHOD_HEADER: 'Payment Method',
    DELIVERY_ADDRESS_LABEL: 'Delivery Address:',
    DELIVERY_LOCATION_LABEL: 'Delivery location:',
    TABLE_LABEL: 'Table:',
    RESERVATION_LABEL: 'Reservation:',
    SCHEDULED_TIME_LABEL: 'Scheduled Time:',
    DISCOUNT_CODE_LABEL: 'Discount Code',
    OFF: 'off',
    CUSTOMER_NOTE_LABEL: 'Customer note:',
    DELIVERY_INSTRUCTIONS_LABEL: 'Delivery instructions:',
    PRODUCTS_HEADER: 'Products',
    FOOD_HEADER: 'Food',
    DRINKS_HEADER: 'Drinks',
    UNKNOWN_PRODUCT: 'Unknown Product',
    QUANTITY_LABEL: 'Quantity',
    ITEM_COMMENT_LABEL: 'Item comment',
    NO_ITEMS: 'No items',
    TOTAL_HEADER: 'Total:',
    CUSTOMER_INFO_HEADER: 'Customer Info',
    FULL_NAME_LABEL: 'Full Name:',
    EMAIL_LABEL: 'Email:',
    PHONE_LABEL: 'Phone:',
    ADDRESS_LABEL: 'Address:',
    PAYMENT_INFO_HEADER: 'Payment Info',
    DETAILS_LABEL: 'Details:',
    DELIVERY_FEE_LABEL: 'Delivery Fee',
    DISCOUNT_LABEL: 'Discount',
    COUPON_DISCOUNT_LABEL: 'Coupon discount',
    BONUS_VOUCHER_LABEL: 'Bonus voucher',
    TOTAL_LABEL: 'Total',
    COMPLETE_SELECTED_ITEMS: 'Complete selected items',
    SET_ORDER_COMPLETED_HEADER: 'Set order completed',
    SET_ORDER_COMPLETED_MESSAGE: 'Are you sure you want to mark the entire order as completed? This cannot be undone.',
    TIMER_STARTED_HEADER: 'Timer Started',
    REJECT_ORDER_CONFIRM_MESSAGE: 'Are you sure you want to reject this order? This cannot be undone.',
    REJECT_ORDER_HEADER: 'Reject Order',
    REJECTED_ORDER_SUMMARY: 'Order Rejected',
    REJECTED_ORDER_DETAIL: 'Order has been rejected.',
    REJECT_ORDER_ERROR_SUMMARY: 'Error',
    REJECT_ORDER_ERROR_DETAIL: 'Failed to reject order.',
    REQUEST_REFUND_CONFIRM_MESSAGE: 'Are you sure you want to request a refund? This action cannot be undone.',
    REQUEST_REFUND_HEADER: 'Request Refund',
    REFUND_REQUESTED_SUMMARY: 'Refund Requested',
    REFUND_REQUESTED_DETAIL: 'Refund has been requested.',
    REQUEST_REFUND_ERROR_SUMMARY: 'Error',
    REQUEST_REFUND_ERROR_DETAIL: 'Failed to request refund.',
    ORDER_STATUS_UPDATED: 'Order status updated',
    FOOD_ITEM_COMPLETED_HEADER: 'Food Item Completed',
    DRINK_ITEM_COMPLETED_HEADER: 'Drink Item Completed',
    ITEMS_COMPLETED_HEADER: 'Items Completed',
    NO_ORDERS: 'No orders found',
    GENERAL_ERROR: 'something went wrong, plesae try again later',
    COMMENT_ENABLED: 'Comment enabled',
    OVERLAPPING_TIME_SLOT: 'Overlaps with existing slot',
    DUPLICATE_DELIVERY_TIME: 'Duplicate delivery time',
    END_TIME_BEFORE_START_TIME: 'End time must be after start time',
    PASSWORD_MANAGEMENT: 'Password Management',
    SEND_PASSWORD_RESET_LINK: 'Send Password Reset Link',
    PASSWORD_RESET_DESCRIPTION: 'Send a secure password reset link to the user’s email address.',
    SEND_RESET_LINK: 'Send Reset Link',
    SET_NEW_PASSWORD: 'Set New Password',
    SET_PASSWORD_DESCRIPTION: 'Directly set a new password for the user. They will be logged out immediately.',
    NEW_PASSWORD: 'New Password',
    UPDATE_PASSWORD: 'Update Password',
    PASSWORD_MIN_LENGTH: 'Password must be at least 6 characters long',
    FILTER_ALL_WARING: 'Please filter orders with same status',
    SELECT_ORDER_WARING: 'You can only select orders with the same status',
    SUCCESSFULLY_UPDATED_DATE_TIME: 'Successfully updated date and time',
    FAILED_TO_UPDATE_DATE_TIME: 'Failed to update date and time',
    KIOSK_INFORMATION: 'Kiosk locations',
    ORDER_LIST_APP_HINT: 'Drag to set the display order in the app. Click Save above to apply.',
    ORDER_LIST_KIOSK_HINT: 'Drag to set the display order for kiosk locations. Click Save above to apply.',
    CORPORATE_CUSTOMERS: 'Corporate Customers',
    INVOICE_MENU: 'Invoice',
    INVOICES: 'Invoices',
    INVOICE_LIST_SUBTITLE: 'Invoices from POS and catering orders awaiting manual forwarding to accounting.',
    INVOICE_LIST_SEARCH: 'Search company, org. number or invoice…',
    INVOICE_LIST_EMPTY: 'No invoices yet',
    INVOICE_LIST_EMPTY_DESCRIPTION: 'Invoices from POS invoice payments and completed catering orders paid by invoice will appear here. Try adjusting the date range or filters.',
    INVOICE_LIST_LOAD_FAILED: 'Failed to load invoices',
    INVOICE_LIST_DATE_RANGE: 'Select date range',
    INVOICE_LIST_TEXT_SEARCH_HINT: 'Search matches company, org. number, invoice number, receipt number and catering order number in the selected date range (up to 100 recent invoices).',
    INVOICE_SOURCE: 'Source',
    INVOICE_SOURCE_ALL: 'All sources',
    INVOICE_SOURCE_POS: 'POS',
    INVOICE_SOURCE_CATERING: 'Catering',
    INVOICE_CATERING_ORDER: 'Catering order',
    INVOICE_OPEN_CATERING_ORDERS: 'Open Catering → Orders',
    INVOICE_LIST_PREVIOUS: 'Previous',
    INVOICE_LIST_NEXT: 'Next',
    INVOICE_LIST_PAGE: 'Page',
    INVOICE_STATUS_CREATED: 'Created',
    INVOICE_STATUS_SENT: 'Sent',
    INVOICE_MARK_SENT: 'Mark sent',
    INVOICE_MARKED_SENT: 'Invoice marked as sent',
    INVOICE_MARK_SENT_FAILED: 'Could not update invoice status',
    INVOICE_PDF_FAILED: 'Could not create invoice PDF',
    OPEN_INVOICE: 'Open invoice',
    INVOICE_DOWNLOAD_SELECTED: 'Download selected',
    INVOICE_LOADING_DETAILS: 'Loading invoice details...',
    INVOICE_TITLE: 'Invoice',
    INVOICE_BILL_FROM: 'Bill From',
    INVOICE_BILL_TO: 'Bill To',
    INVOICE_ISSUED_ON: 'Issued On',
    INVOICE_DETAIL: 'Invoice Detail',
    INVOICE_GRAND_TOTAL: 'Grand Total',
    INVOICE_RECEIPT_LINES_UNAVAILABLE: 'Receipt line details are not available.',
    INVOICE_RECEIPT_DATA_UNAVAILABLE: 'Receipt data unavailable',
    INVOICE_NOT_AVAILABLE: 'Not available',
    INVOICE_CORPORATE_CUSTOMER: 'Corporate customer',
    INVOICE_PAYMENT_METHOD: 'Payment method',
    INVOICE_GENERATED_ON: 'Generated on',
    INVOICE_PAGE_OF: 'Page {0} of {1}',
    INVOICE_DESCRIPTION: 'Description',
    INVOICE_UNIT_PRICE: 'Unit Price',
    INVOICE_QTY: 'Qty',
    INVOICE_VAT: 'VAT',
    INVOICE_DISCOUNT: 'Discount',
    INVOICE_TOTAL: 'Total',
    CORPORATE_CUSTOMERS_SUBTITLE: 'Manage companies and their delivery locations for catering services.',
    CREATE_CORPORATE_CUSTOMER: 'Create Corporate Customer',
    COMPANY_EMAIL: 'Company Email',
    CORPORATE_DELIVERY_LOCATIONS: 'Delivery Locations',
    LOCATIONS: 'Locations',
    CORPORATE_BILLING_INFO: 'Billing Info',
    NO_CORPORATE_CUSTOMERS_TITLE: 'No corporate customers yet',
    NO_CORPORATE_CUSTOMERS_DESCRIPTION: 'Create your first corporate customer to manage billing contacts and delivery locations.',
    CREATE_FIRST_CORPORATE_CUSTOMER: 'Create First Corporate Customer',
    ORGANIZATION_NUMBER: 'Organization Number',
    ORGANIZATION_ID: 'Organization ID',
    NEXT: 'Next',
    EDIT_CORPORATE_CUSTOMER: 'Edit Corporate Customer',
    LEGAL_ENTITY_INFORMATION: 'Legal Entity Information',
    LEGAL_NAME: 'Legal Name',
    VAT_NUMBER: 'VAT Number',
    BILLING_ADDRESS: 'Billing Address',
    STREET_ADDRESS: 'Street Address',
    POSTAL_CODE: 'Postal Code',
    INVOICE_SETTINGS: 'Invoice Settings',
    INVOICE_EMAIL: 'Invoice Email',
    PAYMENT_TERMS_DAYS: 'Payment Terms (Days)',
    BILLING_CONTACT: 'Contact',
    CONTACT_NAME: 'Contact Name',
    ADDED_LOCATIONS: 'Added Locations',
    ADD_DELIVERY_LOCATION: 'Add Delivery Location',
    FLOOR: 'Floor',
    ENTRANCE_CODE: 'Entrance Code',
    DEFAULT_REFERENCE: 'Default Reference',
    REVIEW_INFORMATION: 'Review Information',
    LEGAL_ENTITY: 'Legal Entity',
    PAYMENT_TERMS: 'Payment Terms',
    SUB_LOCATIONS: 'Sub-Locations',
    ADD_SUB_LOCATION: 'Add Sub Location',
    ROOM_CODE: 'Room Code',
    SUB_LOCATION_NAME: 'Sub Location Name',
    LOCATION_NAME: 'Location Name',
    STEP_COMPANY_INFO: 'Company Info',
    EDIT_LOCATION_AND_SUBLOCATIONS: 'Edit location & sub-locations',
    STEP_BILLING_AND_INVOICE: 'Billing & Invoice',
    NO_DELIVERY_LOCATIONS: 'No delivery locations yet',
    CORPORATE_CUSTOMER_CREATED: 'Corporate customer created.',
    CORPORATE_CUSTOMER_UPDATED: 'Corporate customer updated.',
    CORPORATE_CUSTOMER_DELETED: 'Corporate customer deleted.',
    CORPORATE_CUSTOMER_SAVE_FAILED: 'Failed to save corporate customer.',
    CORPORATE_CUSTOMER_DELETE_FAILED: 'Failed to delete corporate customer.',
    CORPORATE_GROUP_ERR_FORBIDDEN: 'You are not an admin of a restaurant in this group.',
    CORPORATE_GROUP_ERR_INVALID: 'The company was not saved:',
    CORPORATE_CUSTOMER_DELETE_CONFIRM: 'Are you sure you want to delete this corporate customer?',
    DELETE_CONFIRMATION: 'Delete confirmation',
    DELIVERY_LOCATIONS_SUBTITLE: 'Delivery locations and sub-locations for this company',
    BILLING_INFO_SUBTITLE: 'Billing and invoice information for this corporate customer',

    // Catering Orders – delivery & invoice details
    DELIVERY_INFORMATION: 'Delivery Information',
    CORPORATE_COMPANY: 'Corporate Company',
    COMPANY_PHONE: 'Company Phone',
    DELIVERY_LOCATION: 'Delivery Location',
    DELIVERY_ROOM: 'Delivery Room',
    DOOR_CODE: 'Door Code',
    INVOICE_NUMBER: 'Invoice Number',
    SUCCEEDED: 'Succeeded',
    DELIVERY_ROOM_FLOOR: 'Room Floor',
    DELIVERY_ROOM_DOOR_CODE: 'Room Code',
    YES_DELETE: 'Yes, Delete',
    TABLE_QR_CODE: 'Table QR Code',
    TABLE_DETAILS: 'Table Details',
    TABLE_MANAGMENT: 'Table Management',
    TABLE_MANAGMENT_DESCRIPTION: 'Manage table groups. Each group defines a range of tables (e.g. 70–100). Tables are generated dynamically — nothing is stored individually',
    SERVING_METHOD_NAME: 'Serving Method Name',
    SERVING_METHOD_NAME_DESC: 'Configure how this serving method should be displayed across sales channels.',
    TABLE_SERVING_OPTION: 'Table Serving',
    SEAT_SERVING_OPTION: 'Seat Serving',
    NEW_GROUP: 'Add Group',
    WEB_ORDER_URL: 'Web Order URL',
    GENERAL_: 'General',
    ROUTE_NAME: 'RouteName',
    WEB_ORDER_URL_NOTE: 'If no custom URL is provided, the system will automatically use the default URL',
    SEO_SETTINGS: 'SEO Settings',
    SEO_SETTINGS_DESC: 'Configure search engine optimization metadata for this unit to improve how it appears on Google.',
    SEO_TITLE: 'SEO Title',
    SEO_TITLE_NOTE: 'Title shown in Google search results and the browser tab. Leave empty to use the default title.',
    SEO_DESCRIPTION: 'SEO Description (Meta Description)',
    SEO_DESCRIPTION_NOTE: 'Short summary shown below the title in Google search results. Recommended length: 120-160 characters.',
    DOWNLOAD_ALL_QR: 'Download All QR',
    WEB_ORDER_BASE_URL: 'Web Order Base URL',
    CREATE_TABLE_GROUP: 'Create Table Group',
    EDIT_TABLE_GROUP: 'Edit Table Group',
    CREATE_SEAT_GROUP: 'Create Seat Group',
    EDIT_SEAT_GROUP: 'Edit Seat Group',
    TABLE_RANGE: 'Table Range',
    SEAT_RANGE: 'Seat Range',
    TABLES_WILL_GENERATE: 'This will generate {count} tables',
    SEATS_WILL_GENERATE: 'This will generate {count} seats',
    END_MUST_BE_GREATER_EQUAL_START: 'End must be ≥ Start',
    SELECT_ALL: 'Select All',
    DOWNLOAD_RANGE: 'Download Range',
    QR_CODE: 'QR Code',
    FORMAT: 'Format',
    DOWNLOAD_AS: 'Download As',
    TABLES: 'Tables',
    SEATS: 'Seats',
    SEAT: 'Seat',
    SEAT_GROUPS: 'Seat Groups',
    SEAT_MANAGEMENT_DESCRIPTION: 'Manage seat groups. Each group defines a range of seats (e.g. 70–100). Seats are generated dynamically — nothing is stored individually.',
    VIEW_TABLES: 'View tables',
    VIEW_SEATS: 'View seats',
    NO_TABLE_GROUPS_YET: 'No table groups yet',
    NO_SEAT_GROUPS_YET: 'No seat groups yet',
    GROUP_NAME_REQUIRED: 'Group name is required',
    UNIT_NAME_REQUIRED: 'Unit name is required',
    WEB_ORDER_URL_REQUIRED: 'Web Order URL is required',
    TABLE_RANGE_REQUIRED: 'Table range is required',
    SEAT_RANGE_REQUIRED: 'Seat range is required',
    START_MUST_BE_LESS_EQUAL_END: 'Start must be ≤ End',
    MAX_1000_TABLES_ALLOWED: 'Range cannot exceed 1000 tables per group',
    MAX_1000_SEATS_ALLOWED: 'Range cannot exceed 1000 seats per group',
    DELETE_GROUP_CONFIRM: 'Delete "{group}" ({tables} {start}–{end})? This cannot be undone.',
    GROUP_DELETED: 'Group deleted',
    FAILED_DELETE_GROUP: 'Failed to delete group',
    SEARCH_GROUPS: 'Search groups...',
    DOWNLOADED: 'Downloaded',
    DOWNLOADING_QR_CODES: 'Downloading QR Codes',
    NO_PRINTERS_SELECTED: 'No printers selected',
    SELECT_PRINTERS_IN_SETTINGS: 'Select printers from Settings -> Printers',
    PRINT_SUCCESS: 'Success',
    ORDER_PRINTED_SUCCESSFULLY: 'Order printed successfully',
    CURRENT_WEEK: 'Current week',
    NEXT_WEEK: 'Next week',
    ROLLOVER_SETTINGS: 'Rollover settings',
    ROLLOVER_DESCRIPTION: 'Control when the ordering app should offer next week for pre-orders.',
    ROLLOVER_ENABLED: 'Automatic rollover',
    ROLLOVER_ENABLED_HINT: 'When enabled, next week is promoted to current at the configured day/time.',
    ROLLOVER_CUTOFF_DAY: 'Cutoff day',
    ROLLOVER_CUTOFF_TIME: 'Cutoff time',
    ROLLOVER_NOW: 'Rollover now',
    ROLLOVER_CONFIRM_MESSAGE: 'This will promote next week into current week. Next week is kept as-is — use "Reset next week" if you want to blank it. Continue?',
    ROLLOVER_PERFORMED: 'Rollover performed',
    ROLLOVER_FAILED: 'Rollover failed',
    ROLLOVER_SETTINGS_SAVED: 'Rollover settings saved',
    NEXT_ROLLOVER_IN: 'Customers start ordering for next week from',
    MANUAL_ACTIONS: 'Manual actions',
    MANUAL_ROLLOVER_DESCRIPTION: 'Weeks are stored by week number, so there is no data rollover to run. Use these actions to seed or clear the next week manually.',
    CLONE_CURRENT_TO_NEXT: 'Clone current into next',
    CLONE_CURRENT_TO_NEXT_CONFIRM: 'This will overwrite next week with a copy of current week. Continue?',
    CLONE_CURRENT_TO_NEXT_DONE: 'Current week copied into next',
    CLONE_CURRENT_TO_NEXT_FAILED: 'Failed to clone current into next',
    RESET_NEXT_WEEK: 'Reset next week',
    RESET_NEXT_WEEK_CONFIRM: 'This will clear next week back to a blank template (no products, weekends closed). Continue?',
    RESET_NEXT_WEEK_DONE: 'Next week reset to blank template',
    RESET_NEXT_WEEK_FAILED: 'Failed to reset next week',
    REMOVE_ORPHAN_WEEKLY_MENUS: 'Remove {{count}} old weekly menu week(s)',
    REMOVE_ALL_PAST_WEEKS_CONFIRM: 'Remove {{count}} past week(s) from database? Current and next week will be kept. This cannot be undone.',
    REMOVE_ALL_PAST_WEEKS_DONE: 'Removed {{count}} past week(s)',
    REMOVE_ALL_PAST_WEEKS_FAILED: 'Failed to remove past weeks',
    TIME_SETTINGS: 'Time settings',
    NO_PRODUCTS_YET: 'No products yet',
    ALL_PRODUCTS_ALREADY_ADDED: 'All products already added',
    NO_WEEKLY_MENU_PRODUCTS_ENABLED: 'No products are enabled for weekly menu ordering. Enable products under the products advanced settings to start adding them to your weekly menu.',
    ENABLE_MORE_PRODUCTS_HINT: 'To add more products, enable them under Product > Advanced Settings.',
    ADD_PRODUCTS: 'Add products',
    ADD_MORE_PRODUCTS: 'Add more products',
    NO_PRODUCTS_SELECTED_FOR_DAY: 'No products added for this day yet',
    SCHEDULED_TAG: 'Scheduled',
    ACTIVE_TAG: 'Active',
    TODAY_LABEL: 'Today',
    WEEKLY_MENU_ORDERING: 'Weekly menu ordering',
    ALL_DAYS: 'All days',
    DAYS_SELECTED_LABEL: '{0} days selected',
    ALL_WEEKS_LABEL: 'All weeks',
    CURRENT_WEEK_LABEL: 'Current week',
    UPCOMING_WEEK_LABEL: 'Upcoming week',
    WEEK_SCOPE_PLACEHOLDER: 'Week',
    DAYS_LABEL: 'Days',
    WEEKLY_TIMELINE_HEADER: 'Weekly Timeline',
    WEEKLY_SCOPED_READONLY_BANNER: 'This weekly order can only be completed on its scheduled day.',
    WEEKLY_SCOPED_START_PREPARING_BTN: 'Start preparing',
    WEEKLY_SCOPED_STARTED_SUCCESS_SUMMARY: 'Started preparing',
    WEEKLY_SCOPED_STARTED_SUCCESS_DETAIL: 'Weekly scoped order is now in progress.',
    WEEKLY_SCOPED_MISSING_ETA_SUMMARY: 'No finish time for this day',
    WEEKLY_SCOPED_MISSING_ETA_DETAIL: 'Set a timer when you start preparing if you want a visible countdown here.',
    WEEKLY_SCOPED_PENDING_SELECTION_HINT: 'Start preparing to unlock item selection for this day.',
    ADDON_SERVING_METHODS: 'Serving methods',
    ADDON_SERVING_METHODS_HINT: 'All serving methods are enabled by default. Uncheck a method to hide this addon for that serving method.',
    ADDONS_V2_RULES_SECTION: 'Selection rules',
    ADDON_WIZARD_RULES: 'Rules',
    ADDON_LABEL_SELECTION_TYPE: 'Addon type',
    ADDON_LABEL_PRESELECT_MODE: 'Preselect mode',
    ADDON_LABEL_MIN_SELECTIONS: 'Min selections',
    ADDON_LABEL_MAX_SELECTIONS: 'Max selections',
    ADDON_REQUIRED_BEFORE_PROCEED: 'Required before guest can proceed',
    ADDON_LABEL_PRESELECTED_OPTION: 'Preselected option',
    SHOW_WHEN_RULES: 'When to show',
    SHOW_WHEN_HINT: 'This group only appears when specific conditions are met from another group selection.',
    ACTIVE_DEPENDENCIES: 'Active dependencies',
    DEPENDS_ON_GROUP: 'Depends on group',
    OPTIONS_TO_TRIGGER: 'Options to trigger',
    ADD_DEPENDENCY: 'Add dependency',
    SHOW_WHEN_GROUP_PREFIX: 'Show when',
    SHOW_WHEN_INCLUDES_VERB: 'includes',
    ADDON_VALIDATE_INVALID_PAYLOAD: 'Invalid addon rules',
    ADDON_VALIDATE_MAX_SELECTIONS_RADIO: 'Single-choice groups must use max selections = 1',
    ADDON_VALIDATE_PRESELECT_SPECIFIC: 'Choose a preselected option or change preselect mode',
    ADDON_VALIDATE_MAX_LT_MIN: 'Max selections cannot be less than min selections',
    ADDON_SELECT_ONE_RADIO: 'Single choice (radio)',
    ADDON_SELECT_MULTIPLE_CHECKBOX: 'Multiple (checkboxes)',
    ADDON_PRESELECT_NONE: 'None',
    ADDON_PRESELECT_FIRST: 'First option',
    ADDON_PRESELECT_SPECIFIC: 'Specific option',
    SUBTITLE_LABEL: 'Subtitle',
    ALWAYS_VISIBLE: 'Always visible',
    VISIBLE_IN_DELIVERY_MENU: 'Visible for delivery menu',
    VISIBLE_IN_TAKEAWAY_MENU: 'Visible for takeaway menu',
    VISIBLE_IN_EATIN_MENU: 'Visible for eat-in menu',
    VISIBLE_IN_TABLEORDER_MENU: 'Visible for table order menu',
    VISIBLE_IN_DELIVERYSETLOCATION_MENU: 'Visible for delivery set location menu',
    WELCOME: 'Welcome',
    HELLO: 'Hello',
    GOOD_MORNING: 'Good morning',
    GOOD_EVENING: 'Good evening',
    GOOD_NIGHT: 'Good night',
    OPTIONAL: 'Optional',
    UNLINK: 'Unlink',
    CAROUSEL: 'Collections',
    SLIDE_PLAYBACK_FAILED: 'Playback failed',
    MENU_DISPLAY: 'Menu display',

    INGREDIENTS: 'Ingredients',
    INGREDIENTS_DESCRIPTION: 'Select ingredients included in this product by default.',
    SELECT_FROM_LIBRARY: 'Select from library',
    CHOOSE_INGREDIENTS: 'Choose ingredients...',
    NO_INGREDIENTS_LIBRARY: 'No ingredients in the library.',
    CREATE_NEW_INGREDIENT: 'Create new ingredient',
    INGREDIENT_PLACEHOLDER: 'e.g. Onion',
    INGREDIENT_HINT: 'Press Enter or click + to add.',
    SELECTED_INGREDIENTS: 'Selected ingredients',
    NO_INGREDIENTS_SELECTED: 'No ingredients selected yet.',
    FAILED_LOAD_INGREDIENTS: 'Failed to load ingredients. Try again.',
    FAILED_CREATE_INGREDIENT: 'Failed to create ingredient. Try again.',
    CONFIRM_DELETE_INGREDIENT: 'Are you sure you want to delete this ingredient from the library permanently?',
    DELETE_INGREDIENT: 'Delete ingredient',
    INGREDIENT_DELETED_LIBRARY: 'Ingredient deleted from the library.',
    FAILED_DELETE_INGREDIENT: 'Failed to delete ingredient. Try again.',
    WITHOUT: 'Without',
    CATERING_ADDON_ERR_DELIVERY_METHOD_REQUIRED: 'At least one delivery method must be selected.',
    CATERING_ADDON_ERR_PRICE_NEGATIVE: 'Option price cannot be negative.',
    NO_DATA: 'No Data Available',
    NO_DATA_HINT: 'There is currently nothing to display.',

    // Catering: no-login order-by-invoice checkout
    GUEST_INVOICE_ORDERING: "Guest invoice ordering",
    GUEST_INVOICE_ORDERING_DESC: "Enables no-login order-by-invoice for this restaurant. Guests enter their company and billing details at checkout instead of paying.",
    CATERING_SHOW_PRICES_EX_VAT: "Show prices excluding VAT (B2B)",
    CATERING_SHOW_PRICES_EX_VAT_DESC: "Shows catering prices excluding VAT in the webshop, with VAT and the total incl. VAT at checkout. Display only: the amount charged is unchanged.",
    TABLE_BOOKING_SETTINGS: 'Table booking',
    TABLE_BOOKING_SETTINGS_DESC: 'Manage guest limits, booking durations, and shift configurations for table booking.',
    RESTAURANT_LOGO_URL: 'Restaurant Logo URL (logoUrl)',
    RESTAURANT_LOGO_URL_HINT: 'The logo is displayed above the restaurant name on the booking page.',
    MIN_NR_OF_GUESTS: 'Minimum Number of Guests (minNrOfGuests)',
    MIN_NR_OF_GUESTS_HINT: 'Minimum party size a guest can select when booking.',
    MAX_NR_OF_GUESTS: 'Maximum Number of Guests (maxNrOfGuests)',
    MAX_NR_OF_GUESTS_HINT: 'Maximum party size a guest can select when booking.',
    DEFAULT_BOOK_DURATION_HOURS: 'Default Booking Duration in Hours (bookDurationHours)',
    DEFAULT_BOOK_DURATION_HOURS_HINT: 'Default dining duration per table booking (e.g. 2 hours).',
    DEFAULT_SLOT_INTERVAL_HOURS: 'Default Booking Interval in Hours (slotIntervalHours)',
    DEFAULT_SLOT_INTERVAL_HOURS_HINT: 'Interval step between bookable start times (e.g. 0.25 = 15 minutes).',
    BOOK_DURATIONS_TITLE: 'Shift & Period Configuration (bookDurations)',
    BOOK_DURATIONS_DESC: 'Customize dining durations and slot intervals for different times of day (e.g. lunch vs dinner).',
    ADD_SHIFT: 'Add Shift',
    START_TIME: 'Start Time (startTime)',
    DURATION_HOURS: 'Dining Duration in Hours (durationHours)',
    SLOT_HOURS: 'Slot Interval in Hours (slotHours)',
    NO_SHIFTS_CONFIGURED: 'No specific shift configurations added. Default settings above apply to the whole day.',
    SETTINGS_SAVE_ERROR: 'Failed to save settings.',
    POS_V2_FREE_TEXT_BUTTON_LABEL: 'Button label',
    POS_V2_FREE_TEXT_BUTTON_LABEL_HELP: 'Text displayed on the button tile in the POS screen.',
    POS_V2_FREE_TEXT_PRESET_LABEL: 'Preset receipt text',
    POS_V2_FREE_TEXT_PRESET_HELP: 'If filled, tapping the button adds this note immediately in 1 tap. If left blank, the POS will open a keyboard so cashiers can type on the spot.',
    POS_V2_BUTTON_STOCK: 'Button Stock',
    POS_V2_BUTTON_STOCK_DESC: 'Secondary popup grid on POS',
    POS_V2_FREE_TEXT_DESC: 'Receipt note or custom message',
    POS_V2_FREE_TEXT_LABEL_PLACEHOLDER: 'e.g. Note',
    POS_V2_FREE_TEXT_PRESET_PLACEHOLDER: 'e.g. No onions',
    POS_V2_STOCK_LABEL_PLACEHOLDER: 'e.g. Sauces',
    POS_V2_STOCK_BUTTON_LABEL: 'Stock button name',
    POS_V2_ADD_STOCK_BUTTON: 'Add Button Stock',
    CLEAR_SEARCH: 'Clear search',
    BUTTONS: 'Buttons',
    ITEM: 'item',
    ITEMS: 'items',
    BACKGROUND: 'Background:',
    POS_V2_CUSTOM_NAME: 'Custom name',
    POS_V2_EDIT_CUSTOM_NAME: 'Edit custom name',
    POS_V2_RESET_TO_MENU_NAME: 'Reset to menu name',
    POS_V2_SOLID_COLOR: 'Solid Color',
    POS_V2_PRODUCT_PHOTO: 'Product Photo',

    // --- Order validation devices ---------------------------------------------
    ORDER_VALIDATION_MENU: 'Order validation',
    ORDER_VALIDATION_DEVICES: 'Devices',
    ORDER_VALIDATION_DEVICES_SUBTITLE: 'The QR terminals customers scan their order at. Changes here apply to the terminal by themselves.',
    ORDER_VALIDATION_DEVICES_TABLE_TITLE: 'Terminals',
    ORDER_VALIDATION_DEVICES_ADD: 'Add terminal',
    ORDER_VALIDATION_DEVICES_CREATE: 'Create',
    ORDER_VALIDATION_DEVICES_EDIT: 'Terminal settings',
    ORDER_VALIDATION_DEVICES_NAME: 'Name',
    ORDER_VALIDATION_DEVICES_NAME_PLACEHOLDER: 'e.g. Entrance terminal',
    ORDER_VALIDATION_DEVICES_NAME_REQUIRED: 'Give the terminal a name',
    ORDER_VALIDATION_DEVICES_ID: 'Device ID',
    ORDER_VALIDATION_DEVICES_ROUTE: 'Restaurant',
    ORDER_VALIDATION_DEVICES_ROUTE_HELP: 'The unit this terminal validates for. Orders from anywhere else are refused.',
    ORDER_VALIDATION_DEVICES_ROUTE_REQUIRED: 'Choose a restaurant',
    ORDER_VALIDATION_DEVICES_LANGUAGE: 'Language',
    ORDER_VALIDATION_DEVICES_LANGUAGE_UNSET: 'Leave to the terminal',
    ORDER_VALIDATION_DEVICES_LANGUAGE_HELP: 'Left empty, the terminal keeps whatever was chosen on it.',
    ORDER_VALIDATION_DEVICES_SOUNDS: 'Sounds',
    ORDER_VALIDATION_DEVICES_SOUND_SUCCESS: 'Sound on a valid scan',
    ORDER_VALIDATION_DEVICES_SOUND_FAILURE: 'Sound on a failed scan',
    ORDER_VALIDATION_DEVICES_VERSION: 'Version',
    ORDER_VALIDATION_DEVICES_LAST_SEEN: 'Last seen',
    ORDER_VALIDATION_DEVICES_ONLINE: 'Online',
    ORDER_VALIDATION_DEVICES_EMPTY: 'No terminals yet. Add one, then enter its ID on the terminal.',
    ORDER_VALIDATION_DEVICES_CREATED_HELP: 'Enter this ID on the terminal, under the PubQ logo, to connect it.',
    ORDER_VALIDATION_DEVICES_ID_COPIED: 'Device ID copied',
    ORDER_VALIDATION_DEVICES_CREATE_FAILED: 'Could not create the terminal',
    ORDER_VALIDATION_DEVICES_SAVED: 'Terminal settings saved',
    ORDER_VALIDATION_DEVICES_SAVE_ERROR: 'Could not save the terminal settings',
    ORDER_VALIDATION_DEVICES_LOAD_ERROR: 'Could not load the terminals',
    ORDER_VALIDATION_DEVICES_REMOVE: 'Remove',
    ORDER_VALIDATION_DEVICES_REMOVE_CONFIRM: 'Remove this terminal from the unit?',
    ORDER_VALIDATION_DEVICES_REMOVE_WARNING: 'The terminal keeps validating on the settings it already has. Removing it here only takes it off this list.',
    ORDER_VALIDATION_DEVICES_REMOVED: 'Terminal removed',
    ORDER_VALIDATION_DEVICES_REMOVE_FAILED: 'Could not remove the terminal',
    // Integrations + Fortnox (Z): translated from Swedish
    INTEG_TITLE: "Integrations",
    INTEG_OVERVIEW: "Overview",
    INTEG_THIS_RESTAURANT: "the restaurant",
    INTEG_LOADING_STATUS: "Loading status…",
    INTEG_COMING_SOON: "Coming soon",
    INTEG_REAUTH: "The connection must be approved again",
    INTEG_NOT_CONNECTED: "Not connected",
    INTEG_NO_ACCESS: "No access",
    INTEG_MANAGE: "Manage",
    INTEG_ACTIVATE: "Activate",
    INTEG_DESC_FORTNOX: "Books every closed Z report as a voucher in the company's Fortnox. Cost center and account mapping per restaurant.",
    INTEG_DESC_PERSONALKOLLEN: "Scheduling and time reporting: staff, shifts and wage costs synced with PubQ.",
    INTEG_DESC_TCPOS: "Sales export to TCPOS (SOAP / REST) for chains that report in TCPOS.",
    FZ_TITLE: "Fortnox – Z reports",
    FZ_INTRO: "Every closed Z report can be booked as a voucher in the company's Fortnox.",
    FZ_MODE_MOCK: "TEST MODE (mock): nothing is sent to Fortnox; voucher numbers are made up.",
    FZ_MODE_READONLY: "READ-ONLY MODE: the connection and the checks against Fortnox work, but no vouchers are created.",
    FZ_NO_UNIT: "No restaurant is selected. Choose a restaurant in the menu.",
    FZ_NOTICE_CONNECTED: "Fortnox is connected for the company.",
    FZ_CONNECTION_HEADER: "Connection (the company)",
    FZ_RETRY: "Try again",
    FZ_CONNECTED_TO: "Connected to",
    FZ_DISCONNECT_COMPANY: "Disconnect the company…",
    FZ_BELONGS_TO: "The restaurant belongs to",
    FZ_ORG_MISSING: "org. no. missing",
    FZ_CONNECT_HELP: "You sign in to the company's Fortnox as an administrator and approve. The Fortnox account must have the same organisation number.",
    FZ_CONNECT: "Connect Fortnox",
    FZ_DISCONNECTED_OK: "Fortnox disconnected for the company",
    FZ_LISTS_STILL_SAVE: "you can still save the settings.",
    FZ_AUTO_EXPORT: "Automatic export",
    FZ_COST_CENTER: "Cost center",
    FZ_NONE: "– none –",
    FZ_LOADING_COST_CENTERS: "Loading cost centers…",
    FZ_NO_COSTCENTER_SCOPE: "The connection lacks the \"cost centers\" permission – Fortnox checks the code when booking.",
    FZ_VOUCHER_SERIES: "Voucher series",
    FZ_COMPANY_DEFAULT: "– the company's default –",
    FZ_ROUNDING_ACCOUNT: "Account for öre rounding",
    FZ_REVIEW_FIRST: "Review the first ones manually",
    FZ_ACCOUNT_MAPPING: "Account mapping",
    FZ_ACCOUNT_MAPPING_HELP: "Replaces an account from the till with another account in Fortnox (or \"drop\" for rows without an amount).",
    FZ_POS_ACCOUNT: "Till account",
    FZ_FORTNOX_ACCOUNT: "Fortnox account",
    FZ_ADD_MAPPING: "Add mapping",
    FZ_SAVE: "Save",
    FZ_SETTINGS_SAVED: "The settings were saved",
    FZ_ZREPORTS: "Z reports",
    FZ_COL_BUSINESS_DATE: "Business day",
    FZ_COL_TOTAL: "Total",
    FZ_COL_STATUS: "Status",
    FZ_TEST: "test",
    FZ_STATUS_NOT_SENT: "Not sent",
    FZ_STATUS_PENDING: "Queued",
    FZ_STATUS_HELD: "Awaiting review",
    FZ_STATUS_SENDING: "Sending",
    FZ_STATUS_SENT: "Sent",
    FZ_STATUS_FAILED: "Failed",
    FZ_STATUS_LEGACY: "Booked (old flow)",
    FZ_PREVIEW: "Preview",
    FZ_APPROVE_SEND: "Approve & send",
    FZ_SEND: "Send",
    FZ_RESEND_ELLIPSIS: "Send again…",
    FZ_EMPTY: "No closed Z reports yet.",
    FZ_BACKFILL_LABEL: "Send past Z",
    FZ_FROM: "from",
    FZ_TO: "to",
    FZ_BACKFILL: "Send past",
    FZ_BACKFILL_HELP: "Oldest first. Already booked ones are skipped. Stops at the first error.",
    FZ_NOT_SENT_BECAUSE: "Will not be sent:",
    FZ_COL_ACCOUNT: "Account",
    FZ_COL_TEXT: "Text",
    FZ_COL_DEBIT: "Debit",
    FZ_COL_CREDIT: "Credit",
    FZ_COL_COST_CENTER_SHORT: "CC",
    FZ_SUM: "Total",
    FZ_CLOSE: "Close",
    FZ_RESEND_SECOND: "Sending again creates a second voucher for the same day.",
    FZ_RESEND_VOID_HINT: "Void the first one in Fortnox if it is wrong.",
    FZ_TYPE_TO_CONFIRM: "Type the following to confirm:",
    FZ_TYPE_ORGNO_TO_CONFIRM: "Type the organisation number to confirm:",
    FZ_CANCEL: "Cancel",
    FZ_RESEND: "Send again",
    FZ_DISCONNECT_TITLE: "Disconnect Fortnox?",
    FZ_DISCONNECT_EFFECT: "Automatic export stops working until someone connects again.",
    FZ_DISCONNECT: "Disconnect",
    FZ_ERROR: "Error",
    FZ_REFUSED_ALREADY_SENT: "already booked",
    FZ_REFUSED_IN_PROGRESS: "already being sent",
    FZ_REFUSED_HELD: "awaiting review",
    FZ_TOAST_MOCK: "TEST – mock",
    FZ_ERR_FORBIDDEN: "You do not have access to this restaurant.",
    FZ_ERR_LOAD: "Could not be loaded",
    FZ_ERR_CONNECTION: "The connection could not be loaded",
    FZ_ERR_LISTS: "Accounts and cost centers could not be loaded from Fortnox",
    FZ_ERR_ZLIST: "The Z reports could not be loaded",
    FZ_ERR_NOT_SIGNED_IN: "You are not signed in.",
    FZ_ERR_SERVICE_TIMEOUT: "The Fortnox service did not answer in time",
    FZ_ERR_UNREACHABLE: "Could not reach the Fortnox service (network or CORS)",
    // Status page (third-party service status)
    MENU_NAV_STATUS: "System status",
    MENU_SECTION_OVERVIEW: "Overview",
    MENU_SECTION_MENU: "Menu & products",
    MENU_SECTION_CHANNELS: "Sales channels",
    MENU_SECTION_GUESTS: "Marketing",
    MENU_SECTION_ECONOMY: "Sales & finance",
    MENU_SECTION_ADMIN: "Administration",
    MENU_SEARCH_PLACEHOLDER: "Search the menu",
    MENU_SEARCH_EMPTY: "No pages match",
    STATUS_PAGE_TITLE: "System status",
    STATUS_PAGE_SUBTITLE: "Status of the third-party services your unit uses",
    PROVIDER_REFRESH: "Refresh",
    PROVIDER_SECTION_TITLE: "Third-party services",
    PROVIDER_ISSUES_COUNT: "Services with issues",
    PROVIDER_ALL_OPERATIONAL: "All services operational",
    PROVIDER_LAST_UPDATED: "Updated",
    PROVIDER_STATUS_PAGE: "Status page",
    PROVIDER_FETCH_FAILED: "Could not fetch status",
    PROVIDER_LOADING: "Loading…",
    PROVIDER_EVENTS_TITLE: "Events",
    PROVIDER_NO_EVENTS: "No ongoing, scheduled or recently resolved events.",
    PROVIDER_PER_PAGE: "Per page:",
    PROVIDER_LEVEL_OPERATIONAL: "Operational",
    PROVIDER_LEVEL_MAINTENANCE: "Maintenance",
    PROVIDER_LEVEL_DEGRADED: "Degraded",
    PROVIDER_LEVEL_PARTIAL_OUTAGE: "Partial outage",
    PROVIDER_LEVEL_MAJOR_OUTAGE: "Major outage",
    PROVIDER_LEVEL_UNKNOWN: "Unknown",
    PROVIDER_EVENT_RESOLVED: "Resolved",
    PROVIDER_EVENT_SCHEDULED_MAINTENANCE: "Scheduled maintenance",
    PROVIDER_EVENT_ONGOING_MAINTENANCE: "Ongoing maintenance",
    PROVIDER_EVENT_ONGOING_INCIDENT: "Ongoing incident",


    // --- Organisation: group figures, shared catalog, shared offers -----------
    ORG_MENU: "Organisation",
    ORG_ORGANISATION: "Organisation",
    ORG_DASHBOARD: "Overview",
    ORG_DASHBOARD_SUBTITLE: "Sales across the whole group, and per unit.",
    ORG_CATALOG: "Shared product catalog",
    ORG_CATALOG_SUBTITLE: "Products the group shares. Publishing writes into each unit's own menu.",
    ORG_CATALOG_HOW_IT_WORKS: "Publishing writes the product into each selected unit's own menu — which is why every register journals its own price change. Units with a pinned local price are skipped.",
    ORG_COUPONS: "Shared offers",
    ORG_COUPONS_SUBTITLE: "Coupons and offers the group shares with its units.",
    ORG_COUPONS_HOW_IT_WORKS: "Define the offer centrally and share it with the units that should have it. A unit may carry its own value.",
    ORG_ACCESS: "Organisation access",
    ORG_ACCESS_SUBTITLE: "Who sees the group's figures, and who may administer them.",
    ORG_ACCESS_WARNING: "Being a member of an organisation does not grant access to the group's sales. Only an explicit role here does — 841 users already hold an organisation row, and they must not see chain-wide figures by accident.",
    ORG_UNITS: "units",
    ORG_UNIT: "Unit",
    ORG_COMPANIES: "companies",
    ORG_PERIOD: "Period",
    ORG_TOTAL_SALES: "Sales",
    ORG_RECEIPTS: "receipts",
    ORG_AVG_RECEIPT: "Average receipt",
    ORG_SALES_PER_DAY: "Sales per day",
    ORG_SALES_PER_HOUR: "Sales per hour",
    ORG_PER_UNIT: "Per unit",
    ORG_PAYMENTS: "Payment methods",
    ORG_PAYMENT_METHOD: "Payment method",
    ORG_TOP_PRODUCTS: "Top products",
    ORG_PRODUCT: "Product",
    ORG_CATEGORY: "Category",
    ORG_QUANTITY: "Quantity",
    ORG_AMOUNT: "Amount",
    ORG_COUNT: "Count",
    ORG_SHARE: "Share",
    ORG_TOTAL: "Total",
    ORG_NO_DATA: "No data for this period.",
    ORG_NO_UNITS: "No units in this organisation.",
    ORG_MULTI_CURRENCY: "The group has units in several currencies. Totals are shown per currency — never added together.",
    ORG_UNITS_TRUNCATED: "More units than one call holds. These are not included:",
    ORG_STATS_UNAVAILABLE: "The statistics service is not enabled in this environment.",
    ORG_STATS_FAILED: "The statistics could not be loaded.",
    ORG_LOAD_FAILED: "Could not be loaded.",
    ORG_SAVE_FAILED: "Could not be saved.",
    ORG_ERROR: "Error",
    ORG_SAVED: "Saved",
    ORG_UNITS_SAVED: "Units saved",
    ORG_DEMO_DATA: "DEMO DATA",
    ORG_DEMO_DATA_HELP: "The endpoint is not live yet. What you see is made up and is not saved.",
    ORG_DEMO_NOT_SAVED: "Demo data — nothing was saved.",
    ORG_LIVE_DATA: "Live data",
    ORG_DERIVED_UNITS: "Your own units",
    ORG_DERIVED_UNITS_HELP: "The units are the ones you are assigned to, grouped by organisation. The server's own unit list is not ready, so a group may show too few units.",
    ORG_NEW_PRODUCT: "New product",
    ORG_EDIT_PRODUCT: "Edit product",
    ORG_NO_PRODUCTS: "No products in the catalog yet.",
    ORG_NAME: "Name",
    ORG_DESCRIPTION: "Description",
    ORG_BASE_PRICE: "Price",
    ORG_BASE_PRICE_ORE: "Price (minor units)",
    ORG_VAT: "VAT",
    ORG_SALES_ACCOUNT: "Sales account",
    ORG_ACTIVE: "Active",
    ORG_INACTIVE: "Inactive",
    ORG_ASSIGNED_UNITS: "Units",
    ORG_VERSION: "Version",
    ORG_EDIT: "Edit",
    ORG_ASSIGN_UNITS: "Assign units",
    ORG_SHARE_WITH_UNITS: "Share with units",
    ORG_PUBLISH: "Publish",
    ORG_PUBLISH_NOW: "Publish now",
    ORG_PUBLISHED: "Published",
    ORG_UNITS_QUEUED: "units queued",
    ORG_PUBLISH_FAILED: "The publish failed.",
    ORG_PREVIEW_FAILED: "The preview could not be loaded.",
    ORG_ON: "On",
    ORG_PRICE_OVERRIDE: "Local price (minor units)",
    ORG_VALUE_OVERRIDE: "Local value",
    ORG_ORG_PRICE: "Group price",
    ORG_ORG_VALUE: "Group value",
    ORG_CLEAR_OVERRIDE: "Clear the local value",
    ORG_WONT_BE_PUBLISHED: "Not overwritten by a publish",
    ORG_PUBLISHED_LABEL: "Published",
    ORG_OVERRIDE_HELP: "A unit's own price is never overwritten by a publish. Clear it to let the unit follow the group price again.",
    ORG_COUPON_OVERRIDE_HELP: "A unit's own value takes precedence over the group's.",
    ORG_EDIT_NOT_PUBLISHED: "Saving changes the catalog. The units get the change only when you publish.",
    ORG_WILL_UPDATE: "Will be updated",
    ORG_WILL_SKIP: "Will be skipped",
    ORG_PUBLISH_JOURNAL_NOTE: "Every updated unit journals its own price change. Journal entries expected:",
    ORG_PUBLISH_BLOCKED_REGISTER: "The publish is blocked: a register could not be resolved for every unit, and the price change would then go through without a journal entry. Units affected:",
    ORG_PUBLISH_NOTHING: "Nothing to publish — every unit is already up to date.",
    ORG_COUPON: "Offer",
    ORG_NEW_COUPON: "New offer",
    ORG_EDIT_COUPON: "Edit offer",
    ORG_NO_COUPONS: "No offers yet.",
    ORG_CODE: "Code",
    ORG_VALUE: "Value",
    ORG_VALID: "Valid",
    ORG_VALID_FROM: "Valid from",
    ORG_VALID_TO: "Valid to",
    ORG_COUPON_KIND: "Type",
    ORG_COUPON_PERCENTAGE: "Percentage",
    ORG_COUPON_AMOUNT: "Amount",
    ORG_COUPON_FREE_ITEM: "Free item",
    ORG_COUPON_PCT_HELP: "0–100",
    ORG_GRANT_ACCESS: "Grant access",
    ORG_GRANT: "Grant",
    ORG_REVOKE: "Revoke access",
    ORG_REVOKE_CONFIRM: "Revoke organisation access for",
    ORG_ACCESS_GRANTED: "Access granted",
    ORG_ACCESS_REVOKED: "Access revoked",
    ORG_USER: "User",
    ORG_ROLE: "Role",
    ORG_GRANTED: "Granted",
    ORG_EMAIL: "Email",
    ORG_ROLE_ADMIN: "Org admin",
    ORG_ROLE_VIEWER: "Viewer",
    ORG_ROLE_ADMIN_HELP: "sees the group's sales and administers the catalog, the offers and who has access.",
    ORG_ROLE_VIEWER_HELP: "sees the group's sales. Nothing else.",
    ORG_ROLES_EXPLAINED: "What the roles mean",
    ORG_ADMIN_ONLY: "Only an org admin can change this.",
    ORG_NO_ACCESS_ROWS: "Nobody has organisation access yet.",
    ORG_GRANT_EMAIL_HELP: "The user must already exist in PubQ.",
    ORG_GRANT_ADMIN_WARNING: "An org admin sees the whole group's sales and can give others the same access.",

    ORG_STAFF_ACCESS: "PubQ staff",
    ORG_STAFF_ACCESS_HELP: "You are signed in as PubQ staff and can open any organisation.",
    ORG_API_PROBLEM: "API problem",
    ORG_API_NOT_DEPLOYED: "The organisation API is not deployed in this environment.",
    ORG_FORBIDDEN: "You do not have organisation access to this organisation.",
    ORG_NET: "Net",
    ORG_NO_SALES: "No sales",
    ORG_OTHER_TYPES: "Other receipts",
    ORG_OTHER_TYPES_HELP: "Receipts that are not sales (refunds, proforma). Reported separately and never counted in sales.",
    ORG_SOLD_IN_UNITS: "Units",
    ORG_SHOW_ARCHIVED: "Show archived",
    ORG_ARCHIVED_TAG: "Archived",
    ORG_ARCHIVE: "Archive",
    ORG_ARCHIVED: "Archived",
    ORG_ARCHIVE_PUBLISH_NOTE: "Archived in the catalog. Publish to withdraw it from the units.",
    ORG_PRODUCT_TYPE: "Product type",
    ORG_CONTAINS_ALCOHOL: "Contains alcohol",
    ORG_VAT_ACCOUNT_HINT: "Sales account (hint)",
    ORG_VAT_ACCOUNT_HINT_HELP: "Units often keep several accounts for one VAT rate (12 % food and 12 % soft drinks). Without a hint or a per-unit override the publish refuses to guess.",
    ORG_SELLABLE: "Sellable",
    ORG_SELLABLE_HELP: "Off means the item exists in the unit but is not sold. It is never deleted.",
    ORG_STALE: "Out of date",
    ORG_UNITS_IN_SCOPE: "units in scope",
    ORG_UNCHANGED: "unchanged",
    ORG_WOULD_WITHDRAW: "withdrawn",
    ORG_WOULD_FAIL: "would fail",
    ORG_WARNINGS: "warnings",
    ORG_PUBLISH_SOME_FAIL: "Some units would fail. The publish runs for the rest — fix these and publish again.",
    ORG_PUBLISH_QUEUED: "Publish queued",
    ORG_RUN: "Run",
    ORG_RUN_SWEEP: "picked up within 15 min",
    ORG_ENABLED: "Enabled",
    ORG_DISCOUNT: "Discount",
    ORG_DISCOUNT_HELP: "1–100 %. The apps support percent only.",
    ORG_OFFER_KIND_CODE: "Discount code",
    ORG_OFFER_KIND_OFFER: "Offer",
    ORG_CODE_HELP: "A–Z, 0–9, _ and -. 3–50 characters. Unique among the organisation's active codes.",
    ORG_CODE_CONFLICT: "That code is already used by an active offer in the organisation.",
    ORG_KIND_LOCKED: "The type cannot be changed afterwards.",
    ORG_LIVE_UNITS: "Live",
    ORG_LIVE_NOW: "Live now",
    ORG_WITHDRAWN: "Withdrawn",
    ORG_VALIDITY_ENFORCED: "The validity window drives the publish: outside it the code is removed in every unit, and put back within about 15 minutes when it starts.",
    ORG_OFFER_CONFLICT_NOTE: "A unit that already has its own code with the same text does not get the organisation's code. The unit's own code is never changed.",
    ORG_UNIT_FLAG_NOTE: "Warnings: apps show codes only where the unit has coupon codes enabled, and offers only where global offers are enabled. The publish does not change unit settings.",
    ORG_STAFF_ONLY: "Only PubQ staff can change this.",
    ORG_STAFF_ONLY_NOTE: "You can see who has access. Granting and revoking is done by PubQ staff — an org admin cannot promote others.",
    ORG_ROLE_STAFF: "PubQ staff",
    ORG_ROLE_STAFF_HELP: "sees everything, and is the only one who can grant or revoke organisation access.",
    ORG_ACCESS_ALREADY: "Access already held",
    ORG_USER_NOT_FOUND: "There is no PubQ account with that email. A grant never creates an account.",
    ORG_AUDIT: "History",
    ORG_NO_AUDIT: "No history.",
    ORG_REASON: "Reason",
    ORG_REASON_HELP: "Recorded in the history.",
    ORG_WHEN: "When",
    ORG_ACTION: "Action",
    ORG_BY: "By",

    ORG_MANAGED_TAG: "Organisation",
    ORG_MANAGED_HELP: "Managed by the organisation. It was placed here by an organisation publish, not created in this unit.",
    ORG_MANAGED_EDIT_WARNING: "You can change this item, but the next publish from the organisation overwrites the fields the organisation owns. If the unit needs its own price permanently, ask the organisation to set a per-unit override.",

    ORG_EXTERNAL_ID: "External ID",
    ORG_EXTERNAL_ID_HELP: "The item's ID in another system, e.g. Compass Group's TCPOS article number. Published to every unit and is the field the TCPOS export reads. Clear the box to remove it.",
    ORG_EXTERNAL_ID_KEY: "System",
    ORG_EXTERNAL_ID_OVERRIDE: "Unit's external ID",
    ORG_WRITTEN: "written",
    ORG_FAILED: "failed",
    ORG_RETRY: "Retry",
    ORG_PUBLISH_DONE: "Publish complete",
    ORG_PUBLISH_PARTIAL: "Publish finished with failures",
    ORG_RUN_STILL_GOING: "The run is still going. It continues in the background — reload later to see the result.",

    ORG_IMAGE: "Image",
    ORG_IMAGE_CHOOSE: "Choose image",
    ORG_IMAGE_REPLACE: "Replace image",
    ORG_IMAGE_CLEAR: "Remove",
    ORG_IMAGE_HELP: "Uploaded as the organisation's own image (org/{id}/products/) and published to every unit along with the item.",

    ORG_IMAGE_NOT_AN_IMAGE: "That file is not an image.",
    ORG_IMAGE_UPLOAD_FAILED: "The image could not be uploaded.",
    ORG_IMAGE_DENIED: "Storage rules refused the write to the organisation path. Ask PubQ to add the rule for:",

    // --- Send an invoice to Fortnox (a draft; never booked from PubQ) ------
    FZ_INV_COLUMN: "Fortnox",
    FZ_INV_SEND: "Send to Fortnox",
    FZ_INV_RETRY: "Retry",
    FZ_INV_RESEND: "Send again",
    FZ_INV_SENDING: "Sending…",
    FZ_INV_FAILED: "Failed",
    FZ_INV_UNCERTAIN: "Uncertain",
    FZ_INV_NOT_SENT: "Not sent",
    FZ_INV_NOT_SENT_YET: "This invoice has not been sent to Fortnox.",
    FZ_INV_DOC: "Fortnox invoice",
    FZ_INV_DRAFT_NOTE: "created as an unbooked draft. Book and send it in Fortnox.",
    FZ_INV_SENT_TITLE: "Sent to Fortnox",
    FZ_INV_ALREADY_TITLE: "Already in Fortnox",
    FZ_INV_FAILED_TITLE: "Fortnox refused the invoice",
    FZ_INV_NOT_READY: "This invoice cannot be sent to Fortnox yet.",
    FZ_INV_CONFIRM: "This creates a new unbooked invoice in Fortnox. PubQ does not book it or send it to the customer.",
    FZ_INV_CONFIRM_DRIFT: "Fortnox will total this invoice a little differently — check it there.",
    FZ_INV_LINK_CUSTOMER_FIRST: "Link this customer to Fortnox first",
    FZ_INV_GO_LINK_CUSTOMER: "Go to corporate customers",
    FZ_INV_RECONNECT: "Reconnect Fortnox to enable invoicing",
    FZ_INV_RECONNECT_CTA: "Reconnect Fortnox",
    FZ_INV_DISABLED: "Fortnox invoicing is not enabled on this environment",
    FZ_INV_NOT_CONNECTED: "This restaurant is not connected to Fortnox",
    FZ_INV_IN_PROGRESS: "This invoice is being sent right now",
    FZ_INV_UNCERTAIN_HELP: "An earlier send may already have created this invoice in Fortnox. Check Fortnox before sending it again.",
    FZ_INV_RESEND_TITLE: "Send this invoice again?",
    FZ_INV_RESEND_CONFIRM_LABEL: "Type the confirmation to send it again:",
    FZ_INV_RECONCILE: "Total in PubQ / in Fortnox",

    // --- Customer import from Fortnox (the accounting system as a source) ---
    FZ_CUST_SEARCH_LABEL: "Search for a customer in Fortnox",
    FZ_CUST_SEARCH_PLACEHOLDER: "Name, customer number or organisation number",
    FZ_CUST_SEARCH_HINT: "Type at least two characters. Searches the customers of the connected Fortnox company.",
    FZ_CUST_INCLUDE_INACTIVE: "Include inactive",
    FZ_CUST_INACTIVE: "inactive",
    FZ_CUST_NO_RESULTS: "No customer in Fortnox matches that search.",
    FZ_CUST_OR_MANUAL: "or fill in the details yourself",
    FZ_CUST_PREFILLED_FROM: "Prefilled from Fortnox:",
    FZ_CUST_DISCARD_PICK: "Remove",
    FZ_CUST_REVIEW_HELP: "Review and adjust the details before saving. Nothing is written to Fortnox — PubQ only reads the customer register.",
    FZ_CUST_REVIEW_TERMS: "The payment terms in Fortnox are not a number of days. 30 days has been filled in — check it.",
    FZ_CUST_REVIEW_EMAIL: "This customer has no email address in Fortnox. Enter the invoice recipient yourself.",
    FZ_CUST_REVIEW_ORGNO: "This customer has no organisation number in Fortnox. Enter it yourself.",
    FZ_CUST_WILL_CREATE: "Will be saved as a new corporate customer.",
    FZ_CUST_WILL_LINK: "That organisation number is already a corporate customer. It will be linked to the Fortnox customer; your own details are left untouched.",
    FZ_CUST_ALREADY_TITLE: "Already imported",
    FZ_CUST_ALREADY_HELP: "This Fortnox customer has already been imported. Open the existing customer, or use Refresh from Fortnox on it.",
    FZ_CUST_OPEN_EXISTING: "Open the existing customer",
    FZ_CUST_CONFLICT_TITLE: "Several possible matches",
    FZ_CUST_CONFLICT_HELP: "There is a corporate customer that may be the same company, but the match is too weak to link automatically. Choose to link to one of them, or to create a new customer.",
    FZ_CUST_MATCHED_ON: "Matches on",
    FZ_CUST_LINK_THIS: "Link to this one",
    FZ_CUST_CREATE_ANYWAY: "Create a new customer anyway",
    FZ_CUST_CHOOSE_FIRST: "Choose link or create new before saving.",
    FZ_CUST_IMPORTED: "The corporate customer was imported from Fortnox.",
    FZ_CUST_LINKED: "The corporate customer was linked to the Fortnox customer.",
    FZ_CUST_SOURCE_TAG: "Fortnox",
    FZ_CUST_REFRESH: "Refresh from Fortnox",
    FZ_CUST_REFRESH_NO_CHANGE: "Everything was already in step with Fortnox.",
    FZ_CUST_RECONNECT_TITLE: "Customer import is not enabled",
    FZ_CUST_RECONNECT_CTA: "Reconnect Fortnox to enable customer import",
    FZ_CUST_CONSENT_NOTE: "Connecting also lets PubQ read your Fortnox customer register, so you can import customers. PubQ never changes it.",

    // Catering: partner-group companies, invoice PDF switch, delivery-time generator
    CC_GROUP_BANNER_TITLE: "Shared by all restaurants in group",
    CC_GROUP_BANNER_DESC: "These companies belong to the partner group, not to this restaurant. Changes apply to every restaurant in the group.",
    CC_GROUP_MISCONFIGURED_TITLE: "The partner group for this restaurant is not set up correctly",
    CC_GROUP_NOT_MEMBER: "The group exists but does not list this restaurant.",
    CC_GROUP_NOT_FOUND: "No partner group with this ID was found.",
    CC_GROUP_FIX_IN_SETTINGS: "Fix or clear the partner group under Catering > Settings > Delivery. Companies cannot be edited until then.",
    CC_EMAIL_DOMAINS: "Email domains",
    CC_EMAIL_DOMAINS_NONE: "No domains (only manually linked users)",
    CC_EMAIL_DOMAINS_HELP: "Signed-in users whose verified email ends in one of these domains can order on invoice for this company. Write the domain without \"@\", e.g. soupster.fi.",
    CC_EMAIL_DOMAINS_EMPTY_HINT: "No domains yet: only users you link manually (Users) will get this company.",
    CC_EMAIL_DOMAIN_INVALID: "Not a valid domain. Example: soupster.fi",
    CC_EMAIL_DOMAIN_PUBLIC: "Public email providers (gmail.com, outlook.com, ...) cannot be used: anyone could sign up with them.",
    CC_EMAIL_DOMAIN_DUPLICATE: "This domain is already on the list.",
    CC_EMAIL_DOMAIN_SHARED: "Also used by:",
    CC_COST_CENTERS: "Cost centres",
    CC_COST_CENTERS_HELP: "Optional. If you add cost centres, users pick one when ordering; without any they can type it freely.",
    CC_COST_CENTER_PLACEHOLDER: "e.g. 4010 Marketing",
    CATERING_INVOICE_PDF: "Invoice PDF",
    CATERING_INVOICE_PDF_ON_DESC: "On: an invoice PDF is created and emailed when an invoice order is placed.",
    CATERING_INVOICE_PDF_OFF_DESC: "No invoice PDF — the restaurant invoices from its POS; the approval email is the order confirmation.",
    CATERING_PARTNER_GROUP: "Partner group",
    CATERING_PARTNER_GROUP_DESC: "If this restaurant belongs to a partner group, enter the group ID. Corporate customers are then shared by all restaurants in the group.",
    CATERING_PARTNER_GROUP_PLACEHOLDER: "Group ID, e.g. soupster",
    CATERING_PARTNER_GROUP_CHECK: "Check",
    CATERING_PARTNER_GROUP_OK: "Found group:",
    CATERING_PARTNER_GROUP_NOT_MEMBER: "This restaurant is not listed in the group:",
    CATERING_PARTNER_GROUP_NOT_FOUND: "No partner group with this ID was found.",
    CATERING_PARTNER_GROUP_INVALID_SLUG: "The group ID may only contain letters, digits, \"-\" and \"_\".",
    CATERING_PARTNER_GROUP_UNCHECKED: "Press Check to verify the group before saving.",
    CATERING_PARTNER_GROUP_NONE: "No partner group: corporate customers belong to this restaurant only.",
    CATERING_PARTNER_GROUP_NOT_SAVED: "The partner group was not saved: it does not exist or does not list this restaurant.",
    CATERING_DELIVERY_DEFAULT_TIME_ADDED: "A default delivery time (10:00) was added. Change it, add more, or generate the day's times below.",
    CATERING_GENERATE_TIMES: "Generate times",
    CATERING_GENERATE_TIMES_FROM: "From",
    CATERING_GENERATE_TIMES_TO: "To",
    CATERING_GENERATE_TIMES_STEP: "Every",
    CATERING_GENERATE_TIMES_APPLY: "Generate",
    CATERING_SORT_TIMES: "Sort",
    CATERING_GENERATE_TIMES_HELP: "Replaces this day's delivery times with every interval from the start to the end time (inclusive). Nothing is saved until you press Save.",
    CATERING_GENERATE_TIMES_ERR_INVALID: "Enter both times as HH:MM.",
    CATERING_GENERATE_TIMES_ERR_ORDER: "The end time must not be before the start time.",
    CATERING_GENERATE_TIMES_ERR_STEP: "Choose an interval.",
    CATERING_GENERATE_TIMES_ERR_TOO_MANY: "Too many times for one day. Use a longer interval.",
}
